<template>
    <div>
         <!--filter bar -->
        <div-filter v-if="config.name!='shippingsHistories' && config.name!='sourcingsHistories' && config.name!='refundsHistories' && config.name!='stockHistories' && config.name!='statusHistories' && config.name!='paymentsHistories'" :productsarray="products" :idWharhouse="idWharhouse" :name="config.name" :config="config" :filters="filters" :currentUser="currentUser"  @reset="reset"  :loading="loading" @filtrer="filtrer" @search="search"></div-filter>
        <!-- end filter bar -->
        <div :class="config.class">
           <div class="bg-white w-full rounded-lg shadow" >
                <div v-if="config.name=='expeditions' || config.name=='products'">
                    <div @click="openAnalytics = !openAnalytics" class="py-4 cursor-pointer bg-grey-lighter hover:bg-grey-light text-indigo-darker rounded rounded-t-none text-center uppercase font-bold flex items-center justify-center text-green-600"><span class="block border border-gray-400 w-1/3 mr-2"></span>
                    <button class="border border-teal-500 text-teal-500 block rounded-sm font-bold py-4 px-6 mr-2 flex items-center hover:bg-teal-500 hover:text-white">
                        Show analytics   <i class="material-icons text-green-600 ml-3">timeline</i></button><span class="block border border-gray-400 w-1/3 ml-2"></span></div>
                    <chart-expeditions v-if="openAnalytics && config.name=='expeditions'"  :currentUser="currentUser" :sellers="sellers" :warehouse="idWharhouse._id"/>
                    <chart-products v-if="openAnalytics && config.name=='products'"  :currentUser="currentUser" :sellers="sellers" :warehouse="idWharhouse._id"/>
                </div>


                <div class="py-4 px-4 md:px-6 flex flex-col xl:flex-row xl:items-center justify-between gap-4 border-b border-gray-100">
                    <div class="flex flex-wrap items-center gap-4">
                         <!-- Title with Icon -->
                        <div class="flex items-center">
                            <i v-if="config.icone" class="material-icons p-3 text-blue-400">{{ config.icone }}</i>
                            <span class="text-xl md:text-2xl font-bold text-blue-600">{{ config.title }}</span>
                        </div>

                        <!-- <span v-if="config.name=='statusHistories' && emailCurrentCall" class="mx-4 text-2xl semi-bold text-black-500">({{ emailCurrentCall }})</span> -->
                         <div v-if="currentUser.type!='CallenterManager' && (config.name=='shippings' || config.name=='orders')" class="ml-0 sm:ml-4">
                            <button @click="openLimit = !openLimit" class="vs-con-dropdown parent-dropdown cursor-pointer">
                            <div class="p-2 shadow rounded-lg  cursor-pointer flex items-end justify-center text-sm font-medium ml-2">
                                <span class="mr-2">{{paginate.currentpage}} - {{data.length}} / {{paginate.total}} </span>
                                <span class="feather-icon select-none relative"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down h-4 w-4"><polyline points="6 9 12 15 18 9"></polyline></svg></span></div>
                            </button>
                            <div class="relative">
                                <div v-if="openLimit"  class="absolute focus:ring-2 focus:ring-blue-600 right-0 dropdown-action-limit w-auto mt-3 z-10 origin-top-right rounded-md shadow-lg">
                                    <div class="bg-white dropdown-limit rounded-md shadow dark-mode:bg-gray-800">
                                        <a @click="Changelimit(10)" class="block cursor-pointer px-2 text-center py-1 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline">10</a>  
                                        <a @click="Changelimit(50)" class="block cursor-pointer px-2 text-center py-1 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline">50</a>
                                        <a @click="Changelimit(100)" class="block cursor-pointer px-2 text-center py-1 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline">100</a>  
                                        <a @click="Changelimit(500)" class="block cursor-pointer px-2 text-center py-1 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline">500</a>  
                                        <a @click="Changelimit(1000)" class="block cursor-pointer px-2 text-center py-1 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline">1000</a>  
                                    </div>
                                    <div class="vs-dropdown--limit--after"></div>
                                </div>
                            </div>
                       </div>  
                    </div>
                
                    <div  class="flex flex-wrap items-center justify-start md:justify-end gap-2">
                       <div v-if="config.options.actions.isActive && !config.options.actions.method && getAccess('create',null,null,null,true)" class="flex flex-col sm:flex-row gap-2">
                           <router-link v-for="(item, index) in config.options.actions.buttons" :key="index" :to="item.link" class="inline-flex items-center rounded whitespace-nowrap text-white px-4 py-2 bg-blue-600 hover:bg-blue-700 transition-all shadow-sm"><i class="material-icons mr-2">{{ item.icon }}</i> {{ item.text }}</router-link>
                       </div>
                      
                       <div v-if="config.name=='products' && getAccess('create',null,null,null,true)" class="flex flex-col sm:flex-row gap-2">
                           <router-link to="/products/new" class="inline-flex items-center rounded whitespace-nowrap text-white px-4 py-2 bg-blue-600 hover:bg-blue-700 transition-all shadow-sm"><i class="material-icons mr-2">add</i> New Product</router-link>
                           <button v-if="['Admin','Administrateur'].includes(currentUser.type)" @click="ProductsNotUsed()" class="rounded flex focus:outline-none outline-none text-gray-800 px-3 w-1/7 py-2 bg-red-300 hover:shadow-inner hover:bg-red-700 transition-all duration-300"><img src="https://img.icons8.com/ios-filled/100/do-not-tilt.png" class="material-icons mr-1" style="height: 24px;"> Products maintenance</button>
                       </div>
                       <div v-if="['Admin','StockManager','Administrateur','Seller','AccountManager'].includes(currentUser.type) && ['orders','payments','shippings','stockHistories','expeditions'].includes(config.name)"  class="flex flex-col sm:flex-row gap-2">
                            <router-link v-if="config.name=='payments' && (currentUser.type =='Admin' || currentUser.type =='Administrateur')" to="/payments/new" class="rounded cursor-pointer inline-block mr-3 focus:outline-none outline-none text-gray-100 px-3  py-2 bg-blue-500 hover:shadow-inner hover:bg-red-700 transition-all duration-300"><i class="material-icons align-bottom mr-2">add</i> New Payement</router-link>
                            <button @click="downloadCsv" class="btnn bg-blue-500 text-gray-100 cursor-pointer  hover:bg-blue-700 box flex items-center dark:text-gray-300 loidingconfirm relative" :class="loading?'noselect':''"><svg  xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-file-text hidden sm:block w-4 h-4 mr-2 hidden sm:block w-4 h-4 mr-2"><path  d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline  points="14 2 14 8 20 8"></polyline><line  x1="16" y1="13" x2="8" y2="13"></line><line  x1="16" y1="17" x2="8" y2="17"></line><polyline  points="10 9 9 9 8 9"></polyline></svg> Export to Excel  <loading :active.sync="loading" :is-full-page="fullPage"></loading></button>
                      </div>
                       <div v-if="config.name=='shippings' && (currentUser.type =='Admin' || currentUser.type =='Administrateur' || currentUser.type =='StockManager')" @click="OpenPopupNewShipp('newShipp','open')" class="ml-2 cursor-pointer flex rounded focus:outline-none outline-none text-gray-100 px-3 w-1/7 py-2 bg-blue-500 hover:shadow-inner hover:bg-blue-700 transition-all duration-300">
                           <i class="material-icons mr-1">add_circle_outline </i> New shippings
                      </div>
                      <div v-if="config.name=='shippings' && (currentUser.type =='Admin' || currentUser.type =='Administrateur' || currentUser.type =='StockManager')" @click="OpenPopupNewShipp('Echange','open','Echange')" class="ml-2 cursor-pointer flex rounded focus:outline-none outline-none text-gray-100 px-3 w-1/7 py-2 bg-blue-500 hover:shadow-inner hover:bg-blue-700 transition-all duration-300">
                           <i class="material-icons mr-1">sync </i> Echange
                      </div>
                      <div v-if="config.name=='orders' && (currentUser.type =='Admin' || currentUser.type =='Administrateur')" @click="EmitMethodAction('MarkUnreached')" class="ml-2 cursor-pointer flex rounded focus:outline-none outline-none text-gray-100 px-3 w-1/7 py-2 bg-blue-500 hover:shadow-inner hover:bg-blue-700 transition-all duration-300">
                           <i class="material-icons mr-1">sync </i> Nbr d'appels → Unreached
                      </div>
                      <!-- Bulk Reset -->
                      <div v-if="config.name=='orders' && (currentUser.type =='Admin' || currentUser.type =='Administrateur')" 
                            @click="openBulkUnreachedModal" 
                            class="inline-flex cursor-pointer items-center rounded whitespace-nowrap text-white px-4 py-2 bg-purple-600 hover:bg-purple-700 transition-all shadow-sm">
                            <i class="material-icons mr-1">history</i> Bulk Reset → Unreached
                      </div>
                       <div v-if="config.name=='orders' && (currentUser.type=='Admin' || currentUser.type =='Administrateur')">
                        <button @click="open = !open" class="vs-con-dropdown parent-dropdown cursor-pointer">
                         <div class="p-3 shadow rounded-lg  cursor-pointer flex items-end justify-center text-lg font-medium"><span class="feather-icon select-none relative"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-vertical h-4 w-4"><circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle></svg></span></div>
                        </button>
                         <div v-if="open" x-transition:enter="transition ease-out duration-100" x-transition:enter-start="transform opacity-0 scale-95" x-transition:enter-end="transform opacity-100 scale-100" x-transition:leave="transition ease-in duration-75" x-transition:leave-start="transform opacity-100 scale-100" x-transition:leave-end="transform opacity-0 scale-95" class="absolute focus:ring-2 focus:ring-blue-600 right-0 dropdown-action  w-full mt-5 z-10 origin-top-right rounded-md shadow-lg">
                            <div class="bg-white rounded-md shadow dark-mode:bg-gray-800">
                               <a v-show="getAccessLinks('deleteOrders')" @click="EmitMethodAction('deleteOrders')" class="block cursor-pointer px-4 py-2 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"><i class="material-icons mr-2" style="font-size: 17px;">delete</i> Delete</a>   
                            </div>
                         </div>
                      </div>
                      <div v-if="config.options.actions.isActive && config.options.actions.method && (config.name=='shippings' || (['payments','products'].includes(config.name) && getAccess('update',null,null,null,true))) && getAccessLinks(null)">
                        <button @click="open = !open" class="vs-con-dropdown parent-dropdown cursor-pointer">
                         <div class="p-3 shadow rounded-lg  cursor-pointer flex items-end justify-center text-lg font-medium"><span class="feather-icon select-none relative"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-vertical h-4 w-4"><circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle></svg></span></div>
                        </button>
                         <div v-if="open" x-transition:enter="transition ease-out duration-100" x-transition:enter-start="transform opacity-0 scale-95" x-transition:enter-end="transform opacity-100 scale-100" x-transition:leave="transition ease-in duration-75" x-transition:leave-start="transform opacity-100 scale-100" x-transition:leave-end="transform opacity-0 scale-95" class="absolute focus:ring-2 focus:ring-blue-600 right-0 dropdown-action  w-full mt-5 z-10 origin-top-right rounded-md shadow-lg">
                            <div class="bg-white rounded-md shadow dark-mode:bg-gray-800">
                                 <a v-for="(item, index) in config.options.actions.buttons" :key="index" v-show="getAccessLinks(item.action)" @click="EmitMethodAction(item.action)" class="block cursor-pointer px-4 py-2 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"><i class="material-icons mr-2">{{ item.icon }}</i> {{ item.text }}</a>   
                            </div>
                         </div>
                       </div>  
                    </div>
                    <div v-if="config.options.actions.isActive && config.options.actions.method && config.name=='statusHistories'" class="w-1/2 flex justify-end space-x-4">
                       <button @click="downloadAnalytics" v-for="(item, index) in config.options.actions.buttons" :key="index"  class="inline-flex items-center rounded whitespace-nowrap text-white px-4 py-2 bg-blue-600 hover:bg-blue-700 transition-all shadow-sm"><i class="material-icons mr-2">{{ item.icon }}</i> {{ item.text }}</button>
                    </div>
                </div>


                <!-- Sourcing Company Dashboard Stats -->
                <div v-if="config.name=='sourcings' && currentUser.type=='Sourcing'" 
                    class="mx-3 mb-4">
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                            
                            <!-- Pending Card -->
                            <div class="bg-white rounded-xl shadow-sm border border-gray-500 p-4 hover:shadow-md transition-shadow">
                            <div class="flex items-center justify-between">
                                <div>
                                <p class="text-sm font-medium text-gray-500">Pending Quotes</p>
                                <p class="text-3xl font-bold text-orange-500">{{ pendingSourcingsCount }}</p>
                                </div>
                                <div class="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
                                <i class="material-icons text-orange-500">hourglass_empty</i>
                                </div>
                            </div>
                            <div v-if="pendingSourcingsCount > 0" class="mt-2">
                                <span class="text-xs text-orange-600 bg-orange-100 px-2 py-1 rounded-full">
                                <i class="material-icons text-xs align-middle">priority_high</i> Action required
                                </span>
                            </div>
                            </div>
                            
                            <!-- Quoted Card -->
                            <div class="bg-white rounded-xl shadow-sm border border-gray-500 p-4 hover:shadow-md transition-shadow">
                            <div class="flex items-center justify-between">
                                <div>
                                <p class="text-sm font-medium text-gray-500">My Quotes</p>
                                <p class="text-3xl font-bold text-blue-500">{{ myQuotesCount || 0 }}</p>
                                </div>
                                <div class="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                                <i class="material-icons text-blue-500">description</i>
                                </div>
                            </div>
                            </div>
                            
                            <!-- Accepted Card -->
                            <div class="bg-white rounded-xl shadow-sm border border-gray-500 p-4 hover:shadow-md transition-shadow">
                            <div class="flex items-center justify-between">
                                <div>
                                <p class="text-sm font-medium text-gray-500">Accepted</p>
                                <p class="text-3xl font-bold text-green-500">{{ acceptedCount || 0 }}</p>
                                </div>
                                <div class="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                                <i class="material-icons text-green-500">check_circle</i>
                                </div>
                            </div>
                            </div>
                        </div>
                </div>

                
                <div v-if="isFilterPaidOrCourier && config.name=='shippings' && currentUser.type !== 'StockManager'"  class="flex justify-center border-gray-200">
                   <div class="w-5/12 bg-blue-100 border-t-4 border-blue-600 rounded-b text-teal-darkest px-4 py-3 shadow-md my-2" role="alert">
                        <div class="flex">
                            <i class="large material-icons mr-5">account_balance_wallet</i>   
                            <div>
                            <p v-if="CourierInfo.courier" class="font-bold">Courier: <span>{{CourierInfo.courier}}</span></p>
                            <p class="font-bold">Total orders: <span>{{CourierInfo.count}}</span></p>
                            <p v-if="CourierInfo.countpending!=0" class="font-bold">Total orders (Pending processed): <span>{{CourierInfo.countpending}}</span></p>
                            <p class="font-bold">Total: <sup v-if="idWharhouse">{{idWharhouse.currency}}</sup> {{CourierInfo.total}} </p>
                            </div>  
                        </div>
                    </div>
                </div>
                 <div v-if="(config.name=='expeditions' || config.name=='refunds' || config.name=='sourcings') && ProcessingInfo.count"  class="flex justify-center border-gray-200">
                   <div class="w-5/12 bg-blue-100 border-t-4 border-blue-600 rounded-b text-teal-darkest px-4 py-3 shadow-md my-2" role="alert">
                        <div class="flex">
                            <i class="large material-icons mr-5">account_balance_wallet</i>   
                            <div>
                                <p class="font-bold">Total {{ config.name}} (Pending processed): <span>{{ProcessingInfo.count}}</span></p>
                                <p class="font-bold">Total: <sup v-if="idWharhouse">{{idWharhouse.currency}}</sup> {{ProcessingInfo.total}} </p>
                            </div>  
                        </div>
                    </div>
                </div>
                <div v-if="config.name=='payments'" class="flex justify-center border-gray-200">
                    <div :class="tabId.length>0?'bg-yellow-100':'bg-blue-100'" class="w-5/12 relative  border-t-4 border-blue-600 rounded-b text-teal-darkest px-4 py-3 shadow-md my-2" role="alert">
                        <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                        <div class="flex">
                            <i class="large material-icons mr-5">account_balance_wallet</i> 
                            <div>
                            <p class="font-bold">Total orders: <span>{{ tabId.length>0?tabId.reduce((a,curr) => a + curr.count, 0):data.reduce((a,curr) => a + curr.count, 0) }}</span></p>
                              <p class="font-bold">Amount total: <sup v-if="idWharhouse">{{idWharhouse.currency}}</sup> {{tabId.length>0?tabId.reduce((a,curr) => a + parseFloat(curr.amount), 0).toFixed(2):data.reduce((a,curr) => a + parseFloat(curr.amount), 0).toFixed(2)}} </p> 
                            </div>  
                        </div>
                    </div>
                </div>
              <div style="overflow-x:auto;">  
                <table id="loading" class="min-w-full w-full"> 
                    <thead class="relative ant-table-thead">
                        <tr class="bg-gray-400 text-gray-600 uppercase text-sm leading-normal">
                            <th v-for="(item, key) in config.columns" :key="key" :class="[item.class]" class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                                <label v-if="item.type && config.name!='products' && currentUser.type !='Seller'" class="text-lg text-teal-500 inline-flex justify-between items-center hover:bg-gray-200 px-2 py-2 rounded-lg cursor-pointer">
                                    <input type="checkbox" @click="selectAllCheckbox($event);" class="form-checkbox checkallbbox focus:outline-none focus:shadow-outline" >
                                </label>
                                <span v-else>
                                      {{ item.name }}
                                </span>     
                            </th>
                            <th v-if="config.actions && config.actions.elements && config.actions.elements.length != 0 " style="position: sticky; right: 0px;" class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider ant-table-cell-fix-right-first ant-table-cell-fix-right">{{ config.actions.name }}</th>
                        </tr>
                    </thead>
                   
                    <tbody>
                        <!-- <loading :active.sync="loading" :is-full-page="fullPage"></loading> -->
                        <template v-for="(item, index) in data">
                            <tr :class="[{'bg-gray-100': index%2 !=0 },{'bg-red-300': (config.name=='payments' && Math.sign(item.amount)==-1) }]" class="border-b border-gray-200 hover:bg-gray-100">
                                <td v-for="(col, ind) in config.columns" :key="ind"  class="px-5 py-2 whitespace-no-wrap border-b border-gray-200">
                                <div class="text-xs leading-5 capitalize rounded-full text-gray-900">
                                    <div v-for="(element,indElm) in col.elements" :key="indElm" >
                                        <div v-for="(itemst,itemIndex) in element.items" :key="itemIndex">
                                            <div v-if="!itemst.elements"> <!-- Status -->
                                                <div v-if="itemst.name=='status' || itemst.name=='previousStatus'" class="text-center">
                                                        <div v-if="!itemst.data"> <!-- status expedition -->
                                                        <div v-if="config.name!='shippingsHistories' && config.name!='refundsHistories'"> 
                                                            <button @click="ShowPopUpInformation(index,data[index][itemst.name],item)" :class="itemst.class" :style="itemst.options(data[index][itemst.name])">{{ data[index][itemst.name] }}</button> 
                                                            <span class="jvectormap-tip label-blue text-white" v-if="config.name=='shippings' && currentUser.type !='Seller' && data[index].reprogrammedCount"> {{ `Reprogrammé : ${data[index].reprogrammedCount||0} fois` }}</span>
                                                            <span class="jvectormap-tip bg-red-500 text-white" v-if="config.name=='shippings' && data[index].status === 'cancelled' && data[index].comment"> {{  data[index].comment }}</span>
                                                            <span class="jvectormap-tip label-accept text-white" v-if="((config.name=='shippings' || config.name=='expeditions' || config.name=='refunds' || config.name=='sourcings') && (data[index].status=='paid' || data[index].status=='received' || data[index].status=='effectue') && data[index].isProcessed)">Generated <span v-if="data[index].generateAt">{{'('+$moment(data[index].generateAt).format('yyyy-MM-DD')+')'}}</span></span>
                                                        </div>
                                                        <div v-else> 
                                                            <button :class="itemst.class" :style="itemst.options(data[index][itemst.name])">{{ data[index][itemst.name] }}</button> 
                                                            <span v-if="config.name=='shippingsHistories' && data[index].type && data[index].type=='echange'" class="jvectormap-tip text-white label-accept"> Echange </span>
                                                        </div>
                                                        </div>
                                                        <div v-else> <!-- status orders -->
                                                            <button :disabled="statusToUpdate(item)?false:true"  @click="ShowPopUpInformation(index,null,item)"  :class="itemst.class" v-bind:style="{color: data[index][itemst.name][itemst.champs.color],borderColor: data[index][itemst.name][itemst.champs.color]}">{{ data[index][itemst.name][itemst.champs.name] }}</button> 
                                                            <span :class="data[index].processedAt?'label-sucess':'label-accept'" class="jvectormap-tip text-white" v-if="(config.name=='orders' && data[index].isProcessed)">
                                                                <span v-if="data[index].processedAt"> Processed <span v-if="data[index].processedAt">{{'('+$moment(data[index].processedAt).format('yyyy-MM-DD')+')'}}</span></span>
                                                                <span v-else>
                                                                    Generated <span v-if="data[index].generateAt">{{'('+$moment(data[index].generateAt).format('yyyy-MM-DD')+')'}}</span>
                                                                </span>
                                                                
                                                            </span>
                                                            <div v-if="config.name==='orders' && data[index][itemst.name] && data[index][itemst.name][itemst.champs.name]">
                                                                <span v-if="data[index]['unreachedBySize']" class="flex items-center justify-center sous-s">
                                                                    <svg class="fill-current mr-2 inline" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><path d="M18.48 22.926l-1.193.658c-6.979 3.621-19.082-17.494-12.279-21.484l1.145-.637 3.714 6.467-1.139.632c-2.067 1.245 2.76 9.707 4.879 8.545l1.162-.642 3.711 6.461zm-9.808-22.926l-1.68.975 3.714 6.466 1.681-.975-3.715-6.466zm8.613 14.997l-1.68.975 3.714 6.467 1.681-.975-3.715-6.467z"/></svg> <span>Unreached ({{data[index]['unreachedBySize']}}) ({{$moment(data[index]['lastUnreachedDate']||data[index]['updatedAt']).format('yyyy-MM-DD HH:mm') }})</span>
                                                                </span>
                                                                <span v-if="data[index]['remind'] && (data[index][itemst.name][itemst.champs.name]==='Pending' || data[index][itemst.name][itemst.champs.name]==='Unreached')" class="flex items-center justify-center sous-s">
                                                                   <svg class="fill-current mr-1 inline" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><path d="M24 12c0 6.627-5.373 12-12 12s-12-5.373-12-12h2c0 5.514 4.486 10 10 10s10-4.486 10-10-4.486-10-10-10c-2.777 0-5.287 1.141-7.099 2.977l2.061 2.061-6.962 1.354 1.305-7.013 2.179 2.18c2.172-2.196 5.182-3.559 8.516-3.559 6.627 0 12 5.373 12 12zm-13-6v8h7v-2h-5v-6h-2z"/></svg> <span>A rapeller (To: {{$moment(data[index]['remind']).format('yyyy-MM-DD HH:mm') }})</span>
                                                                </span>
                                                            </div>
                                                            
                                                            <span v-if="config.name==='orders' && data[index].countDouble" class="flex items-center justify-center sous-s">
                                                                <svg class="fill-current mr-2 inline" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><path d="M18 6v-6h-18v18h6v6h18v-18h-6zm-12 10h-4v-14h14v4h-10v10zm16 6h-14v-14h14v14zm-6.793-4v-.757c1.529-1.381 2.425-2.116 2.436-2.896 0-.436-.255-.782-.872-.782-.46 0-.864.23-1.144.437l-.354-.889c.396-.304 1.029-.551 1.745-.551 1.218 0 1.875.708 1.875 1.67 0 1.145-1.043 1.996-1.917 2.724v.016h2.024v1.028h-3.793zm-4.097-3.544h1.11l.624.925.617-.925h1.075l-1.164 1.659 1.31 1.885h-1.11l-.741-1.118-.74 1.118h-1.091l1.275-1.865-1.165-1.679z"/></svg> <span>Double ({{data[index].countDouble}})</span>
                                                            </span> 
                                                        </div>    
                                                </div>
                                                <div v-else-if="itemst.name=='type' && config.name!='stockHistories'">
                                                    <span :style="itemst.options(data[index][itemst.name])">{{ data[index][itemst.name] }}</span> 
                                                </div>    
                                                <div v-else :class="itemst.class"> 
                                                        <div v-if="itemst.array"><!--zones(number of cities type array)-->
                                                            {{ data[index][itemst.name].length }}
                                                        </div>
                                                        <div v-else-if="itemst.date"><!--filed type date-->
                                                            {{  formattedDate(data[index][itemst.name]) }}
                                                        </div>
                                                        <div v-else-if="itemst.history">
                                                            <span :class="data[index]['status']=='in'? 'text-green-600':'text-red-600'"><span v-if="data[index]['status']=='in'"> <i class="material-icons">arrow_drop_up</i></span><span v-else> <i class="material-icons">arrow_drop_down</i></span> {{ data[index][itemst.name] }}</span>
                                                        </div> 
                                                        <div v-else-if="itemst.type=='checkbox' && currentUser.type !='Seller'">
                                                        <label  class="text-lg text-teal-500 inline-flex justify-between items-center hover:bg-gray-200 px-2 py-2 rounded-lg cursor-pointer">
                                                            <input type="checkbox" :class="'rowCheckboxProduct-'+item._id" :date="item.date?item.date:''" :status="item.status?item.status:''" :trackingNumber="item.trackingNumber?item.trackingNumber:''" :count="item.count?item.count:''" :amount="item.amount?item.amount:''" :refund="item.refund?item.refund:''" :orderObjet="item.order?JSON.stringify({id:item.order.id,totalPrice:item.order.totalPrice,teleConsultantConfirm:item.order.teleConsultantConfirm,seller:{_id:item.order.seller._id||item.order.seller},source:item.order.source,customer:item.order.customer,details:item.order.details.map( el => ({product: {_id:el.product._id,quantity:el.product.quantity}, quantity: el.quantity}) ) }):''" :order="item.order?item.order._id:''" :seller="(item.seller && item.seller.source)?item.seller.source:'nosource'" :id="item._id" @click="getRowDetail(item,item._id)" class="form-checkbox rowCheckbox focus:outline-none focus:shadow-outline">
                                                            </label>
                                                        </div> 
                                                        <div v-else>
                                                            <div v-if="itemst.name=='country' && config.name=='warehouses'">
                                                               <img v-if="data[index].is_primary" :src="data[index]['flag'] || $f.getCountryCode(data[index][itemst.name])" class="h-4 w-5 blob inline-block mr-2" :alt="data[index][itemst.name]"> 
                                                            </div>
                                                            <div v-else-if="itemst.name=='address' || itemst.name=='name'" :class="itemst.name=='name' && config.name=='warehouses' && data[index]['parent']?'parent-warehouse':''">
                                                               
                                                               <div v-if="config.name == 'products' && itemst.name == 'name'" class="flex align-items-center"> 
                                                                    <div class="flex-shrink-0 me-2">
                                                                         <expandable-image class="expandable-img" :src="data[index].picture || 'https://img.icons8.com/ios-glyphs/30/no-image.png'" alt="img-pr" />
                                                                    </div>
                                                                    <div class="flex-grow-1 text-reset font-semibold"> {{ exceptText(data[index][itemst.name]) }}</div>
                                                                </div>
                                                                <div v-else>{{ exceptText(data[index][itemst.name]) }} </div>
                                                                
                                                            </div>
                                                            <!--Producs quatite-->
                                                            <div v-else-if="itemst.arrayD" class="text-center">
                                                                <span v-if="!['outOfStock','price','upsells','cross-sell'].includes(itemst.name)" class="bg-purple-200 text-purple-600 py-1 px-3 rounded-full text-xs">Total:  {{ data[index][itemst.name]?data[index][itemst.name]:0 }}</span>

                                                                  <div v-for="(war, i) in data[index][itemst.arrayD].filter(item => idWharhouse && item.warehouse && item.warehouse.country == idWharhouse.country)" :key="i"  :class="data[index][itemst.arrayD].filter(item => item.warehouse && item.warehouse.country == idWharhouse.country).length>1 && data[index][itemst.arrayD].filter(item => item.warehouse && item.warehouse.country == idWharhouse.country).length-1 != i && itemst.name!='outOfStock' ?'border-b border-gray-600 border-dashed':''" class="flex justify-center items-center py-1">
                                                                        <span v-if="itemst.name=='outOfStock'"> 
                                                                            <span  v-if="war.warehouse.is_primary"  :class="war.outOfStock?'status-inactive':'status-active'" class="statusP"><span>{{war.outOfStock?'Inactive':'Active'}}</span></span>
                                                                        </span>
                                                                        <span v-else-if="itemst.name == 'price'">
                                                                        <span v-if="war.warehouse.is_primary" :class="war[itemst.name] ? 'text-green-600 ' : 'text-red-600 '" class="statusP uppercase">{{ war[itemst.name] }} <sup v-if="idWharhouse">{{ idWharhouse.currency }}</sup></span>
                                                                        </span>
                                                                        <span v-else-if="itemst.name == 'upsells'">
                                                                            <span v-if="war.warehouse.is_primary" class="statusP">
                                                                                <span
                                                                                style="background-color:#fce7e7;color:rgba(237,94,94,1);padding:0.35em 0.65em;font-size:0.75em;font-weight:500"
                                                                                v-if="!war.upsells || (war.upsells && war.upsells.length === 0)">Non
                                                                                utilisé</span>
                                                                                <svg class="fill-current text-green-600" v-else
                                                                                xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                                                <path
                                                                                    d="M0 0v24h24v-24h-24zm11 17l-5-5.299 1.399-1.43 3.574 3.736 6.572-7.007 1.455 1.403-8 8.597z" />
                                                                                </svg>
                                                                            </span>
                                                                        </span>
                                                                        <span v-else-if="itemst.name == 'cross-sell'">
                                                                            <span v-if="war.warehouse.is_primary" class="statusP">
                                                                                <span
                                                                                style="background-color:#fce7e7;color:rgba(237,94,94,1);padding:0.35em 0.65em;font-size:0.75em;font-weight:500"
                                                                                v-if="!war.cross_sells || (war.cross_sells && war.cross_sells.length === 0)">Non
                                                                                utilisé</span>
                                                                                <svg class="fill-current text-green-600" v-else
                                                                                xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                                                <path
                                                                                    d="M0 0v24h24v-24h-24zm11 17l-5-5.299 1.399-1.43 3.574 3.736 6.572-7.007 1.455 1.403-8 8.597z" />
                                                                                </svg>
                                                                            </span>
                                                                        </span>
                                                                        <!-- <span class="flex box-flexx" v-else>
                                                                            <div class="mr-2"><img class="w-4 h-4 rounded-full" :src="idWharhouse.flag"></div>
                                                                            <span>{{ war.quantity[itemst.name] }}</span>
                                                                        </span> -->
                                                                        <template v-else>
                                                                            <template>
                                                                                <svg v-if="war.warehouse.is_primary" class="fill-current mr-2" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"><path d="M12 6.453l9 8.375v9.172h-6v-6h-6v6h-6v-9.172l9-8.375zm12 5.695l-12-11.148-12 11.133 1.361 1.465 10.639-9.868 10.639 9.883 1.361-1.465z"/></svg> <img class="w-4 h-4 rounded-full" :src="war.warehouse.flag">  
                                                                            </template>
                                                                            <div class="pl-1 flex">{{ war.quantity[itemst.name] }}   <span class="mx-1 px-1 ware-name" v-if="war.warehouse.parent">({{war.warehouse.name}})</span></div>
                                                                        </template>
                                                                  </div>
                                                               
                                                            </div>
                                                        <!-- /Producs quatite-->
                                                            <div :class="(itemst.name=='id' || itemst.name=='order_id')?'normal-case':''" v-else>
                                                                <span v-if="itemst.name=='id' || itemst.name=='order_id'">
                                                                   <!-- {{$f.getIdbySplit(data[index][itemst.name])}}  -->
                                                                   {{ data[index][itemst.name] }}
                                                                </span>
                                                                <span :class="itemst.name=='amount'?'font-bold':''" v-else>
                                                                    <span v-if="itemst.name=='warehouses'" class="flex">
                                                                            <span v-for="(images, r) in data[index][itemst.name]" :key="r">
                                                                                    <img :src="images" class="w-4 h-4 rounded-full mr-2">
                                                                            </span>
                                                                    </span>
                                                                    <span v-else-if="itemst.name==='is_primary'">
                                                                        <svg v-if="data[index][itemst.name]" class="fill-current" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><path d="M10.041 17l-4.5-4.319 1.395-1.435 3.08 2.937 7.021-7.183 1.422 1.409-8.418 8.591zm5.959-17v2h-8v-2h8zm0 24v-2h-8v2h8zm2-22h4v4h2v-6h-6v2zm-18 14h2v-8h-2v8zm2-10v-4h4v-2h-6v6h2zm22 2h-2v8h2v-8zm-2 10v4h-4v2h6v-6h-2zm-16 4h-4v-4h-2v6h6v-2z"/></svg>
                                                                    </span>
                                                                    <span v-else>
                                                                        <div class="inline-block" v-html="data[index][itemst.name]"></div> <sup v-if="(itemst.name=='amount' || itemst.name=='totalPrice') && idWharhouse">{{idWharhouse.currency}}</sup> <span class="font-bold ml-1 text-blue-600" v-if="itemst.name=='count' && config.name=='payments'">Orders</span>
                                                                    </span>           
                                                                
                                                                </span>
                                                            </div> 
                                                        </div>       
                                                </div>    
                                            </div>
                                            <div v-else> <!-- show two fieds seller(name,nemail),custumers(name,phone) ... -->
                                                <div v-for="(ele,itemelem) in itemst.elements" :key="itemelem">
                                                    <div v-for="(refit,ind) in ele.items" :key="ind">
                                                        <div :class="refit.class">
                                                            <div v-if="refit.name == 'picture'">
                                                                <img :src="data[index][itemst.name][refit.name]||'https://img.icons8.com/external-others-inmotus-design/67/000000/external-Image-basic-ui-elements-others-inmotus-design-3.png'" class="h-12 w-12" />
                                                            </div>
                                                            <div v-else>
                                                                <span v-if="data[index][itemst.name] && !isEmpty(data[index][itemst.name][refit.name] )"> 
                                                                    <i v-if="refit.icone" class="material-icons tiny">{{refit.icone}}</i>
                                                                    <img class="icone-img" v-if="refit.iconeimg" :src="refit.iconeimg"/>
                                                                    <span v-if="refit.name=='shippingAddress'">{{exceptText(data[index][itemst.name][refit.name])}}</span>
                                                                    <span v-else-if="refit.name=='products'"> 
                                                                        {{ProductNamesGroup(data[index][itemst.name][refit.name])}}
                                                                    </span>
                                                                    <!-- <span v-else-if="refit.name=='orderId'">{{$f.getIdbySplit(data[index][itemst.name][refit.name])}}</span> -->
                                                                    <span v-else>{{ data[index][itemst.name][refit.name] }}</span>
                                                                </span> 
                                                            </div>   
                                                        </div>
                                                    </div>
                                                </div>  
                                            </div> 
                                        </div>    
                                    </div> 
                                    <div v-if="(col.model && col.model=='expedition') || (col.model && col.model=='order') || (col.model && col.model=='payments') || (col.model && col.model=='shippings')  || (col.model && col.model=='sourcings')"> <!-- Expedition and Order and Shipping sous table -->    
                                        <div class="flex">
                                            <div v-if="(col.model && col.model=='expedition') || (col.model && col.model=='sourcings') || (col.model && col.model=='order') || (col.model && col.model=='payments')">
                                                <p><span class="font-semibold mr-1 text-blue-600"> <span v-if="col.model=='order'">{{QuantityTotalProductOrderOnly(data[index][col.name])}}</span><span v-else>{{data[index][col.name].length}} </span>  </span><b>{{col.title}}</b></p>
                                                <span v-if="col.model!='sourcings'" class="font-light text-gray-700">
                                                    {{ $moment(data[index]['date']).format('yyyy-MM-DD')}}
                                                </span>
                                            </div>
                                            <div v-else><!--shppings -->
                                                <p><span class="font-bold mr-1 text-blue-600"> {{data[index].order.details.length}} </span>Products</p>
                                                <span class="font-light text-gray-700">Quantity: </span><b>{{QuantityTotalProductOrder(data[index])}}</b> 
                                            </div>    
                                            <button v-if="col.model!='payments'"  @click="showSousTable(index)" :class="$colors.newColor" class="bg-gray-100 hover:bg-blue-100 hover:text-white rounded-full mr-2 flex items-center text-2xl focus:outline-none p-1 ml-1">
                                                <i class="material-icons" style="transition: 0.3s" :style=" element && element._id == item._id ? 'transform: rotate(180deg)' : ''">keyboard_arrow_down</i>
                                            </button>
                                        </div>
                                    </div> 
                                </div>    
                                </td>
                                <td v-if="config.actions && config.actions.elements && config.actions.elements.length != 0" style="position: sticky; right: 0px;" class="px-3 py-4 whitespace-no-wrap border-b border-gray-200 ant-table-cell-fix-right ant-table-cell-fix-right-first" >
                                    <div class="flex justify-center">
                                        <div v-for="(action,ind) in config.actions.elements" :key="ind">
                                            <div @click="getAccess(action.key,data[index]['status'],data[index]['sameOrderUnreached']||null,data[index]['type'],action.role)" v-if="getAccess(action.key,data[index]['status'],data[index]['sameOrderUnreached']||null,data[index]['type'],action.role) && action.role" :class="$colors.actionTable">
                                                <div  v-if="action.link"> <!--link view, edit --> 
                                                <router-link :target="config.name=='statusHistories'?'_blank':''" :to="config.name=='statusHistories'?{ path: `${action.link}/${data[index]['order']['_id']}`}:{ path: `${action.link}/${data[index]['_id']}`}" :class="config.actions.class"><i class="material-icons mx-2"> {{action.icone}}</i></router-link>
                                                </div>
                                                <div v-else> <!--link delete -->
                                                    <button :disabled="loadingDouble" @click="emitFunction(action.key,data[index]['_id'],data[index])" :class="config.actions.class"><i class="material-icons mx-2">{{action.icone}}</i></button>
                                                </div>
                                            </div>
                                        </div>    
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="config.sousTable && (element && element._id == data[index]['_id'])"><!-- sous table info expedition and order -->
                            <td :colspan="config.columns.length+1" class="border">
                                <div class="w-full rounded-2xl">
                                    <table class="table w-full text-center" :class="config.name=='shippings'? 'table-shipp':''">
                                            <thead class="bg-gray-100 text-black">
                                                <tr>
                                                   <th v-for="(col, ind) in config.columnsDialog.elements" :key="ind" class="px-5 py-2 bg-gray-100 text-center text-xs font-semibold text-gray-600 capitalize tracking-wider"> {{col.name=='sous warehouse'?(sous_idWharhouse && sous_warehouses && sous_warehouses.length>0?'sous warehouse':'warehouse'):col.name}}  <span v-if="idWharhouse && col.name=='Total Price' && config.name=='sourcings'">({{idWharhouse.currency}})</span></th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="config.name=='expeditions' || config.name=='orders' || config.name=='payments' || config.name=='sourcings'">
                                                <tr v-for="(row,j) in element[config.columnsDialog.details]" :key="j" class="bg-light-blue-200">
                                                    <td v-for="(col, ind) in config.columnsDialog.elements" :key="ind" class="text-xs leading-5 capitalize text-gray-900">
                                                        <div v-for="(item, indeitem) in col.items" :key="indeitem">
                                                            <div v-if="config.name=='expeditions'"> <!-- Expedition sous table -->
                                                                <span v-if="col.attribut=='product'">
                                                                    <div v-if="item.name=='picture'">
                                                                    <img :src="[row.product][0][item.name]||'https://img.icons8.com/external-others-inmotus-design/67/000000/external-Image-basic-ui-elements-others-inmotus-design-3.png'" class="w-8 my-2 rounded-md mx-auto">
                                                                    </div>
                                                                    <div v-else>
                                                                        {{[row.product][0][item.name]}} 
                                                                    </div>
                                                                </span> 
                                                                <span v-else>
                                                                    <div v-if="item.name=='received'">
                                                                        <table  class="min-w-full">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th class="text-center bg-gray-200 px-6 py-1 border border-gray-300 text-left leading-4 text-blue-500 tracking-wider">Ok/Good</th>
                                                                                    <th  class="text-center bg-gray-200 px-6 py-1 border border-gray-300 text-left leading-4 text-blue-500 tracking-wider">Defective</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody class="bg-white">
                                                                                <tr class="bg-light-blue-200">
                                                                                    <td class="text-xs leading-5 capitalize text-gray-900">{{[row.quantity][0][item.name]}}</td>
                                                                                    <td class="text-xs leading-5 capitalize text-gray-900">{{[row.quantity][0][item.name_1]}}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                    <div v-else>
                                                                        {{item.name=='warehouseParentName'?(row[item.name]||[row.quantity][0][item.name]||idWharhouse.name):row[item.name]||[row.quantity][0][item.name]}}
                                                                    </div>                                                               
                                                                </span> 
                                                            </div>
                                                            <div v-else-if="config.name=='sourcings'"> <!-- Sourcing sous table -->
                                                                <span v-if="col.attribut=='productObject'">
                                                                    <div v-if="item.name=='image'">
                                                                        <img :src="[row.productObject][0][item.name]||'https://img.icons8.com/external-others-inmotus-design/67/000000/external-Image-basic-ui-elements-others-inmotus-design-3.png'" class="w-8 my-2 rounded-md mx-auto">
                                                                    </div>
                                                                    <div v-else>
                                                                        {{[row.productObject][0][item.name]}}
                                                                    </div>
                                                                </span> 
                                                                <span v-else>
                                                                    {{[row][0][item.name]}} 
                                                                </span>    
                                                            </div>
                                                            <div v-else-if="config.name=='orders'"> <!-- Order sous table -->
                                                                <div v-if="col.referent"> 
                                                                    <span v-if="col.referent=='product'">
                                                                        <div v-if="item.name=='picture'">
                                                                            <img :src="[row.product][0][item.name]||'https://img.icons8.com/external-others-inmotus-design/67/000000/external-Image-basic-ui-elements-others-inmotus-design-3.png'" class="w-8 my-2 rounded-md mx-auto"> 
                                                                        </div>
                                                                        <div v-else>
                                                                            <span v-if="item.name=='name' && idWharhouse && idWharhouse._id">
                                                                              <a class="text-blue-600" target="_blank" :href="`/products?name=${[row.product][0].id}&limit=10&details.warehouse=${idWharhouse._id}`">{{[row.product][0][item.name]}} </a>
                                                                            </span>
                                                                            <span v-else>
                                                                                {{[row.product][0][item.name]}}
                                                                            </span>
                                                                        </div>
                                                                    </span> 
                                                                    <span v-else>{{[row.category][0][item.name]}}</span> 
                                                                </div>
                                                                <div v-else>
                                                                      {{item.name=='warehouseParentName'?([row][0][item.name]||idWharhouse.name):[row][0][item.name]}}
                                                                </div>
                                                            </div>
                                                            <div v-else><!-- payament sous tabl -->
                                                            <div v-if="item.referent">
                                                                <div v-if="item.field">
                                                                    {{row[item.referent][item.field][item.name]}}
                                                                </div>
                                                                <div v-else>
                                                                    <div :class="item.name=='id'?'normal-case':''">
                                                                            <span v-if="item.name=='id'">
                                                                                <!-- {{$f.getIdbySplit(row[item.referent][item.name])}} -->
                                                                                {{row[item.referent][item.name]}}
                                                                            </span>
                                                                            <span v-else>
                                                                                {{row[item.referent][item.name]}}
                                                                            </span>
                                                                    </div> 
                                                                </div> 
                                                            </div>
                                                            <div v-else>
                                                                <div :class="((item.name=='vat' || item.name=='shipping_refund_vat' || item.name=='shipping_change_vat') && row[item.name]==0  && config.name=='payments') ?'empty-row':''">
                                                                        <span v-if="item.name=='vat'">{{row[item.name]}} ({{data[index]['vat']}}%)</span>
                                                                        <span v-else>{{row[item.name]}}</span>
                                                                </div>
                                                            </div>
                                                            </div>                                                      
                                                        </div>
                                                    </td>
                                                </tr> 
                                            </tbody>
                                            <tbody  v-else><!--Shipping sous table order info-->
                                                <tr class="bg-light-blue-200">
                                                    <td v-for="(col, ind) in config.columnsDialog.elements" :key="ind" class="text-xs leading-5 capitalize text-gray-900">
                                                        <div v-for="(item, indeitem) in col.items" :key="indeitem">
                                                                <div v-if="col.attribut"> 
                                                                    <div v-if="!item.elements">
                                                                        <span v-if="item.name=='shippingAddress'">{{data[index]['address']}}</span>  
                                                                        <span v-else>{{data[index][col.referent][col.attribut][item.name]}}</span>  
                                                                    </div>
                                                                    <div v-else> <!-- Show two fields (Custumer) -->
                                                                            <div v-for="(ele,itemelem) in item.elements" :key="itemelem">
                                                                                <div v-for="(refit,ind) in ele.items" :key="ind">
                                                                                    <div :class="ele.class">
                                                                                        <div v-if="col.attribut!='seller'">
                                                                                            <i v-if="refit.icone" class="material-icons tiny">{{refit.icone}}</i>  {{data[index][col.referent][col.attribut][refit.name]}}
                                                                                        </div>  
                                                                                        <div v-else>
                                                                                            <span v-if="!isEmpty(data[index][config.columnsDialog.details][config.columnsDialog.name][0].product.seller[refit.name])">   <i v-if="refit.icone" class="material-icons tiny">{{refit.icone}}</i>  {{data[index][config.columnsDialog.details][config.columnsDialog.name][0].product.seller[refit.name]}}</span>
                                                                                        </div> 
                                                                                    </div>
                                                                                </div>
                                                                            </div>  
                                                                    </div>                                                    
                                                                </div>
                                                                <div v-else :class="item.name=='id'?'normal-case':''">
                                                                <span v-if="item.name=='id'">
                                                                    <!-- {{$f.getIdbySplit(data[index][col.referent][item.name])}}     -->
                                                                    {{ data[index][col.referent][item.name] }}    
                                                                </span>
                                                                <span :class="item.name=='totalPrice' && data[index].refund?'font-bold':''" v-else>
                                                                    <span v-if="item.name=='totalPrice' && data[index].refund">-</span>  {{data[index][col.referent][item.name]}}  
                                                                </span>
                                                                </div>  
                                                        </div>   
                                                    </td>   
                                                </tr>               
                                            </tbody>
                                            <thead class="bg-gray-100 text-black"><!--Shipping sous table product order info-->
                                                <tr><th v-for="(col, ind) in config.columnsDialog.sousElements" :key="ind" class="px-5 py-2 bg-gray-100 text-center text-xs font-semibold text-gray-600 capitalize tracking-wider">{{col.name}}</th></tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(prod, k) in data[index][config.columnsDialog.details][config.columnsDialog.name]" :key="k" class="bg-light-blue-200"> <!-- sous table products in order -->
                                                    <td v-for="(col, ind) in config.columnsDialog.sousElements" :key="ind" class="text-xs leading-5 capitalize text-gray-900">
                                                        <div v-for="(item, indeitem) in col.items" :key="indeitem">
                                                            <div v-if="col.referent">                                                          
                                                                <div v-if="item.name=='picture'">
                                                                    <img :src="prod[col.referent][item.name]||'https://img.icons8.com/external-others-inmotus-design/67/000000/external-Image-basic-ui-elements-others-inmotus-design-3.png'" class="w-8 my-2 rounded-md mx-auto">
                                                                </div>
                                                                <div v-else>
                                                                    {{prod[col.referent][item.name]}}
                                                                </div>                                                          
                                                            </div>
                                                            <div v-else>
                                                                <span>{{prod[item.name]}}</span> 
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr> 
                                            </tbody>     
                                        </table>     
                                </div>
                            </td> 
                            </tr>
                            <!--**************************************Debut Modal Change Shipping Address  and Status Order***************************-->
                            <vue-modal-2 v-if="config.name=='orders'" :name="'modal1_' + index" :headerOptions="{title: 'Order information'}" :noFooter="true" modalSize="xl" @on-close="closePopUpInformation(index)">
                                <modal-info-order :item="item" :index="index" :shippingDate="shippingDate" :CheckQteDefecteuseorderexist="CheckQteDefecteuseorderexist" @CheckQteDefecteuseOrder="CheckQteDefecteuseOrder" :checkSousWrehouses="checkSousWrehouses"  :courier="courier" :currentUser="currentUser" @getCourierZone="getCourierZone" @OrderChange="OrderChange" :shipping="shipping"  :config="config" :statusOrder="statusOrder" :statusOrderToChange="statusOrderToChange" :zones="zones" />
                                <div class="modal-footer px-5 border0-t text-right">
                                <button @click="closePopUpInformation(index)" class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">Cancel</button>
                                <button @click="ConfirmOperationUpdate(item, index)" class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right relative loidingconfirm" :disabled="loadingcreateShipp"><loading :active.sync="loadingcreateShipp" :is-full-page="fullPage"></loading>Confirm</button>
                                </div>
                            </vue-modal-2>  
                            <!--**************************************Debut Modal Change Shipping Address  and Status Order***************************-->
                            <!--**************************************Debut Modal Change status recived expeditions***************************-->
                            <vue-modal-2 v-if="config.name=='expeditions'" :name="'modal1_' + index" :headerOptions="{title: 'Expedition information'}" :noFooter="true" modalSize="xl" @on-close="closePopUpInformation(index)">
                                <modal-info-expo :item="item" :index="index" :config="config" :CheckExpeditionRecived="CheckExpeditionRecived" @CheckQteSentExist="CheckQteSentExist" :statusExpedition="statusExpedition" :transports="transports"/>
                                <div class="modal-footer-ex px-5 border0-t text-right">
                                <button @click="closePopUpInformation(index)" class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">Cancel</button>
                                <button @click="ConfirmOperationUpdate(item, index)" class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right  relative loidingconfirm" :disabled="loadingdatashipp"><loading :active.sync="loadingdatashipp" :is-full-page="fullPage"></loading>Confirm</button>
                                </div>
                            </vue-modal-2>   
                            <!--**************************************Debut Modal Change status recived expeditions***************************-->
                            <!--**************************************Debut Modal Change status shipping***************************-->
                        <vue-modal-2 v-if="config.name=='shippings'" :name="'modal1_' + index" :headerOptions="{title: 'Shipping informations'}" :noFooter="true" modalSize="xl" @on-close="closePopUpInformation(index)">
                                <modal-info-shipp :item="item" :index="index" :active_el="active_el" @activate="activate" :couriers="couriers" :currentUser="currentUser" :idWharhouse="idWharhouse" :config="config" :CheckQteDefecteuseexist="CheckQteDefecteuseexist" :CheckQteReturnedexist="CheckQteReturnedexist" @ChangeQuantityOrder="ChangeQuantityOrder"  @CheckQteDefecteuse="CheckQteDefecteuse" @CheckQteReturned="CheckQteReturned" :zones="zones" :statusShipp="statusShipp" :typesShipp="typesShipp"/>
                                <div class="modal-footer px-5 border0-t text-right">
                                <button @click="closePopUpInformation(index)" class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">Cancel</button>
                                <button @click="ConfirmOperationUpdate(item, index)" class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right loidingconfirm relative" :class="loadingdatashipp?'noselect':''"><loading :active.sync="loadingdatashipp" :is-full-page="fullPage"></loading>Confirm</button>
                                </div> 
                            </vue-modal-2>  
                            <!--**************************************/Debut Modal Change status shipping***************************-->
                            <!--**************************************Debut Modal Change status shipping***************************-->
                        <vue-modal-2 v-if="config.name=='refunds'" :name="'modal1_' + index" :headerOptions="{title: 'Refund informations'}" :noFooter="true" modalSize="xl" @on-close="closePopUpInformation(index)">
                                <modal-info-refund :item="item" :index="index" :currency="idWharhouse?idWharhouse.currency:''" :currentUser="currentUser" :config="config" :statusShipp="statusShipp"/>
                                <div class="modal-footer px-5 border0-t text-right">
                                <button @click="closePopUpInformation(index)" class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">Cancel</button>
                                <button @click="ConfirmOperationUpdate(item, index)" class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right loidingconfirm relative" :class="loadingdatashipp?'noselect':''"><loading :active.sync="loadingdatashipp" :is-full-page="fullPage"></loading>Confirm</button>
                                </div> 
                            </vue-modal-2>  
                                <!--**************************************Debut Modal Change status shipping***************************-->
                        <vue-modal-2 v-if="config.name=='sourcings'" :name="'modal1_' + index" :headerOptions="{title: 'Sourcing informations'}" :noFooter="true" modalSize="xl" @on-close="closePopUpInformation(index)">
                                <modal-info-sourcing :item="item" :index="index" :currency="idWharhouse?idWharhouse.currency:''" :currentUser="currentUser" :config="config" :statusShipp="statusShipp"/>
                                <div class="modal-footer px-5 border0-t text-right">
                                <button @click="closePopUpInformation(index)" class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">Cancel</button>
                                <button @click="ConfirmOperationUpdate(item, index)" class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right loidingconfirm relative" :class="loadingdatashipp?'noselect':''"><loading :active.sync="loadingdatashipp" :is-full-page="fullPage"></loading>Confirm</button>
                                </div> 
                            </vue-modal-2>  
                            <!--**************************************/Debut Modal Change status shipping***************************-->
                                <!--**************************************Debut Modal Change status shipping***************************-->
                        <vue-modal-2 v-if="config.name=='payments'" :name="'modal1_' + index" :headerOptions="{title: 'Payment informations'}" :noFooter="true" modalSize="xl" @on-close="closePopUpInformation(index)">
                                <modal-info-payement :item="item" :index="index" :currency="idWharhouse?idWharhouse.currency:''" :currentUser="currentUser" :config="config" :statusShipp="statusShipp"/>
                                <div class="modal-footer px-5 border0-t text-right">
                                <button @click="closePopUpInformation(index)" class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">Cancel</button>
                                <button @click="ConfirmOperationUpdate(item, index)" class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right loidingconfirm relative" :class="loadingdatashipp?'noselect':''"><loading :active.sync="loadingdatashipp" :is-full-page="fullPage"></loading>Confirm</button>
                                </div> 
                            </vue-modal-2>  
                            <!--**************************************/Debut Modal Change status shipping***************************-->
                            <!--**************************************Debut Modal Change shipping print***************************-->
                            <vue-modal-2  v-if="config.name=='shippings'"  name="print-shippings-delivry" :headerOptions="{title: 'Shipping informations'}" :noFooter="true" modalSize="xl">
                                    <modal-info-shipp-print :item="item" :idWharhouse="idWharhouse" :index="index" :config="config"/>
                            </vue-modal-2>       
                            <!--**************************************/Debut Modal Change shipping print***************************-->
                        </template> 
                    </tbody>
                </table>
              </div>
                <div v-if="!data || data.length <= 0" class="bg-blue-100 py-8 relative">
                    <!-- <loading :active.sync="loading" :is-full-page="fullPage"></loading> -->
                    <span class="w-full flex justify-center text-center py-3 border-b border-gray-200 text-base">
                        <p class="font-semibold flex text-blue-500 whitespace-no-wrap">
                            <i class="material-icons mx-3">error</i>
                            <span v-if="loading"> Loading Data ... <img class="img-paym" :src="spinner" /></span>
                            <span v-else> No {{config.name}} Found </span>   
                        </p>
                    </span>
                </div>
            </div>
            <!--pagination -->
            <div class="p-1" v-if="paginate.lastpage > 1" >
                <div class="flex flex-col items-center my-12">
                    <div-paginate  :paginate="paginate" @paginatation="paginatation" />
                </div>
            </div>
            <!--end pagination -->
            <!--Modal change status Shipping -->
             <vue-modal-2 v-if="config.name=='shippings' || config.name=='payments'"  name="ModalChangeStatus" :headerOptions="{title: 'Change status'}" :noFooter="true" modalSize="lg" @on-close="OpenClosePopupModal('close','changestatus')">
                <div class="bg-white rounded-lg mb-20">
                    <div v-if="showprogress && tabId.length>0" class="k-progressss px-4 mb-4">
                        <k-progress 
                            active 
                            status="error" 
                            type="lump"
                            :border="false"
                            :color="['#40a9ff', '#5cdbd3', '#cf1322', '#722ed1']"
                            :percent="itemsShipp*100/tabId.length" >
                        </k-progress>
                        <div class="flex items-center"><div class="font-mediummm">Updating ...</div><div class="text-xs text-gray-900 ml-auto">{{itemsShipp}} / {{tabId.length}}</div></div>
                    </div>
                    <div class="relative">
                         <loading :active.sync="loadingChange" :is-full-page="fullPage"></loading>
                        <div class="rounded-lg flex">
                            <div class="w-1/3 flex justify-center items-center">
                                <span class="w-16 h-16 bg-blue-600 text-white p-3 rounded-full"><i class="material-icons" style="font-size: 40px;">update</i></span>
                            </div>
                            <div class="w-full pr-4">
                                <h3 class="font-bold text-blue-700 mb-10">Change Status</h3>
                                <div class="mb-5 change-status border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                        <p>
                                            <label for="status" class="bg-white text-gray-700 px-1">Status</label>
                                        </p>
                                    </div> 
                                    <p>
                                        <v-select  v-model="statusTochange" :options="statusShippChange" ></v-select>    
                                    </p>
                                </div> 
                                <div v-if="statusTochange && statusTochange=='cancelled' && config.name=='shippings'" class="border mb-5  hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                    <p>
                                    <label for="resonCancelled" class="bg-white text-gray-700 px-1"> Reason <span :class="$colors.required">*</span></label>
                                    </p>
                                </div>
                                <p>
                                    <textarea id="resonCancelled" rows="3" placeholder="Reason cancelled ..." type="text" v-model="resonCancelled" class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full"></textarea>
                                </p>
                            </div>
                            </div>
                        </div>
                        <div v-if="config.name=='shippings'" class="blue tagged tex2jax_ignore x-rem clc-jobs-multi py-4">
                              <div class="header d-flex ">
                                  <span class="flex--item fl1"> <strong>Change in order of </strong> cases </span>
                                  <span class="header-icon-right flex--item"> 
                                      <svg class="svg-icon iconHome fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-2.033 16.01c.564-1.789 1.632-3.932 1.821-4.474.273-.787-.211-1.136-1.74.209l-.34-.64c1.744-1.897 5.335-2.326 4.113.613-.763 1.835-1.309 3.074-1.621 4.03-.455 1.393.694.828 1.819-.211.153.25.203.331.356.619-2.498 2.378-5.271 2.588-4.408-.146zm4.742-8.169c-.532.453-1.32.443-1.761-.022-.441-.465-.367-1.208.164-1.661.532-.453 1.32-.442 1.761.022.439.466.367 1.209-.164 1.661z"/></svg>
                                   </span>
                              </div>
                              <div class="middle">
                                 <div class="voyage-info">
                                       <div class="segments">
                                           <div class="segment departure">
                                               <time class="fz-10" style="color:#dbb010">Queued</time>
                                            </div> 
                                            <div class="divider"></div> 
                                            <!-- <div class="segment adaptive duree">
                                               <span class="bus"><i  class="fa fa-clock-o"></i> Queued </span>
                                            </div>  -->
                                            <div class="divider adaptive"></div> 
                                            <div class="segment destination">
                                                <time class="fz-10" style="color:#1073db">Prepared</time> 
                                            </div>
                                        </div>
                                 </div>
                                 <div class="voyage-info">
                                       <div class="segments">
                                           <div class="segment departure">
                                               <time class="fz-10" style="color:#1073db">Prepared</time>
                                            </div> 
                                            <div class="divider"></div> 
                                            <!-- <div class="segment adaptive duree">
                                               <span class="bus"><i  class="fa fa-clock-o"></i> Queued </span>
                                            </div>  -->
                                            <div class="divider adaptive"></div> 
                                            <div class="segment destination">
                                                <time class="fz-10" style="color:#cf5d26">Shipped</time> 
                                            </div>
                                        </div>
                                 </div>
                                  <div class="voyage-info">
                                       <div class="segments">
                                           <div class="segment departure">
                                               <time class="fz-10" style="color:#cf5d26">Shipped</time>
                                            </div> 
                                            <div class="divider"></div> 
                                            <!-- <div class="segment adaptive duree">
                                               <span class="bus"><i  class="fa fa-clock-o"></i> Queued </span>
                                            </div>  -->
                                            <div class="divider adaptive"></div> 
                                            <div class="segment destination">
                                                <time class="fz-10" style="color:black">Reprogrammed</time> 
                                            </div>
                                        </div>
                                 </div>
                                   <div class="voyage-info">
                                       <div class="segments">
                                           <div class="segment departure">
                                               <time class="fz-10" style="color:black">Reprogrammed</time>
                                            </div> 
                                            <div class="divider"></div> 
                                            <!-- <div class="segment adaptive duree">
                                               <span class="bus"><i  class="fa fa-clock-o"></i> Queued </span>
                                            </div>  -->
                                            <div class="divider adaptive"></div> 
                                            <div class="segment destination">
                                                <time class="fz-10" style="color:#cf5d26">Shipped</time> 
                                            </div>
                                        </div>
                                 </div>
                                 <div class="voyage-info">
                                       <div class="segments">
                                           <div class="segment departure">
                                               <time class="fz-10" style="color:#cf5d26">Shipped</time>
                                            </div> 
                                            <div class="divider"></div> 
                                            <div class="segment adaptive duree">
                                               <span class="bus">  <i style="font-size: 16px;vertical-align: sub;" class="material-icons">access_time</i> Shipping date :{{$moment(Date.now()).format('yyyy-MM-DD')}} </span>
                                            </div> 
                                            <div class="divider adaptive"></div> 
                                            <div class="segment destination">
                                                <time class="fz-10" style="color:#45a52e">Received</time> 
                                            </div>
                                        </div>
                                 </div>
                                  <div class="voyage-info">
                                       <div class="segments">
                                           <div class="segment departure">
                                               <time class="fz-10" style="color:#45a52e">Received</time>
                                            </div> 
                                            <div class="divider"></div> 
                                            <!-- <div class="segment adaptive duree">
                                               <span class="bus"><i  class="fa fa-clock-o"></i> Queued </span>
                                            </div>  -->
                                            <div class="divider adaptive"></div> 
                                            <div class="segment destination">
                                                <time class="fz-10" style="color:rgb(181 16 183)">Paid</time> 
                                            </div>
                                        </div>
                                 </div>
                                  <div class="voyage-info">
                                       <div class="segments">
                                           <div class="segment departure">
                                               <time style="color:rgb(46 65 165);font-size: 10px;">(Prepared,Shipped,Reprogrammed)</time>
                                            </div> 
                                            <div class="divider"></div> 
                                            <!-- <div class="segment adaptive duree">
                                               <span class="bus"><i  class="fa fa-clock-o"></i> Queued </span>
                                            </div>  -->
                                            <div class="divider adaptive"></div> 
                                            <div class="segment destination">
                                                <time class="fz-10" style="color:red">Cancelled</time> 
                                            </div>
                                        </div>
                                 </div>
                              </div>
                        </div>
                        
                    </div>   
                    <div class="p-4 flex space-x-4 modal-footer">
                            <a href="#" @click="OpenClosePopupModal('close','changestatus')" class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm">Cancel</a>
                            <a href="#" @click="confirmChange" class="w-1/2 px-4 py-3 text-center text-blue-100 bg-blue-600 rounded-lg hover:bg-blue-700 hover:text-white font-bold text-sm">Confirme</a>
                        </div> 
                </div>
            </vue-modal-2>     
            <!-- end modal change status shipping -->
             <!--Modal change status Shipping -->
              <vue-modal-2 v-if="config.name=='products'"  name="ModalChangeQte" :headerOptions="{title: 'Change quantity in stock'}" :noFooter="true" modalSize="lg" @on-close="OpenClosePopupModal('close','ChangeQte')">
                <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                <div class="bg-white rounded-lg">
                    <div class="rounded-lg flex">
                    <!-- <div class="w-1/4 pt-6 flex justify-center items-center">
                        <span class="w-16 h-16 bg-blue-600 text-white p-3 rounded-full"><i class="material-icons" style="font-size: 40px;">import_export</i>{{selectProduct.name}}</span>
                    </div> -->
                    <div class="w-full pt-9 px-4 mb-20">
                        <h3 class="uppercase font-bold text-sm text-blue-700 pt-2 mb-4 text-center">Change quantity in stock</h3>
                         <div  v-if="selectProduct.name" class="py-3 px-5 mx-2 mb-6 bg-gray-100 text-gray-900 rounded-md text-sm border border-gray-500" role="alert">
                          <p> <strong>Product: {{selectProduct.name}} </strong></p>
                          <p class="mb-3"><strong>Current quantity Instock: </strong></p>
                           <div class="flex flex-wrap">  
                                <div class="w-1/2 text-center px-2">
                                    <div class="bg-gray-300 rounded-lg flex items-center justify-center border border-gray-500">
                                    <div class="w-1/3 bg-transparent flex items-center justify-center icon-step">
                                      Instock:
                                    </div>
                                    <div class="w-2/3 bg-gray-200  flex flex-col items-center justify-center px-1 rounded-r-lg body-step">
                                        <h2 class="font-bold text-sm">Total:  {{ selectProduct.quantity.inStock }}</h2>
                                        <div class="py-1">
                                            <div  v-for="(wharhouse, i) in producWarhouse" :key="i" v-if="wharhouse.warehouse.country == idWharhouse.country" class="flex justify-center items-center py-1">
                                                <div class="flex">
                                                   <svg v-if="wharhouse.warehouse.is_primary" class="fill-current mr-2" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"><path d="M12 6.453l9 8.375v9.172h-6v-6h-6v6h-6v-9.172l9-8.375zm12 5.695l-12-11.148-12 11.133 1.361 1.465 10.639-9.868 10.639 9.883 1.361-1.465z"/></svg> <img class="w-4 h-4 rounded-full" :src="wharhouse.warehouse.flag">  
                                                </div>
                                                <div class="pl-1 flex">{{ wharhouse.quantity.inStock }}   <span class="mx-1 px-1 ware-name" v-if="wharhouse.warehouse.parent">({{wharhouse.warehouse.name}})</span></div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                <div class="w-1/2 text-center px-2">
                                    <div class="bg-gray-300 rounded-lg flex items-center justify-center border border-gray-500">
                                    <div class="w-1/3 bg-transparent  flex items-center justify-center icon-step">
                                        Total:
                                    </div>
                                    <div class="w-2/3 bg-gray-200  flex flex-col items-center justify-center px-1 rounded-r-lg body-step">
                                        <h2 class="font-bold text-sm">Total:  {{ selectProduct.quantity.total }}</h2>
                                        <div class="py-1">
                                            <div  v-for="(wharhouse, i) in producWarhouse" :key="i" v-if="wharhouse.warehouse.country == idWharhouse.country" class="flex justify-center items-center py-1">
                                                <div class="flex">
                                                   <svg v-if="wharhouse.warehouse.is_primary" class="fill-current mr-2" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"><path d="M12 6.453l9 8.375v9.172h-6v-6h-6v6h-6v-9.172l9-8.375zm12 5.695l-12-11.148-12 11.133 1.361 1.465 10.639-9.868 10.639 9.883 1.361-1.465z"/></svg> <img class="w-4 h-4 rounded-full" :src="wharhouse.warehouse.flag">  
                                                </div>
                                                <div class="pl-1 flex">{{ wharhouse.quantity.total }}   <span class="mx-1 px-1 ware-name" v-if="wharhouse.warehouse.parent">({{wharhouse.warehouse.name}})</span></div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>  
                        </div>
                        </div>
                      <div class="flex flex-wrap">  
                         <div class="w-full lg:w-1/3 px-2">
                            <div class="mb-10 border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                    <p>
                                        <label for="status" class="bg-white text-gray-700 px-1">Type operation</label>
                                    </p>
                                </div> 
                                <p>
                                    <v-select  v-model="ChangeQte.operation" :options="typeoperations" ></v-select>    
                                </p>
                            </div>
                        </div>
                         <div class="w-full lg:w-1/3 px-2">
                            <div class="mb-10 border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                    <p>
                                        <label for="status" class="bg-white text-gray-700 px-1">Type stock</label>
                                    </p>
                                </div> 
                                <p>
                                    <v-select  v-model="ChangeQte.stock" :options="typeostocks" ></v-select>    
                                </p>
                            </div>
                        </div>
                         <div class="w-full lg:w-1/3 px-2">
                            <div class="mb-10 border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                    <p>
                                        <label for="status" class="bg-white text-gray-700 px-1">Quantity</label>
                                    </p>
                                </div> 
                                <p>  
                                      <input id="quantity"  type="number" min="0" v-model="ChangeQte.quantity" class="py-2 text-xs px-2 outline-none block h-full w-full"/> 
                                </p>
                            </div>
                        </div>
                       
                        <!-- <div v-if="checkQte" class="w-full mx-4 px-4 py-3 px-5 mb-4 bg-red-100 text-red-900 text-sm rounded-md border border-red-200 flex items-center" role="alert">
                            <div class="w-4 mr-2">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.618 5.984A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016zM12 9v2m0 4h.01"></path>
                                </svg>
                            </div>
                         <span><strong>Quantity InStock Or Total insufficient !</strong></span>
                        </div> -->
                       </div>    
                       <section class="warehouse" v-if="expeditionData.warhouseParent.exist">   
                            <div class="flex mb-5 items-center text-center">
                                <hr class="border-gray-600 border-1 w-full rounded-md">
                                <label class="block font-medium text-sm cursor-pointer text-green-500  w-full"><span class="font-medium text-base text-green-800 dark:text-green-200">Choisir warehouse</span> </label>
                                <hr class="border-gray-600 border-1 w-full rounded-md">
                            </div>
                            <div class="bg-ww">
                                <h2 class="text-sm font-bold truncate mb-5">Définir le warehouse pour ce produit </h2> 
                                <div class="w-full">
                                    <div v-for="it in checkWarehousingParent" :key="it._id"  :id="it._id" @click="activateWarehouse(it)" :class="{active: it.fullOf}" class="border border-gray-600 intro-y flex-1 box-1 cursor-pointer zoom-in p-2 mb-2 pl-10">
                                    <div class="check-left"><span class="feather-icon select-none relative"><svg :class="it.fullOf?'bg-green-500':'bg-gray-500'" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check p-1 w-5 h-5 text-white rounded-full shadow"><polyline points="20 6 9 17 4 12"></polyline></svg></span></div>
                                    <div class="text-sm font-bold text-left">{{it.name}} <span v-if="it.is_primary">(Principal)</span></div>
                                    </div>             
                                </div>
                            </div>
                         </section>   
                    </div>
                    </div>
                    <div class="modal-footer  px-5 border0-t text-right">
                        <button @click="OpenClosePopupModal('close','ChangeQte')" class="px-6 mr-2 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm">Cancel</button>
                        <button  @click="confirmChangeQte" class="px-6  py-3 text-center text-blue-100 bg-blue-600 rounded-lg hover:bg-blue-700 hover:text-white font-bold text-sm loidingconfirm relative" :class="ChangeQte.loading?'noselect':''"><loading :active.sync="ChangeQte.loading" :is-full-page="fullPage"></loading>Confirme</button>
                    </div>
                </div>
              </vue-modal-2>         
            <!-- end modal change status shipping -->
            <!--Modal New shippings Shipping -->
             <vue-modal-2 v-if="config.name=='shippings'"  name="newShipp" :headerOptions="{title: 'New Shippings'}" :noFooter="true" modalSize="lg" @on-close="OpenPopupNewShipp('newShipp','close')">
                <div class="bg-white rounded-lg">
                    <div class="rounded-lg flex">
                    <div class="w-1/6 flex justify-center items-center">
                        <span class="w-16 h-16 bg-blue-600 text-white p-3 rounded-full"><i class="material-icons" style="font-size: 40px;">add_circle_outline</i></span>
                    </div>
                    <div class="w-full pr-4 mt-4">
                      <div class="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8">
                        <div class="grid grid-cols-1">
                            <div class="border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                    <p>
                                        <label for="Courier" class="bg-white text-gray-700 px-1">Courier <span class="text-blue-500">*</span></label>
                                    </p>
                                </div> 
                                <p>
                                    <v-select  @input="getZonesByCourier" @search="getUsersType($event,'courier')" label="fullName" v-model="newShipp.courier" :options="courier" ></v-select>    
                                </p>
                            </div> 
                        </div>
                        <div class="grid grid-cols-1">
                           <div  class="flex items-center justify-between"><span class="w-1/5 border-b dark:border-gray-600 md:w-1/4"></span> <span  @click="OpenPopupNewShipp('newCourier','open')" class="text-xs text-blue-600 font-bold cursor-pointer  uppercase dark:text-blue-500 hover:underline">Create new Courier</span> <span class="w-1/5 border-b dark:border-gray-600 md:w-1/4"></span></div>
                        </div>    
                      </div> 
                      <div class="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8 mt-10 mb-5">
                        <div class="grid grid-cols-1">
                            <div class="border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                    <p>
                                        <label for="Zone" class="bg-white text-gray-700 px-1">Zone <span class="text-blue-500">*</span></label>
                                    </p>
                                </div> 
                                <p>
                                    <v-select label="name" @search="serchZones($event,'zone')"  v-model="newShipp.zone" :options="zonesShipp" ></v-select>    
                                </p>
                            </div> 
                        </div>
                        <div class="grid grid-cols-1">
                           <div v-if="newShipp.courier" class="flex items-center justify-between"><span class="w-1/5 border-b dark:border-gray-600 md:w-1/4"></span> <span @click="OpenPopupNewShipp('newZone','open')" class="text-xs text-blue-600 font-bold cursor-pointer  uppercase dark:text-blue-500 hover:underline">Create new zone</span> <span class="w-1/5 border-b dark:border-gray-600 md:w-1/4"></span></div>
                        </div>    
                      </div> 
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8 mt-10 mb-5">
                        <div class="grid grid-cols-1">
                            <div class="border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                    <p>
                                        <label for="date" class="bg-white text-gray-700 px-1">Shippings date <span class="text-blue-500">*</span></label>
                                    </p>
                                </div> 
                                <p>
                                     <datetime-v2  v-model="newShipp.date" placeholder="Shipping date ..." input-class="py-2 text-xs px-2 outline-none block h-full w-full" ></datetime-v2>   
                                </p>
                            </div> 
                        </div>
                        <div class="grid grid-cols-1">
                           
                        </div>    
                      </div>
                    </div>
                    </div>
                    <div class="p-4 flex space-x-4">
                        <a href="#" @click="OpenPopupNewShipp('newShipp','close')" class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm">Cancel</a>
                        <a href="#" @click="EmitActionNewShipp('newShipp')" class="w-1/2 px-4 py-3 text-center text-blue-100 bg-blue-600 rounded-lg hover:bg-blue-700 hover:text-white font-bold text-sm">Confirme</a>
                    </div>
                </div>
            </vue-modal-2>     
            <!-- end  New shippings  shipping -->
             <!--Modal New zone Shipping -->
             <vue-modal-2 v-if="config.name=='shippings'"  name="newZone" :headerOptions="{title: 'New Zone'}" :noFooter="true" modalSize="lg" @on-close="OpenPopupNewShipp('newZone','close')">
                <div class="bg-white rounded-lg">
                    <div class="rounded-lg flex">
                    <div class="w-1/4 flex justify-center items-center">
                        <span class="w-16 h-16 bg-blue-600 text-white p-3 rounded-full"><i class="material-icons" style="font-size: 40px;">add_location</i></span>
                    </div>
                    <div class="w-full pr-4 mt-4">
                      <div class="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8">
                        <div class="grid grid-cols-1">
                            <div class="border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                    <p>
                                        <label for="Zone" class="bg-white text-gray-700 px-1">Zone name</label>
                                    </p>
                                </div> 
                                <p>
                                 <input type="text"  placeholder="Name zone ..." v-model="newZone.name" class="py-2 text-xs px-2 outline-none block h-full w-full"> 
                                </p>
                            </div> 
                        </div>
                        <div class="grid grid-cols-1">
                             <div class="border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                    <p>
                                        <label for="Country" class="bg-white text-gray-700 px-1">Country</label>
                                    </p>
                                </div> 
                                <p>  
                                    <v-select @input="setSelectedCountry" v-model="newZone.country" :options="options" label="name">
                                        <template slot="option" slot-scope="option">
                                        <img
                                            class="flag-img"
                                            :src="$f.getCountryCode(option.code)"
                                        />
                                        {{ option.name }}
                                        </template>
                                    </v-select>
                                </p>
                            </div> 
                        </div>    
                      </div> 
                    </div>
                    </div>
                    <div class="p-4 flex space-x-4">
                        <a href="#" @click="OpenPopupNewShipp('newZone','close')" class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm">Cancel</a>
                        <a href="#" @click="EmitActionNewShipp('newZone')" class="w-1/2 px-4 py-3 text-center text-blue-100 bg-blue-600 rounded-lg hover:bg-blue-700 hover:text-white font-bold text-sm">Confirme</a>
                    </div>
                </div>
            </vue-modal-2>     
            <!-- end  New shippings  shipping -->
            <!--Modal New courier Shipping -->
             <vue-modal-2 v-if="config.name=='shippings'"  name="newCourier" :headerOptions="{title: 'New Courier'}" :noFooter="true" modalSize="lg" @on-close="OpenPopupNewShipp('newCourier','close')">
                <div class="bg-white rounded-lg">
                    <div class="rounded-lg flex">
                    <div class="w-1/4 flex justify-center items-center">
                        <span class="w-16 h-16 bg-blue-600 text-white p-3 rounded-full"><i class="material-icons" style="font-size: 40px;">person_add</i></span>
                    </div>
                    <div class="w-full pr-4 mt-4">
                      <div class="grid grid-cols-1">
                           <div class="border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                    <p>
                                        <label for="fullname" class="bg-white text-gray-700 px-1">Full name</label>
                                    </p>
                                </div> 
                                <p>
                                    <input type="text"  v-model="newCourier.fullName" class="py-2 text-xs px-2 outline-none block h-full w-full"> 
                                </p>
                            </div> 
                      </div>
                       <div class="grid grid-cols-1 mt-5">
                            <div class="border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                    <p>
                                        <label for="Email" class="bg-white text-gray-700 px-1">Email</label>
                                    </p>
                                </div> 
                                <p>
                                 <input type="text" v-model="newCourier.email" class="py-2 text-xs px-2 outline-none block h-full w-full"> 
                                </p>
                            </div> 
                       </div> 
                    </div>
                    </div>
                    <div class="p-4 flex space-x-4">
                        <a href="#" @click="OpenPopupNewShipp('newCourier','close')" class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm">Cancel</a>
                        <a href="#" @click="EmitActionNewShipp('newCourier')" class="w-1/2 px-4 py-3 text-center text-blue-100 bg-blue-600 rounded-lg hover:bg-blue-700 hover:text-white font-bold text-sm">Confirme</a>
                    </div>
                </div>
            </vue-modal-2>     
            <!-- end  New courier  shipping -->
              <!--Modal Ndata new shippings -->
             <vue-modal-2 v-if="config.name=='shippings'"  name="newDataShipp" :headerOptions="{title: `Prepared Shippings (Prepared & Reprogrammed) (${$moment(newShipp.date).format('LL')}) : ${newShipp.shippings.length} orders`}" :noFooter="true" modalSize="xl" @on-close="OpenPopupNewShipp('newDataShipp','close')">
                <div class="bg-white rounded-lg mb-14">
                    <div v-if="showprogress && newShipp.tabId.length>0" class="k-progressss px-4 mb-4">
                        <k-progress 
                            active 
                            status="error" 
                            type="lump"
                            :border="false"
                            :color="['#40a9ff', '#5cdbd3', '#cf1322', '#722ed1']"
                            :percent="itemsShipp*100/newShipp.tabId.length" >
                        </k-progress>
                        <div class="flex items-center"><div class="font-mediummm">Updating ...</div><div class="text-xs text-gray-900 ml-auto">{{itemsShipp}} / {{newShipp.tabId.length}}</div></div>
                    </div>
                    <div class="flex flex-col border px-3 mx-3 p-4 rounded-lg bg-white">
                        <div class="flex flex-row">
                            <div class="flex w-full mb-5">
                                <input id="inputshipping"  @input="searchShippByTrack($event)" placeholder="Scan qr code here ..." v-model="searchTextShipp" type="search" autofill="off"  class="border-t  text-gray-700  text-xs border-b border-l border-r rounded-l-md rounded-r-md w-full focus:outline-none py-1 px-4">
                                <!--<button @click="searchNewShipp" ref="sendReplyNewShipp" class="bg-white rounded-r-md text-blue-500  border-t border-r border-b hover:opacity-75  px-3 focus:outline-none">
                                    <i class="py-1 material-icons">search</i> 
                                </button>-->
                            </div>
                        </div>
                        <div style="overflow-x: auto;">
                           <table class="min-w-full w-full">
                               <thead class="relative">
                                    <tr class="bg-gray-400 text-gray-600 uppercase text-sm leading-normal">
                                        <th class="px-3 w-10  py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider"><label class="text-lg text-teal-500 inline-flex justify-between items-center hover:bg-gray-200 px-2 py-2 rounded-lg cursor-pointer"><input type="checkbox" @click="selectAllCheckboxShipp($event)" class="form-checkbox checkallbboxShipp focus:outline-none focus:shadow-outline"></label></th>
                                        <th class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider"><span> Shipping Address </span></th>
                                        <th class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider"><span> Shipping Date </span></th>
                                        <th class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider"><span> Traking number </span></th>
                                        <th class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider"><span> Order </span></th>
                                        <th class="px-3 text-center py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider"><span> Status </span></th>
                                    </tr>
                                </thead>
                                <loading :active.sync="newShipp.loading" :is-full-page="fullPage"></loading>
                                <tbody>
                                 <tr  v-for="(item, index) in newShipp.shippings" :key="index" class="border-b border-gray-200 hover:bg-gray-100">
                                   <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300"><label class="text-lg text-teal-500 inline-flex justify-between items-center hover:bg-gray-200 px-2 py-2 rounded-lg cursor-pointer"><input type="checkbox"  @click="getRowDetailShipp(item, item._id)" :id="item._id" :date="item.date?item.date:''" :refund="item.refund?item.refund:''" :trackingNumber="item.trackingNumber?item.trackingNumber:''" :status="item.status?item.status:''" :orderobjet="item.order?JSON.stringify({id:item.order.id,totalPrice:item.order.totalPrice,teleConsultantConfirm:item.order.teleConsultantConfirm,seller:{_id:item.order.seller._id||item.order.seller},source:item.order.source,customer:item.order.customer,details:item.order.details.map( el => ({product: {_id:el.product._id,quantity:el.product.quantity}, quantity: el.quantity}) ) }):''" :order="item.order?item.order._id:''" :seller="(item.seller && item.seller.source)?item.seller.source:'nosource'" :class="'rowProduct-'+item._id" class="form-checkbox rowCheckboxShipp focus:outline-none focus:shadow-outline"></label></td>
                                   <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300"><div class="text-xs leading-5 capitalize rounded-full text-gray-900">{{exceptText(item.address)}}</div></td>
                                   <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300"><div class="text-xs leading-5 capitalize rounded-full text-gray-900">{{$moment(item.date).format('yyyy-MM-DD')}}</div></td>
                                   <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300"><div class="text-xs leading-5 capitalize rounded-full text-gray-900">{{item.trackingNumber}}</div></td>
                                   <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300"><div class="text-xs leading-5 capitalize rounded-full text-gray-900"><span v-if="item.order" class="font-bold mr-1 text-blue-600">{{item.order.details.length}} Products</span></div></td>
                                   <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300 text-center"><div class="text-xs leading-5 capitalize rounded-full text-gray-900"><button class="border capitalize rounded-full text-gray-600 h-8 text-xs px-8 bg-white hover:border-gray-500 focus:outline-none appearance-none" :style="item.status=='prepared'?'color: rgb(8, 194, 226); border-color: rgb(8, 194, 226)':'color: black; border-color: black'">{{item.status}}</button></div></td>
                                 </tr>
                                </tbody>
                           </table>
                            <div v-if="newShipp.shippings.length==0" class="bg-blue-100 py-8">
                                <span class="w-full flex justify-center text-center py-3 border-b border-gray-200 text-base">
                                     <img alt="..." class="w-20 ml-4" :src="imageScannerShipp"/>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="p-4 flex space-x-4 modal-footer">
                        <a href="#" @click="OpenPopupNewShipp('newDataShipp','close')" class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm">Cancel</a>
                        <a href="#" @click="EmitActionNewShipp('newDataShipp')" class="w-1/2 px-4 py-3 text-center text-blue-100 bg-blue-600 rounded-lg hover:bg-blue-700 hover:text-white font-bold text-sm relative loidingconfirm" :class="loadingdatashipp?'noselect':''"><loading :active.sync="loadingdatashipp" :is-full-page="fullPage"></loading> Confirme</a>
                    </div>
                </div>
            </vue-modal-2>     
            <!-- end  data new shippings  shipping -->
            <!--alert box if total shipp courier >29 -->
             <vue-modal-2 v-if="config.name=='shippings'"  name="alertCourier" :headerOptions="{title: 'ATTENTION'}" :noFooter="true"  modalSize="md" @on-close="OpenPopupNewShipp('alertCourier','close')">
                 <div class="bg-white rounded-lg">
                    <div class="w-full px-4 mt-4">
                        <div class="alert flex flex-row items-center bg-yellow-200 p-5 rounded border-b-2 border-yellow-300">
                            <div class="alert-icon flex items-center bg-yellow-100 border-2 border-yellow-500 justify-center h-10 w-10 flex-shrink-0 rounded-full">
                                <span class="text-yellow-500">
                                    <svg fill="currentColor" viewBox="0 0 20 20" class="h-6 w-6">
                                        <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                                    </svg>
                                </span>
                            </div>
                            <div v-if="newShipp.courier" class="alert-content ml-4">
                                <div class="alert-title font-semibold text-lg text-yellow-800">
                                    ATTENTION
                                </div>
                                <div class="alert-description text-sm font-semibold text-yellow-700">
                                    {{newShipp.courier.fullName||newShipp.courier.email}} a déjà {{newShipp.countShippCourier}} orders !
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-4 flex space-x-4">
                        <a href="#" @click="OpenPopupNewShipp('alertCourier','close')" class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm">Annuler</a>
                        <a href="#" @click="EmitActionNewShipp('alertCourier')" class="w-1/2 px-4 py-3 text-center text-blue-100 bg-blue-600 rounded-lg hover:bg-blue-700 hover:text-white font-bold text-sm">Suivant</a>
                    </div>
                </div>
            </vue-modal-2>     
             <!--/ alert box if total shipp courier >29 -->
             <vue-modal-2 v-if="config.name=='shippings'"  name="Echange" :headerOptions="{title: `Change order`}" :noFooter="true" modalSize="lg">
                <div class="rounded-lg mb-14">
                    <div class="flex flex-col border border-gray-500 px-3 mx-3 p-4 rounded-lg relative">
                        <div class="flex flex-row">
                            <div class="flex w-full mb-5">
                                <input id="inputshipping"  @input="searchShippByTrack_01($event)" placeholder="Scan qr code OR copier traking number here ..." v-model="searchTextShipp" type="search" autofill="off"  class="border-t  text-gray-700 border-gray-500  text-xs border-b border-l border-r rounded-l-md rounded-r-md w-full focus:outline-none py-1 px-4">
                                <!--<button @click="searchNewShipp" ref="sendReplyNewShipp" class="bg-white rounded-r-md text-blue-500  border-t border-r border-b hover:opacity-75  px-3 focus:outline-none">
                                    <i class="py-1 material-icons">search</i> 
                                </button>-->
                            </div>
                        </div>
                        <loading :active.sync="newShipp.loading" :is-full-page="fullPage"></loading>
                        <div v-if="newShipp.echange.data"  style="overflow-x: auto;">
                             <div class="grid lg:grid-cols-2 gap-6">
                                <div class="data-ss">
                                    <div class="row-data">
                                        <span class="title-1">Seller</span>
                                        <div class="content-1">{{newShipp.echange.data.orderObjet.seller.fullName}}</div>
                                    </div>
                                    <div class="row-data">
                                        <span class="title-1">Order ID</span>
                                        <div class="content-1">{{newShipp.echange.data.orderObjet.id}}</div>
                                    </div>
                                    <div class="row-data">
                                        <span class="title-1">Customer</span>
                                        <div class="content-1">{{newShipp.echange.data.orderObjet.customer.fullName}}</div>
                                        <div class="content-1">{{newShipp.echange.data.orderObjet.customer.phone}}</div>
                                    </div>
                                </div>
                                <div class="data-ss">
                                    <div class="row-data">
                                        <span class="title-1">Traking number</span>
                                        <div class="content-1">{{newShipp.echange.data.trackingNumber}}</div>
                                    </div>
                                    <div class="row-data">
                                        <span class="title-1">Shipping date</span>
                                        <div class="content-1">{{$moment(newShipp.echange.data.date).format('yyyy-MM-DD')}}</div>
                                    </div>
                                    <!-- <div class="row-data">
                                        <span class="title-1">Type</span>
                                        <div class="content-1 status" :style="colorStatus(newShipp.echange.data.type)">{{newShipp.echange.data.type}}</div>
                                    </div> -->
                                    <div class="row-data">
                                        <span class="title-1">Status</span>
                                        <div class="content-1 status" :style="colorStatus(newShipp.echange.data.status)">{{newShipp.echange.data.status}}</div>
                                    </div>
                                </div>
                                <div>

                                </div>
                             </div>
                             <div class="w-full data-ss">
                                <div class="header-1">
                                    <div class="content">
                                        <span class="title">Orders details</span>
                                        <div class="content-1">TotalPrice: {{newShipp.echange.data.orderObjet.totalPrice}} <sup v-if="idWharhouse">({{idWharhouse.currency}})</sup></div>
                                   </div>
                                </div>
                                <div class="header-table">
                                    <div class="xz84dc7"><div class="title">Product name</div></div>
                                    <div class="x8yj6t5"><div class="title">Quantity</div></div>
                                    <div class="x8yj6t5"><div class="title">total</div></div>
                                </div>
                                <div v-for="(item, index) in newShipp.echange.data.order.details" :key="index" class="header-table">
                                    <div class="xz84dc7"><div class="title title-1">{{item.product.name}}</div></div>
                                    <div class="x8yj6t5"><div class="title title-1">{{item.quantity}}</div></div>
                                    <div class="x8yj6t5"><div class="title title-1">{{item.quantity*item.unitPrice}}</div></div>
                                </div>
                             </div>
                        </div>  
                    </div>
                    <div class="p-4 flex space-x-4 modal-footer">
                        <a href="#" @click="OpenPopupNewShipp('Echange','close','Echange')" class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm">Cancel</a>
                        <a href="#" @click="EmitActionNewShipp('Echange')" class="w-1/2 px-4 py-3 text-center text-blue-100 bg-blue-600 rounded-lg hover:bg-blue-700 hover:text-white font-bold text-sm relative loidingconfirm" :class="newShipp.loading?'noselect':''"><loading :active.sync="newShipp.loading" :is-full-page="fullPage"></loading> Confirme Echange</a>
                    </div>
                </div>
            </vue-modal-2>     

             <!--Update qte order-->
             <vue-modal-2 v-if="config.name=='shippings'"  name="updateorders" :headerOptions="{title: `Update details order (id: ${'#'+$f.getIdbySplit(orderToUpdate.order?orderToUpdate.order.id:'')})`}" :noFooter="true" modalSize="lg">
                <div class="rounded-lg">
                    <div class="rounded-lg flex" style="margin-bottom: 90px;">
                    <div class="w-1/4 flex justify-center items-center">
                        <span class="w-16 h-16 bg-blue-600 text-white p-3 rounded-full"><i class="material-icons" style="font-size: 40px;">update</i></span>
                    </div>
                    <div class="w-full pr-4">

                        <div v-if="orderToUpdate.order" class="w-full data-ss">
                            <div class="header-1">
                                <div class="content content-2 border border-gray-700 border-dashed rounded min-w-125px py-3 px-4 mb-3">
                                    <span class="title">Orders details</span>
                                    <div class="content-1">TotalPrice: {{TotalPrice(orderToUpdate.order)}} <sup v-if="idWharhouse">({{idWharhouse.currency}})</sup></div>
                                </div>
                            </div>
                            <div class="header-table th-1 first">
                                <div class="xz84dc7z"><div class="title">Product name</div></div>
                                <div class="x8yj6t5z"><div class="title">UnitPrice</div></div>
                                <div class="x8yj6t5z"><div class="title">Quantity</div></div>
                                <div class="xz84dc7p"><div class="title"></div></div>
                            </div>
                            <div v-for="(item, index) in orderToUpdate.order.details" :key="index" class="header-table first">
                                <div class="xz84dc7z"><div class="title title-1">{{item.product.name}}</div></div>
                                <div class="x8yj6t5z"><div class="title title-1"> <div><input autocomplete="false" tabindex="0" min="0" type="number" v-model="item.unitPrice" class="border border-blue-600 py-2 text-xs px-2 outline-none block h-full w-full"/></div></div></div>
                                <div class="x8yj6t5z">
                                    <div class="title title-1 justify-center flex-col">
                                        <div class="flex space-x-6">
                                            <button :class="$colors.textPrimary" class="bg-blue-500 rounded-md w-6 h-6 flex items-center focus:outline-none" @click="addQuantity(index,orderToUpdate.order)"><span class="font-bold text-2xl text-white"><i class="material-icons mt-2">add</i></span></button>
                                            <span :class="$colors.textPrimary" class="text-gray-700 text-sm h-6 flex items-center quant-1 focus:outline-none"><input class="focus:outline-none w-12 text-center" type="text" v-model="item.quantity"/></span>
                                            <button :class="$colors.textPrimary" @click="removeQuantity(index,orderToUpdate.order)" class="bg-blue-500 quant-1 rounded-md w-6 h-6 text-white flex items-center focus:outline-none"><span class="font-bold text-2xl text-white mt-1"><i class="material-icons">remove</i></span></button>
                                        </div>
                                        <div class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"></div>
                                    </div>
                                </div>
                                <div class="xz84dc7p"><div v-if="orderToUpdate.order.details.length>1" style="justify-content: center;align-items: center;" class="title title-1"> <button @click="removeProduct(orderToUpdate.order, item)"  class="rounded-full flex focus:outline-none w-8 h-8"><i class="material-icons">delete</i></button></div></div>  
                            </div>
                        </div>
                      
                       
                    </div>
                    
                    </div>
                    <div class="p-4 flex space-x-4 modal-footer">
                        <a href="#" @click="closePopup('updateorders')" class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm" :class="loadingupdateorder?'noselect':''">Cancel</a>
                        <a href="#" @click="UpdateOrder()" class="w-1/2 px-4 py-3 text-center text-blue-100 bg-blue-600 rounded-lg hover:bg-green-700 hover:text-white font-bold text-sm loidingconfirm relative" :class="loadingupdateorder?'noselect':''"><loading :active.sync="loadingupdateorder" :is-full-page="fullPage"></loading>Confirme</a>
                    </div>
                </div>
            </vue-modal-2>   
              <!-- data Escel -->
            <dialog class="printingExcel" v-if="config.name=='orders'" >
                <modal-export-excel-orders :items="data" :idWharhouse="idWharhouse" :currentUser="currentUser" />
            </dialog>   
            <dialog class="printingExcel" v-if="config.name=='payments' || config.name=='expeditions'">
                <modal-export-excel-payments :type="config.name" :items="data" :idWharhouse="idWharhouse" :currentUser="currentUser" />
            </dialog>   
            <dialog class="printingExcel" v-if="config.name=='shippings'" >
                <modal-export-excel-shippings :items="data" :idWharhouse="idWharhouse" :currentUser="currentUser"/>
            </dialog>  
            <!-- / end dataExcel -->
             <!--Modal set service seller Shipping -->

                <!--Modal  Expedition multiwarehouse -->
            <vue-modal-2 v-if="config.name=='expeditions'" name="ModalChangeSetSettingsSeller" :headerOptions="{title: `Définir le warehouse pour chaque produit`}" :noFooter="true"  modalSize="lg" @on-close="$vm2.close('ModalChangeSetSettingsSeller')">
                <loading :active.sync="expeditionData.loading" :is-full-page="fullPage"></loading>
                 <div class="bg-white rounded-lg" style="margin-bottom: 60px;">

                    <div class="relative">
                        <div class="rounded-lg flex">
                            <div class="w-full p-4">
                                <div class="change-status border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                        <p>
                                            <label for="settings" class="bg-white text-gray-700 px-1">Country (warhousing)</label>
                                        </p>
                                    </div> 
                                   <p>
                                   <input v-if="expeditionData.country" type="text" disabled v-model="expeditionData.country" class="py-2 text-xs px-2 outline-none block h-full w-full">
                                  </p>
                                </div> 
                              <section class="warehouse" v-if="expeditionData.warhouseParent.exist">   
                                    <div class="flex my-5 items-center text-center">
                                        <hr class="border-gray-600 border-1 w-full rounded-md">
                                        <label class="block font-medium text-sm cursor-pointer text-green-500  w-full"><span class="font-medium text-base text-green-800 dark:text-green-200">Choisir warehouse</span> </label>
                                        <hr class="border-gray-600 border-1 w-full rounded-md">
                                    </div>
                                    <div class="bg-ww">
                                        <h2 class="text-sm font-bold truncate mb-5">Définir le warehouse pour chaque produit (<img v-if="idWharhouse" :src="idWharhouse.flag" class="h-4 w-5 blob inline-block" :alt="idWharhouse.country">)</h2> 
                                        <!-- <div class="w-full">
                                          <div v-for="it in checkWarehousingParent" :key="it._id"  :id="it._id" @click="activateWarehouse(it)" :class="{active: it.fullOf}" class="border border-gray-600 intro-y flex-1 box-1 cursor-pointer zoom-in p-2 mb-2 pl-10">
                                            <div class="check-left"><span class="feather-icon select-none relative"><svg :class="it.fullOf?'bg-green-500':'bg-gray-500'" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check p-1 w-5 h-5 text-white rounded-full shadow"><polyline points="20 6 9 17 4 12"></polyline></svg></span></div>
                                            <div class="text-sm font-bold text-left">{{it.name}} <span v-if="it.is_primary">(Principal)</span></div>
                                          </div>             
                                        </div> -->
                                       
                                           <div v-for="(item, index) in expeditionData.data.details" :key="index" :value="item._id" class="flex w-full space-x-12 h-auto py-1 px-8 rounded border border-gray-600 mb-2">
                                                <div>
                                                    <img
                                                    :alt="item.product.name"
                                                    :src="item.product.picture||'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'"
                                                    class="h-16 w-16 rounded-md mx-auto"
                                                    />
                                                </div>
                                                <div class="col-span-2 w-full">
                                                    <h3 class="text-gray-80">{{ item.product.name }}</h3>
                                                   <p>
                                                    <v-select  v-model="item.warehouseParent" :options="checkWarehousingParent" placeholder="Select warehouse" label="name" class="border border-gray-600">
                                                    <template slot="option" slot-scope="option">
                                                        {{ option.name }} <span v-if="option.is_primary">(Principal)</span>
                                                    </template>
                                                    </v-select>
                                                </p>
                                                   
                                                </div>
                                            </div>
                                    </div>
                              </section>  
                               
                           </div>
                           </div>    
                          
                         </div> 
                    
                </div>
                <div class="modal-footer  px-5 border0-t text-right">
                    <button @click="$vm2.close('ModalChangeSetSettingsSeller')" class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">Cancel</button>
                    <button  @click="confirmChangeExpedition" class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-green-500 py-2 px-8 items-center focus:outline-none md:float-right relative loidingconfirm" :disabled="expeditionData.loading"><loading :active.sync="expeditionData.loading" :is-full-page="fullPage"></loading>Confirm</button>
                </div>
            </vue-modal-2>  


           <!--double order-->
          <vue-modal-2 class="test"  name="ModalDouble" :headerOptions="{title: `Double orders (${paginateDouble.total-1 })`}" :noFooter="true" modalSize="xl" @on-close="$vm2.close('ModalDouble')">
            <div class="flex flex-col w-full h-auto p-5 pt-0">
                <div class="align-middle inline-block min-w-full overflow-hidden bg-white shadow-dashboard rounded-bl-lg rounded-br-lg" style="margin-bottom: 62px;">
                <table class="min-w-full">
                    <thead>
                        <tr>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left leading-4  text-green-600  tracking-wider">ID Order</th>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">Customer</th>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">Products</th>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">Total Price</th>
                             <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">Date</th>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">Status</th>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-right text-sm leading-4  text-green-600  tracking-wider">Action</th>
                            
                        </tr>
                    </thead>
                    <loading :active.sync="loadingDouble" :is-full-page="fullPage"></loading>
                    <tbody class="bg-white">
                        <tr v-for="(order,ind) in dataDouble" :key="ind">
                            <td class="border-t-2 border-gray-300 px-3 py-1">
                                <div class="flex items-center">
                                    <div>
                                        <div class="text-sm leading-5 text-gray-800">{{order.id}}</div>
                                    </div>
                                </div>
                            </td>
                            <td class="border-t-2 border-gray-300 px-3 py-1">
                                <div class="text-sm leading-5 siz12 text-blue-900">
                                  <div class="flex-grow-1">
                                    <h5 class="fs-14">{{order.customer.fullName}}</h5>
                                    <p class="badge badge-soft-success text-uppercase"><b style="background-color: #e8bc52;">{{order.customer.phone}}</b></p></div>
                                  
                                </div>
                            </td>
                            <td class="border-t-2 border-gray-300 px-3 py-1">
                                <div class="text-sm leading-5 text-blue-900"><b style="background-color: #e8bc52;">{{sumProduct(order.details)}}</b></div>
                            </td>
                            <td class="px-3 py-1 text-left border-t-2 border-gray-300 whitespace-no-wrap">
                                <div class="text-sm leading-5 text-blue-900">{{order.totalPrice}} <sup v-if="idWharhouse">{{idWharhouse.currency}}</sup> </div>
                            </td>
                            <td class="px-3 py-1 text-left border-t-2 border-gray-300 whitespace-no-wrap">
                                <div class="text-sm leading-5 text-blue-900"><b style="background-color: #e8bc52;">{{$moment(order.date).format('yyyy-MM-DD') }}</b></div>
                            </td>
                             <td class="border-t-2 border-gray-300 px-3 py-1">
                                <div class="text-sm leading-5 text-blue-900" v-bind:style="{color: order.status.name?order.status.color:'',borderColor: order.status.name?order.status.color:''}">{{order.status.name}}</div>
                            </td>
                            <td class="border-t-2 border-gray-300 px-3 py-1 text-right">
                               <router-link target="_blank" :to="{ path: `/orders/detail/${order._id}`}" class="text-sm leading-5 px-2 rounded-full text-xs text-blue-900 cursor-pointer font-medium"><i class="material-icons mx-2"> remove_red_eye</i></router-link>
                            </td>
                           
                        </tr>
                        </tbody> 
                    </table>

                      <!--pagination -->
                    <div class="p-1" v-if="paginateDouble.lastpage > 1" >
                        <div class="flex flex-col items-center mt-2">
                            <div-paginate :paginate="paginateDouble" @paginatation="paginatationDouble" />
                        </div>
                    </div>
                    <!--end pagination -->
                            
            </div>     
                
            </div>

            <div class="modal-footer px-5 border0-t text-right">
                <button @click="$vm2.close('ModalDouble')" class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">Cancel</button>
            </div>
          </vue-modal-2>    

             <!--Products not used-->
          <vue-modal-2 class="test" v-if="currentUser.type === 'Admin'"  name="ProductsNotUsed" :headerOptions="{title: `Products (${ProductNotUsed.paginate.total})`}" :noFooter="true" modalSize="xl" @on-close="$vm2.close('ProductsNotUsed')">

            <div class="flex flex-col w-full h-auto p-5 pt-0" style="margin-bottom: 62px;">
                
                  <div class="border-dashed border-4 border-blue-600 p-4">
                    <div class="grid grid-cols-3 gap-5">
                       <div  class="border seller-select h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p>
                                <label for="seller"  class="bg-white text-gray-700 px-1"> Seller <span :class="$colors.required">*</span></label>
                            </p>
                            </div>    
                            <p>
                                <v-select label="fullName" :disabled="ProductNotUsed.loading||ProductNotUsed.dataExcel.loading"  @search="getUsersDebance($event,'shipsen')" v-model="ProductNotUsed.seller" :options="sellers"></v-select>
                            </p>         
                        </div>  
                        <div class="border border-gray-500  hover:border-green-500  hover:border-green-500  focus-within:border-blue-500 flex flex-wrap items-stretch  relative  bg-white items-center rounded">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p>
                              <label for="currency" class="bg-white text-gray-700 px-1">Quantity InStock plus grand ou égal <span :class="$colors.required">*</span></label>
                            </p>
                          </div>
                          <div class="flex -mr-px justify-center p-1">
                            <span class="flex border border-black items-center leading-normal bg-white px-3 border-0 rounded rounded-r-none text-sm font-bold text-gray-600">Quantity</span>
                          </div>
                          <input type="number" :disabled="ProductNotUsed.loading||ProductNotUsed.dataExcel.loading"  v-model="ProductNotUsed.minQte" min="1" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-0 h-10 border-grey-light rounded rounded-l-none px-3 self-center relative outline-none">
                        </div>
                        <div class="w-full border border-gray-500  hover:border-green-500  hover:border-green-500  focus-within:border-blue-500 flex flex-wrap items-stretch  relative  bg-white items-center rounded">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p>
                              <label for="currency" class="bg-white text-gray-700 px-1">Derniers <span :class="$colors.required">*</span></label>
                            </p>
                          </div>
                          <div class="flex -mr-px justify-center p-1">
                            <span class="flex border border-black items-center leading-normal bg-white px-3 border-0 rounded rounded-r-none text-sm font-bold text-gray-600">Mois</span>
                          </div>
                          <v-select :disabled="ProductNotUsed.loading||ProductNotUsed.dataExcel.loading"  v-model="ProductNotUsed.minMois" :options="['1 mois','2 mois','3 mois','4 mois']" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-0 h-10 border-grey-light rounded rounded-l-none px-3 self-center relative outline-none"></v-select>
                        </div>
                    </div>
                   <div class="flex flex-row justify-center space-x-2 mt-2">
                    <button @click="ProductsNotUsed('confirm')" class="flex text-white rounded text-center bg-blue-500 py-2 px-10 items-center focus:outline-none relative loidingconfirm" :disabled="ProductNotUsed.loading||ProductNotUsed.dataExcel.loading"><loading :active.sync="ProductNotUsed.loading" :is-full-page="fullPage"></loading>Filter</button>
                    <button @click="exportToExcel('analyticsProducts')" v-if="ProductNotUsed.ProductNotExistInOrders.length>0 || ProductNotUsed.productsExistsInOrders.length>0" :disabled="ProductNotUsed.loading||ProductNotUsed.dataExcel.loading" class="btnn box flex items-center bg-green-300 text-gray-700 dark:text-gray-300"><svg  xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-file-text hidden sm:block w-4 h-4 mr-2 hidden sm:block w-4 h-4 mr-2"><path  d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline  points="14 2 14 8 20 8"></polyline><line  x1="16" y1="13" x2="8" y2="13"></line><line  x1="16" y1="17" x2="8" y2="17"></line><polyline  points="10 9 9 9 8 9"></polyline></svg>
                        <span v-if="ProductNotUsed.dataExcel.loading" class="inline-block loading-excel"> Exporting ({{ProductNotUsed.dataExcel.timer}}/ {{ProductNotUsed.paginate.total}}) <span>.</span><span>.</span><span>.</span> </span><span v-else>Export to Excel</span> 
                    </button>
                   </div>  
                  </div>

                  <div class="border-dashed border-4 border-blue-600 p-4 pt-1 mt-2"> 
                      <h4 class="mb-4 font-extrabold leading-none tracking-tight text-gray-700 dark:text-gray-600">Des produits  <span class="underline underline-offset-3 decoration-8 decoration-blue-400 dark:decoration-blue-600">qui n'ont aucune orders</span> dans cette periode sélectionnée</h4>
                      <div v-if="ProductNotUsed.loading" class="flex justify-center gap-2">
                            <div class="w-5 h-5 rounded-full animate-pulse bg-blue-600"></div>
                            <div class="w-5 h-5 rounded-full animate-pulse bg-blue-600"></div>
                            <div class="w-5 h-5 rounded-full animate-pulse bg-blue-600"></div>
                      </div>

                    <div v-if="ProductNotUsed.ProductNotExistInOrders.length>0" class="relative overflow-x-auto shadow-md sm:rounded-lg max-300">
                        <table class="w-full text-sm text-left rtl:text-right text-blue-100 dark:text-blue-100">
                            <thead class="text-xs text-white uppercase bg-blue-600 border-b border-blue-400 dark:text-white">
                                <tr>
                                    <th scope="col" class="px-6 py-3">
                                       Seller
                                    </th>
                                    <th scope="col" class="px-6 py-3">
                                        Product ID
                                    </th>
                                    <th scope="col" class="px-6 py-3">
                                        Product name
                                    </th>
                                    <th scope="col" class="px-6 py-3">
                                        Quantity inStock
                                    </th>
                                    <th scope="col" class="px-6 py-3">
                                        Nb Orders
                                    </th>
                                    <th scope="col" class="px-6 py-3">
                                        Date creation
                                    </th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in ProductNotUsed.ProductNotExistInOrders" :key="index" :value="item._id" class="bg-blue-600 border-b border-blue-400 hover:bg-blue-500">
                                    <th scope="row" class="px-2 py-1 font-medium text-blue-50 whitespace-nowrap dark:text-blue-100">
                                       {{item.seller}}
                                    </th>
                                    <td class="px-2 py-1">
                                        {{item.id}}
                                    </td>
                                    <td class="px-2 py-1">
                                        {{item.name}}
                                    </td>
                                    <td class="px-2 py-1">
                                        {{item.stock}}
                                    </td>
                                    <td class="px-2 py-1">
                                        0
                                    </td>
                                    <td class="px-2 py-1">
                                        {{$moment(item.createdAt).format('yyyy-MM-DD')}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                  </div>

                  <div class="border-dashed border-4 border-blue-600 p-4  pt-1 mt-2"> 
                        <h4 class="mb-4 font-extrabold leading-none tracking-tight text-gray-700 dark:text-gray-600">Des produits  <span class="underline underline-offset-3 decoration-8 decoration-blue-400 dark:decoration-blue-600">qui ont des orders</span> dans cette periode sélectionnée</h4>
                        <div v-if="ProductNotUsed.loading" class="flex justify-center gap-2">
                                <div class="w-5 h-5 rounded-full animate-pulse bg-blue-600"></div>
                                <div class="w-5 h-5 rounded-full animate-pulse bg-blue-600"></div>
                                <div class="w-5 h-5 rounded-full animate-pulse bg-blue-600"></div>
                        </div>
                        <div v-if="ProductNotUsed.productsExistsInOrders.length>0" class="relative overflow-x-auto shadow-md sm:rounded-lg max-300">
                        <table class="w-full text-sm text-left rtl:text-right text-blue-100 dark:text-blue-100">
                            <thead class="text-xs text-white uppercase bg-blue-600 border-b border-blue-400 dark:text-white">
                                <tr>
                                    <th scope="col" class="px-6 py-3">
                                        Seller
                                    </th>
                                    <th scope="col" class="px-6 py-3">
                                        Product ID
                                    </th>
                                    <th scope="col" class="px-6 py-3">
                                        Product name
                                    </th>
                                    <th scope="col" class="px-6 py-3">
                                        Quantity inStock
                                    </th>
                                    <th scope="col" class="px-6 py-3">
                                        Nb Orders
                                    </th>
                                    <th scope="col" class="px-6 py-3">
                                        Last Order created
                                    </th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in ProductNotUsed.productsExistsInOrders" :key="index" :value="item._id" class="bg-blue-600 border-b border-blue-400 hover:bg-blue-500">
                                    <th scope="row" class="px-2 py-1 font-medium text-blue-50 whitespace-nowrap dark:text-blue-100">
                                       {{ item.product?item.product.seller||'':''}}
                                    </th>
                                    <td class="px-2 py-1">
                                        {{ item.product?item.product.id||'':''}}
                                    </td>
                                    <td class="px-2 py-1">
                                        {{ item.product?item.product.name||'':''}}
                                    </td>
                                    <td class="px-2 py-1">
                                        {{ item.product?item.product.stock||'':''}}
                                    </td>
                                    <td class="px-2 py-1">
                                        {{item.count}}
                                    </td>
                                    <td class="px-2 py-1">
                                        {{item.orderIds?$moment(item.orderIds.date).format('yyyy-MM-DD'):''}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                  </div>
                   
                 
                   
            </div>

            <div class="modal-footer px-5 border0-t text-right productsnotused">
                  <!--pagination -->
                    <div class="inline-block float-left" v-if="ProductNotUsed.paginate.lastpage > 1" >
                        <div :class="[ProductNotUsed.loading?'noselect':'','flex flex-col items-center my-12']">
                            <div-paginate  :paginate="ProductNotUsed.paginate" @paginatation="paginatationProductAnalytics" />
                        </div>
                    </div>
                    <!--end pagination -->
                <button @click="$vm2.close('ProductsNotUsed')" class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">Close</button>
            </div>

          </vue-modal-2>    


        <vue-modal-2 name="ModalBulkUnreached" :headerOptions="{title: 'Bulk Reset Orders to Unreached'}" :noFooter="true" modalSize="md" @on-close="$vm2.close('ModalBulkUnreached')">
            <div class="p-6 bg-white rounded-lg">

                <div class="grid grid-cols-1 gap-8"> <!-- زدنا Gap كبير بيناتهم -->

                    <!-- Warehouse Info (Display Only) -->
                    <div class="border bg-gray-50 border-gray-200 relative rounded p-1 opacity-80">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p><label class="bg-white text-blue-600 font-bold px-1">Selected Warehouse</label></p>
                        </div>
                        <div class="p-3 flex items-center justify-between">
                            <div class="flex items-center">
                                <!-- Flag -->
                                <img v-if="idWharhouse && idWharhouse.flag" :src="idWharhouse.flag" class="h-5 w-7 rounded shadow-sm mr-3" />
                                <!-- Name -->
                                <span class="text-sm font-extrabold text-gray-800 uppercase">
                                    {{ idWharhouse ? idWharhouse.name : 'No Warehouse Selected' }}
                                </span>
                            </div>
                            <!-- Currency Badge -->
                            <span v-if="idWharhouse && idWharhouse.currency" class="bg-blue-100 text-blue-700 text-xs px-2 py-1 rounded-full font-bold">
                                {{ idWharhouse.currency }}
                            </span>
                        </div>
                    </div>

                    
                    <!-- Start Date -->
                    <div class="border hover:border-blue-400 focus-within:border-blue-500 transition-all duration-500 relative rounded p-1">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p><label class="bg-white text-gray-700 px-1">Start Date</label></p>
                        </div>
                        <div class="p-1">
                            <datetime-v2 v-model="bulkFilter.startDate" placeholder="Select Start Date" input-class="py-2 text-xs px-2 outline-none block h-full w-full"></datetime-v2>
                        </div>
                    </div>

                    <!-- End Date -->
                    <div class="border hover:border-blue-400 focus-within:border-blue-500 transition-all duration-500 relative rounded p-1">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p><label class="bg-white text-gray-700 px-1">End Date</label></p>
                        </div>
                        <div class="p-1">
                            <datetime-v2 v-model="bulkFilter.endDate" placeholder="Select End Date" input-class="py-2 text-xs px-2 outline-none block h-full w-full"></datetime-v2>
                        </div>
                    </div>

                    <!-- Order Sub-Type -->
                    <div class="border hover:border-blue-400 focus-within:border-blue-500 transition-all duration-500 relative rounded p-1">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p><label class="bg-white text-gray-700 px-1">Order Sub-Type</label></p>
                        </div>
                        <div class="p-1">
                            <v-select v-model="bulkFilter.subType" :options="['Pending Remind', 'Pending Unreached']" placeholder="Select Sub-type"></v-select>
                        </div>
                    </div>

                </div>

                <!-- Footer Buttons -->
                <div class="flex space-x-4 mt-12">
                    <button @click="$vm2.close('ModalBulkUnreached')" class="w-1/2 py-3 bg-gray-500 text-white rounded-lg font-bold text-sm hover:bg-gray-400 transition-all">Cancel</button>
                    <button @click="confirmBulkReset" :disabled="loadingBulk" class="w-1/2 py-3 bg-purple-600 text-white rounded-lg font-bold text-sm hover:bg-purple-700 transition-all relative loidingconfirm">
                        <loading :active.sync="loadingBulk" :is-full-page="false"></loading>
                        Confirm Reset
                    </button>
                </div>
            </div>
        </vue-modal-2>
             
        </div>          
    </div>
</template>

<!--  ************  -->
<script>
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import addFontNormal from '@/assets/fonts/WorkSans-normal';
import addFontBold from '@/assets/fonts/WorkSans-bold';
import button from './~/button.vue';
import imageScanner from "@/assets/scanner.png"
import spinner from "@/assets/spinner.gif";
import Swal from "sweetalert2";
    export default {
        props: {
            config: { required: true, type: Object},
            data:{ default: [] },
            element: {type: Object },
            loading:{required:false},
            CheckQteDefecteuseexist:{required:false},
            CheckQteReturnedexist:{required:false},
            CheckQteDefecteuseorderexist:{required:false},
            CheckExpeditionRecived:{required:false},  
            name: { type: String, default: "" },
            emailCurrentCall: { type: String, default: "" },
            paginate: { type: Object },
            statusOrder:{ type: Array },
            statusOrderToChange:{ type: Array },
            zones:{ type: Array },
            checkSousWrehouses:{ type: Array },
            limit:{ type: Number },
            statusExpedition:{ type: Array },
            statusShipp:{ type: Array },
            statusShippChange:{ type: Array },
            tabId:{ type: Array },
            typesShipp:{ type: Array },
            transports:{ type: Array },
            isFilterPaidOrCourier:{required:false},
            CourierInfo: {type: Object },
            ProcessingInfo: {type: Object },
            selectProduct:{type: Object },
            sellers:{ type: Array },
            products:{ type: Array },
            idWharhouse: { type: Object},
            currentUser: { type: Object},
            sous_idWharhouse: { type: String,default() {return null}},
            sous_warehouses: { type: Array,default() {return []}},
            producWarhouse:{type: Array },
            couriers:{ type: Array,default() {return []}},
            pendingSourcingsCount: { type: Number, default: 0 },
            myQuotesCount: { type: Number, default: 0 },
            acceptedCount: { type: Number, default: 0 },
        },
        data() {
            return {
                imageScannerShipp: imageScanner,
                spinner:spinner,
                open:false,
                openLimit:false,
                showprogress:false,
                Datadone:true,
                itemsShipp:0,
                openAnalytics:false,
                resonCancelled:'',
                statusTochange:'',
                shipping: {
                    address: "",
                    type: "normal",
                    date: "",
                    status:'queued',
                    orderObjet:{},
                    order:{ type: Object },
                    zone:{ type: Object },
                },
                shippingDate:"",
                shippingChange:{
                    type: "pendingchange",
                    date: '',
                    orderObjet:{},
                    status:'queued',
                    order:{ type: Object },
                    zone:{ type: Object },
                    courier:{ type: Object },
                },
                fullPage: false,
                loadingChange:false,
                filters: [],
                actions: [],
                newSeller: {},
                roles: [],
                categories: [],
              //  currentUser: {},
                courier:[],
                checkQte:false,
                custumerTest:"shipsen",
                ShippCode:"shipsen",
                ChangeQte:{
                    operation:'Addition',
                    stock:'inStock-total',
                    loading:false,
                    warehouse:null,
                    warhouseParent:null,
                    quantity:0
                },
                searchTextShipp:'',
                zonesShipp:[],
                loadingdatashipp:false,
                newShipp:{
                    zone:null,
                    courier:null,
                    date:null,
                    shippings:[],
                    tabId:[],
                    countShippCourier:0,
                    loading:false,
                    echange:{
                        data:null,
                    }
                },
                newZone:{
                    name:'',
                    country:null,
                },
                newCourier:{
                    fullName:'',
                    role:null,
                    type:'Courier',
                    email:null
                },
                typeoperations:['Addition','Subtraction'],
                typeostocks:['inStock', 'total','inStock-total'],
                IsAllzonesEqualse:false,
                options: this.$countries,
                couriersSamezone:[],
                loadingcreateShipp:false,
                limitdata:0,
                active_el:"",
                filters:{},
                //idWharhouse:null,
                dataExcel:[],
                orderToUpdate:{order:null},
                loadingupdateorder:false,
                expeditionData:{model:null,loading:false,data:{},country:null,warhouseParent:{exist:false,warehouse:null}},
                checkWarehousingParent:[],
                loadingDouble:false,
                dataDouble:[],
                paginateDouble: {total: 0,currentpage: 1,lastpage: 0,per_page: 0,},
               filterDouble:{},
               bulkFilter: {
                    startDate: null,
                    endDate: null,
                    subType: 'Pending Remind'
                },
                loadingBulk: false,
               ProductNotUsed:{dataExcel:{timer:0,loading:false,productsExistsInOrders:[],ProductNotExistInOrders:[]},loading:false,productsExistsInOrders:[],ProductNotExistInOrders:[],seller:null,minQte:1,minMois:'1 mois',paginate:{total: 0,currentpage: 1,lastpage: 0,per_page: 0}}
            };
        },
        async mounted() {
            //this.$store.dispatch("actionloadingpage",{loading:true});
           // await this.getUser();
           // await this.getwharhouseId();
            this.filters=this.$f.QueryStringToobject();
            if(this.filters && this.filters["limit"]) this.limitdata=this.filters["limit"];
           // this.$store.dispatch("actionloadingpage",{loading:false});

           console.log('checkSousWrehouses user-----',this.checkSousWrehouses)
        },
        computed: {
            warhouseSelected(){
                  return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['warehouses'])});
            },
        },
        watch: {
            'warhouseSelected': async function(oldVal, newVal) {
               // await this.getwharhouseId();
            },
            'tabId': async function(oldVal, newVal) {
               this.tabId=this.tabId;
            },
        },
        methods: {
            openBulkUnreachedModal() {
                this.$vm2.open('ModalBulkUnreached');
            },
            cleanUrl(url) {
                this.$router.replace({ 
                query: this.$route.query, 
                hash: '' 
                }).catch(err => {
                // كنحبسو الـ Error غير إيلا كانت بسبب NavigationDuplicated
                if (err.name !== 'NavigationDuplicated') {
                    throw err;
                }
                });
            },
            async confirmBulkReset() {
                if (!this.bulkFilter.startDate || !this.bulkFilter.endDate || !this.bulkFilter.subType) {
                    alert("Please fill all fields", "warning");
                    return;
                }

                 // 1. تأكد أن التواريخ موجودة
                if (!this.bulkFilter.startDate || !this.bulkFilter.endDate) {
                    alert("Please select both Start and End dates", "warning");
                    return;
                }

                // 2. تأكد أن تاريخ البداية ليس أكبر من تاريخ النهاية
                // استعمل moment لي ديجا عندك في الفروينت
                if (this.$moment(this.bulkFilter.startDate).isAfter(this.bulkFilter.endDate)) {
                    alert("Start Date cannot be after End Date!", "error");
                    return;
                }

                this.$confirm(`Are you sure you want to reset orders from ${this.$moment(this.bulkFilter.startDate).format('LL')} to ${this.$moment(this.bulkFilter.endDate).format('LL')}?`).then(async (res) => {
                    if (res) {
                        this.loadingBulk = true;
                        try {
                            const payload = {
                                bulkResetUnreached: true,
                                startDate: this.bulkFilter.startDate,
                                endDate: this.bulkFilter.endDate,
                                subType: this.bulkFilter.subType,
                                warehouse: this.idWharhouse._id
                            };
                            
                            const response = await this.$server.updateMany("orders", payload);
                            this.loadingBulk = false;
                            
                            if (response && response.ok) {
                                alert(`${response.nModified} orders updated successfully`, "success");
                                this.$vm2.close('ModalBulkUnreached');
                                await this.refresh();
                            } else {
                                alert(response || "Error occurred", "warning");
                            }
                        } catch (err) {
                            this.loadingBulk = false;
                            alert("Server error", "error");
                        }
                    }
                });
            },
            async ProductsNotUsed(type=null,filter={}){
               if(!type) this.$vm2.open('ProductsNotUsed');
               else{
                // this.ProductNotUsed.ProductNotExistInOrders=[];
                // this.ProductNotUsed.productsExistsInOrders=[];

                  if(!this.ProductNotUsed.minMois){
                       alert(`Please select last mois  !`, "warning");
                       return false;
                  }
                  if(this.ProductNotUsed.minQte && isNaN(this.ProductNotUsed.minQte)){
                       alert(`Check the Quantity, it must be a number !`, "warning");
                       return false;
                  }
                  if(!this.ProductNotUsed.minQte || (this.ProductNotUsed.minQte && !parseInt(this.ProductNotUsed.minQte))){
                       alert(`Please select Quantity !`, "warning");
                       return false;
                  }
                  console.log('filter ProductsNotUsed-----',filter)
                  let filters={ProductsNotUsed:true,seller:this.ProductNotUsed.seller?this.ProductNotUsed.seller._id||this.ProductNotUsed.seller:null,warehouse:this.idWharhouse._id,minQte:this.ProductNotUsed.minQte,minMois:this.ProductNotUsed.minMois};
                  if(filter.page){
                    filters.page=filter.page;
                    filters.totalData=this.ProductNotUsed.paginate.total;
                  }else{
                    this.ProductNotUsed.paginate.currentpage=1;
                    filters.page=1;
                  }
                  
                  this.ProductNotUsed.loading=true;
                  const {content:resPr}= await this.$server.search("products", filters);
                  console.log('resPr ProductsNotUsed-----',resPr)
                  this.ProductNotUsed.loading=false;
                 if(resPr && resPr.ProductNotExistInOrders){
                    this.ProductNotUsed.ProductNotExistInOrders=resPr.ProductNotExistInOrders;
                    this.ProductNotUsed.productsExistsInOrders=resPr.productsExistsInOrders;

                    this.ProductNotUsed.paginate.total = resPr.total;
                    this.ProductNotUsed.paginate.lastpage = resPr.last_page;
                    this.ProductNotUsed.paginate.per_page = resPr.per_page;
                    this.ProductNotUsed.paginate.currentpage = resPr.current_page;
                 }else{
                    this.ProductNotUsed.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}
                 }
                
               }
            },
            async exportToExcel(name){
                    var nameTable=name;
                    
                    var htmlstableProductNotExistInOrders = "",htmlsproductsExistsInOrders="";
                    var uri = 'data:application/vnd.ms-excel;base64,';
                    var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'; 
                    var base64 = function(s) {
                        return window.btoa(unescape(encodeURIComponent(s)))
                    };

                    var format = function(s, c) {
                        return s.replace(/{(\w+)}/g, function(m, p) {
                            return c[p];
                        })
                    };

                    let tableProductNotExistInOrders="";
                    let tableproductsExistsInOrders="";

                    this.ProductNotUsed.dataExcel.loading=true;
                    this.ProductNotUsed.dataExcel.data=[];
                    console.log('oook expp')
                    
                    let filtersP={totalData:this.ProductNotUsed.paginate.total,ProductsNotUsed:true,seller:this.ProductNotUsed.seller?this.ProductNotUsed.seller._id||this.ProductNotUsed.seller:null,warehouse:this.idWharhouse._id,minQte:this.ProductNotUsed.minQte,minMois:this.ProductNotUsed.minMois};
                    
                    var itemsCounts=400;
                    filtersP.limit=itemsCounts;
                    filtersP.page = 1;

                    var count = Math.ceil(this.ProductNotUsed.paginate.total/itemsCounts);
                    var close=false;
                   
                    console.log('total ----',this.ProductNotUsed.paginate.total)
                    console.log('count  ----',count)
                    for (var i = 0; i <count; i++) {
                        if(close) return;
                        //this.countDown(this.timer);
                        const {content:resAllshipp} = await this.$server.search(this.config.name,filtersP);
                       // console.log('resAllshipp export to excell ----',resAllshipp)
                         //return false
                        if(resAllshipp.ProductNotExistInOrders) {
                            this.ProductNotUsed.dataExcel.timer+=resAllshipp.ProductNotExistInOrders.length+resAllshipp.productsExistsInOrders.length;
                            filtersP.page++;
                            this.ProductNotUsed.dataExcel.ProductNotExistInOrders.push(...resAllshipp.ProductNotExistInOrders);
                            this.ProductNotUsed.dataExcel.productsExistsInOrders.push(...resAllshipp.productsExistsInOrders);
                        }else close=true  

                        if(close) {this.ProductNotUsed.dataExcel.timer=0;this.ProductNotUsed.dataExcel.loading=false;alert("An error occurred, please reload the page and try again !!", "error"); }
                    }

                   // const resAllshipp = await this.$server.search("shippings",filtersP);
                    if(this.ProductNotUsed.dataExcel.ProductNotExistInOrders.length>0) {
                        this.ProductNotUsed.dataExcel.timer=0;
                        console.log('dataExcel--------------',this.ProductNotUsed.dataExcel.ProductNotExistInOrders)

                        tableProductNotExistInOrders=`<table style="width: 100%;border-collapse: separate;text-indent: 0;border-spacing: 2px;">
                            <thead>
                                <tr>
                                    <th scope="col" class="px-6 py-3"> Seller </th> <th scope="col" class="px-6 py-3"> Product ID </th> <th scope="col" class="px-6 py-3"> Product name </th> <th scope="col" class="px-6 py-3"> Quantity inStock </th> <th scope="col" class="px-6 py-3"> Nb Orders </th> <th scope="col" class="px-6 py-3"> Date creation </th>
                                </tr> 
                            </thead>
                            <tbody>`;
                                
                            for (const item of this.ProductNotUsed.dataExcel.ProductNotExistInOrders) {
                                tableProductNotExistInOrders+= `
                                    <tr>
                                        <td width="250" style="font-weight: bold; border: 1px solid #4e504a;">${ item.seller }</td>
                                        <td width="250" style="font-weight: bold; border: 1px solid #4e504a;">${ item.id }</td>
                                        <td width="250" style="font-weight: bold; border: 1px solid #4e504a;">${ item.name }</td>
                                        <td width="250" style="font-weight: bold; border: 1px solid #4e504a;">${ item.stock }</td>
                                        <td width="250" style="font-weight: bold; border: 1px solid #4e504a;">${ 0 }</td>
                                        <td width="250" style="font-weight: bold; border: 1px solid #4e504a;">${ this.$moment(item.createdAt).format('yyyy-MM-DD') }</td>
                                    </tr>`;
                            }
                       
                            tableProductNotExistInOrders+= `</tbody></table>`;  
                        let parser = new DOMParser();
                        let doc = parser.parseFromString(tableProductNotExistInOrders, 'text/html');
                        tableProductNotExistInOrders=doc.body;
                        htmlstableProductNotExistInOrders =tableProductNotExistInOrders.outerHTML;
                        //console.log('html--------------',htmls)
                        var ctx = {
                            worksheet : 'Products_Not_Exist_In_Orders',
                            table : htmlstableProductNotExistInOrders
                        }

                        var link = document.createElement("a");
                        link.download = "Products_Not_Exist_In_Orders.xls";
                        link.href = uri + base64(format(template, ctx));
                        link.click();
                    }

                    if(this.ProductNotUsed.dataExcel.productsExistsInOrders.length>0) {
                        this.ProductNotUsed.dataExcel.timer=0;
                        console.log('dataExcel productsExistsInOrders--------------',this.ProductNotUsed.dataExcel.productsExistsInOrders)

                        tableproductsExistsInOrders=`<table style="width: 100%;border-collapse: separate;text-indent: 0;border-spacing: 2px;">
                            <thead>
                                <tr>
                                    <th scope="col" class="px-6 py-3"> Seller </th> <th scope="col" class="px-6 py-3"> Product ID </th> <th scope="col" class="px-6 py-3"> Product name </th> <th scope="col" class="px-6 py-3"> Quantity inStock </th> <th scope="col" class="px-6 py-3"> Nb Orders </th> <th scope="col" class="px-6 py-3"> Last Order created </th>
                                </tr> 
                            </thead>
                            <tbody>`;
                                
                            for (const item of this.ProductNotUsed.dataExcel.productsExistsInOrders) {
                                tableproductsExistsInOrders+= `
                                    <tr>
                                        <td width="250" style="font-weight: bold; border: 1px solid #4e504a;">${ item.product?item.product.seller||'':'' }</td>
                                        <td width="250" style="font-weight: bold; border: 1px solid #4e504a;">${ item.product?item.product.id||'':'' }</td>
                                        <td width="250" style="font-weight: bold; border: 1px solid #4e504a;">${ item.product?item.product.name||'':'' }</td>
                                        <td width="250" style="font-weight: bold; border: 1px solid #4e504a;">${  item.product?item.product.stock||'':''} </td>
                                        <td width="250" style="font-weight: bold; border: 1px solid #4e504a;">${ item.count }</td>
                                        <td width="250" style="font-weight: bold; border: 1px solid #4e504a;">${ item.orderIds?this.$moment(item.orderIds.date).format('yyyy-MM-DD'):'' }</td>
                                    </tr>`;
                            }
                       
                            tableproductsExistsInOrders+= `</tbody></table>`;  
                        let parser = new DOMParser();
                        let doc = parser.parseFromString(tableproductsExistsInOrders, 'text/html');
                        tableproductsExistsInOrders=doc.body;
                        htmlsproductsExistsInOrders =tableproductsExistsInOrders.outerHTML;
                        //console.log('html--------------',htmls)
                        var ctx = {
                            worksheet : 'Products_Exists_In_Orders',
                            table : htmlsproductsExistsInOrders
                        }

                        var link = document.createElement("a");
                        link.download = "Products_Exists_In_Orders.xls";
                        link.href = uri + base64(format(template, ctx));
                        link.click();
                    }

                    this.ProductNotUsed.dataExcel.loading=false;
                    

            },
            serchsellerFilter(){
                this.debounce(function(){
                //  console.log('serch______________',this.)
                },500)
            },
            activateWarehouse:function(el){
                console.log('el  1111',this.checkWarehousingParent)
                this.checkWarehousingParent.forEach(function (warehouse) {if (warehouse._id.toString() == el._id.toString()) warehouse.fullOf = true;else warehouse.fullOf = false;});
                this.expeditionData.warhouseParent.warehouse=el;
                console.log('el  222',this.checkWarehousingParent)
            },
            async confirmChangeExpedition(){
                
                if(this.expeditionData.warhouseParent.exist){
                    //check warehouse if select
                    for (let index = 0; index < this.expeditionData.data.details.length; index++) {
                        const expeditionLine = this.expeditionData.data.details[index];
                        if (!expeditionLine.warehouseParent) {
                            alert(`Warehouse est obligatoir pour ce produit : ${expeditionLine.product.name}`, "warning");
                            return false;
                            break;
                        }else expeditionLine.warehouseParentName=expeditionLine.warehouseParent.name||expeditionLine.warehouseParent;
                    }
                }
                console.log('dta--',this.expeditionData.data.details)
                // return false;
                this.expeditionData.loading=true;
                const data = await this.$server.update("expeditions",this.expeditionData.data);
                this.expeditionData.loading=false;
                if(data && data._id) {
                    this.expeditionData.warhouseParent={exist:false,warehouse:null},
                    this.$vm2.close('ModalChangeSetSettingsSeller');
                    this.closePopUpInformation(this.expeditionData.model);
                    alert("expeditions updated", "success");
                }else alert(data, "warning");
            },
            TotalPrice_01(data){
                let Total=0;
                    for (const element of data.details) {
                        Total+=element.unitPrice * element.quantity;
                    }
                    data.totalPrice=Total;
                    return Total;
             },
            addQuantity(index,data) {
                data.details[index].quantity++;
            },
            removeProduct(data, item) {
                this.$confirm("Are you sure you want to delete this product?").then(
                    async (res) => {
                        var index = data.details.findIndex(function(o){return o.product._id.toString() === item.product._id.toString();})
                        if (index !== -1) data.details.splice(index, 1);
                        alert(`Product deleted !`, "success");
                    }
                );
                },
            removeQuantity(index,data) {
                if (data.details[index].quantity <= 1) {
                } else data.details[index].quantity--;
            },
            TotalPrice(data=null){
                let Total=0;
                let dataOrder=null;
                if(data) dataOrder=data;
                else dataOrder=this.order;
                if(dataOrder && dataOrder._id){
                    for (const element of dataOrder.details) {
                        Total+=element.unitPrice * element.quantity;
                    }
                    dataOrder.totalPrice=Total;
                }
                return Total;
            },
            async ChangeQuantityOrder(data){
                // if(data.order.details.length>1) {
                //     alert('tu peux pas modifier cette order car contient des produit different', "warning");
                //     return false;
                // }
               console.log('ChangeQuantityOrder 1111----------',data)
            //    for (let i in data.order.details) {
            //         const editData = await this.$server.get("products", {id:data.order.details[i].product._id||data.order.details[i].product,});
            //         data.order.details[i].name=editData.content.name;
            //         data.order.details[i].picture=editData.content.picture
            //     }
               this.orderToUpdate=data;
               console.log('open--popup')
               this.openPopup('updateorders');
            },
            async UpdateOrder(){
                for (let i in this.orderToUpdate.order.details) {
                   if(!parseInt(this.orderToUpdate.order.details[i].quantity) || parseInt(this.orderToUpdate.order.details[i].quantity)==0){
                       alert('Quantité required !!!', "warning");
                       return false;
                   }
                }
                this.loadingupdateorder=true;
                console.log('ChangeQuantityOrder 2222----------',this.orderToUpdate)
                this.orderToUpdate['UpdateQteOrder']=true;
                this.orderToUpdate['country']=this.idWharhouse.country;
                const res= await this.$server.update("shippings", this.orderToUpdate);
                this.loadingupdateorder=false;
                console.log('res 2222----------',res)
                if (res && res._id) {
                    const index = this.data.findIndex(shipp => shipp._id.toString()===res._id.toString());
                    this.data[index].order.details= res.order.details;
                    this.data[index].orderObjet.totalPrice = res.order.totalPrice;
                    this.data[index].orderObjet.details=  res.order.details;
                     this.data[index].orderObjet.totalPrice = res.order.totalPrice;
                    alert('Quantite order updated', "success");
                    this.closePopup('updateorders','no_change');
                }else alert(res, "warning");
               

            },
            async closePopup(name,change=null){
                console.log('name----------',name)
               if(name=='updateorders' && this.orderToUpdate.order && this.orderToUpdate.order._id && !change) {
                   console.log('orderToUpdate--------',this.orderToUpdate)
                   this.loadingupdateorder=true;
                   const resOrder= await this.$server.get("orders",{id: this.orderToUpdate.order._id,PopulateProductOnly:true});
                   this.loadingupdateorder=false;
                   if(resOrder && resOrder.content && resOrder.content._id){
                       const index = this.data.findIndex(shipp => shipp._id.toString()===this.orderToUpdate._id.toString());
                       console.log('index--------',index)
                       this.data[index].order.details = resOrder.content.details;
                   } 
                }
                this.$vm2.close(name);
               // if(name=='updateorders')  this.orderToUpdate={order:null};
            },
            openPopup(name){
                this.$vm2.open(name);
            },
            sumProduct(data){
                let product="";
                for (let i in data) {
                    if(data[i].product && data[i].product.name) product+=data[i].product.name
                    if(data.length-1 != i) product+=" ,"; 
                }
                return product;
            },
            ProductNamesGroup(data){
                let product="";
                for (let i in data) {
                    product+=data[i].productName
                    if(data.length-1 != i) product+=" ,"; 
                }
                return product;
            },
            async getwharhouseId(){
                 await this.$store.dispatch('wharhouse/getwharhouseId',{country: this.warhouseSelected,}).then((res) => {this.idWharhouse=res;})
            }, 
            QuantityTotalProductOrderOnly(data){
                var qte=0;
                for (let i in data) {
                    qte+=data[i].quantity;
                }
                return qte;
            },
            activate:function(el){
                this.active_el = el;
            },
            searchShippByTrack_01: _.debounce(async function(e) {
                console.log('oooooooooooooooooooook',e.target.value)
                if (typeof this.searchTextShipp !== 'undefined' && this.searchTextShipp) {
                    this.newShipp.loading=true;
                    const res = await this.$server.get("shippings", { warehouse:this.idWharhouse._id,trackingNumber:this.searchTextShipp.trim().toUpperCase()});
                    console.log('res fin shipp',res)
                    this.newShipp.loading=false;
                    if(res && res.content && res.content._id) this.newShipp.echange.data=res.content;
                    else this.newShipp.echange.data=null;
                    this.searchTextShipp="";
                }
            }, 500),
            searchShippByTrack: _.debounce(async function(e) {
                console.log('oooooooooooooooooooook',e.target.value)
                  if (typeof this.searchTextShipp !== 'undefined' && this.searchTextShipp) {
                        const filters={
                            status:"preparedNewShipp",
                            date:this.newShipp.date,
                            warehouse:this.idWharhouse._id,
                            limit:500,
                            ids:this.searchTextShipp.trim().toUpperCase()
                        };
                    let index = this.newShipp.shippings.findIndex(element => element.trackingNumber === this.searchTextShipp); 
                    if (index == -1) {   
                        this.newShipp.loading=true;
                        const res = await this.$server.search("shippings", filters);
                         this.newShipp.loading=false;
                        if(res.content.results){
                            let indext = this.newShipp.shippings.findIndex(element => element.trackingNumber ===res.content.results[0].trackingNumber); 
                            let status=res.content.results[0].status;
                            if (indext == -1) {  
                                if(status == "prepared" || status == "reprogrammed"){
                                this.newShipp.shippings.push(res.content.results[0]);
                                this.searchTextShipp="";
                                }else{
                                    if(status == "queued") alert(`This order not prepared !`, "warning");
                                    else alert(`This order already shipped !`, "warning");
                                    return false;
                                }      
                            }                  
                        }else{
                              alert("Error shipping date !", "warning");  
                        }
                    }else{
                         this.searchTextShipp="";
                    }
               }
            // const filter = {
            //     limit:this.limit,
            //     name:e.target.value,
            //     };
            //     const res= await this.$server.find("users",filter);

            // if (res.content.results) this.sellers = res.content.results;
            // else this.sellers = [];
            }, 500),
            exceptText(text){
              if (text && text.length > 40) text = text.substring(0, 40) + "...";
               return text;
            },
            debounce(func, wait, immediate) {
                var timeout;
                return function() {
                var context = this, args = arguments;
                var later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                    if (callNow) func.apply(context, args);
                };
            },
            changedQte(event){
               this.checkQte=false;
               if(this.ChangeQte.operation=="Subtraction" &&  parseInt(this.selectProduct.quantity.inStock)< parseInt(this.ChangeQte.quantity)){
                   this.checkQte=true;
               }
               if(this.ChangeQte.operation=="Subtraction" && parseInt(this.selectProduct.quantity.total)< parseInt(this.ChangeQte.quantity)){
                   this.checkQte=true;
               }
            },
            async getUser() {
              const res = await this.$me;
               this.currentUser = res.content;
               console.log('user',this.currentUser.role.permissions)
            },
            async getCouriers() {
                const res = await this.$server.search("users",{ type: 'Courier', warehouses:this.idWharhouse._id, limit: 10});
                if (res.content.results) this.courier = res.content.results;
                else this.courier = [];
            },
            getUsersType: _.debounce(async function(name) {
                await this.$store.dispatch('wharhouse/searchUser',{type: "Courier",warhouse:this.idWharhouse._id,search:name}).then((res) => {
                    this.courier = res
                })
            }, 500), 
            getUsersDebance: _.debounce(async function(name) {
                console.log('name----',name)
                if(this.formData.warehouse){
                    await this.$store.dispatch('wharhouse/searchUser',{type: "Seller",warhouse:this.idWharhouse._id,search:name}).then((res) => {
                    this.sellers = res
                    })
                }
            }, 500), 
            async getRoleByName(name) {
                const result = await this.$server.get("roles",{ type: name });
                return result.content._id;
             },
             triggerSearchNewShipp(){
                this.$refs.sendReplyNewShipp.click();
             },
            async searchNewShipp(){
               if (typeof this.searchTextShipp !== 'undefined' && this.searchTextShipp) {
                        const filters={
                            status:"preparedNewShipp",
                            limit:500,
                            ids:this.searchTextShipp.replace(/;/g, ',').split(",")
                        };
                    this.newShipp.loading=true;
                    const res = await this.$server.search("shippings", filters);
                    this.newShipp.loading=false;
                    if(res.content.results){
                        this.newShipp.shippings=res.content.results;
                    }else this.newShipp.shippings=[];                  
               }
            },
            getRowDetailShipp(item, id){
                // console.log('item________________________',item)
                let itemInRow = this.tabId.filter(item => item.id === id);
                let isItemInRow = itemInRow.length > 0;
                    
                if (isItemInRow) { 
                    let pos = this.newShipp.tabId.map(function (e) {return e.id;}).indexOf(id);
                    this.newShipp.tabId.splice(pos, 1);
                } else {
                    this.newShipp.tabId.push({id:id,source:item.seller.source?item.seller.source:'nosource',order:item.order._id,date:item.date,refund:item.refund,trackingNumber:item.trackingNumber,status:item.status,orderobjet:JSON.stringify({id:item.order.id,totalPrice:item.order.totalPrice,teleConsultantConfirm:item.order.teleConsultantConfirm,seller:{_id:item.order.seller._id||item.order.seller},source:item.order.source,customer:item.order.customer,details:item.order.details.map( el => ({product: {_id:el.product._id,quantity:el.product.quantity}, quantity: el.quantity}) ) })});
                }
                if(this.newShipp.tabId.length === 0){
                    let columns = document.querySelectorAll('.checkallbboxShipp');
                    columns.forEach(column => {column.checked = false});
                }
            },
            selectAllCheckboxShipp($event){
                let columns = document.querySelectorAll('.rowCheckboxShipp');
                this.newShipp.tabId = [];
                if ($event.target.checked == true) {
                    columns.forEach(column => {
                        column.checked = true;             
                        this.newShipp.tabId.push({id:column.id,source:column.getAttribute('seller'),order:column.getAttribute('order'),status:column.getAttribute('status'),refund:column.getAttribute('refund'),trackingNumber:column.getAttribute('trackingNumber'),orderobjet:column.getAttribute('orderobjet')});
                    });
                } else {
                   columns.forEach(column => {column.checked = false});
                   this.newShipp.tabId = [];
                }
            },
            setSelectedCountry(contry) {
                if (contry) {
                    this.newZone.country = contry.name;
                } else {
                    this.newZone.country = null;
                }
            },
            isEmpty(value){
                if(value == null || value == "" || value == " ") return true;
                else return false;
            },
            async getCurrentCourierZone(){
                if(this.shipping._id && this.shipping.zone){
                    const filter = {
                        type: 'Courier',
                        zones:this.shipping.zone._id,
                        limit:2000,
                    };
                    const res = await this.$server.search("users",filter);
                    if (res.content.results) {
                        this.courier = res.content.results;
                    } else this.courier = [];
                }  
            }, 
            async getCouriersInSmaeZone(zone){
                const filter = {
                    type: 'Courier',
                    zones:zone,
                        limit:2000,
                };
                const res = await this.$server.search("users",filter);
                if (res.content.results) {
                    this.couriersSamezone = res.content.results;
                } else this.couriersSamezone = [];
            }, 
            async CheckDataShip(item){
              if (item._id) {
                const editData = await this.$server.get("shippings", {
                  order: item._id,
                }); 
                console.log(editData.content)
                if(editData.content._id){
                   this.shipping = editData.content;
                }else{
                    const nDate = new Date().toLocaleString('en-US', {timeZone: 'Africa/Abidjan'});
                    let newdate=new Date(nDate);
                    this.shipping={};
                    this.shipping.order=item._id;
                    this.shipping.seller=item.seller;
                    this.shipping.warehouse=item.warehouse._id||item.warehouse;
                    this.shipping.status="queued";
                }   
                 await this.getCurrentCourierZone();           
              }
            },
            async getCourierZone(zone){
                this.courier = [];
                const filter = {
                    type: 'Courier',
                    zones:zone._id
                };
                const res = await this.$server.search("users",filter);
                if (res.content.results) {
                    this.courier = res.content.results;
                } else this.courier = [];
            },
            async getZonesByCourier(courier){
                // if(courier){
                //     this.newCourier.courier=courier._id?courier._id:courier;
                //     const filter = {id: courier._id?courier._id:courier};
                //     const res = await this.$server.get("users", filter);
                //     if (res.content) {
                //        this.zonesShipp = res.content.zones;
                //     } else this.zonesShipp = [];
                // }else this.newCourier.courier=null; 
            },
             async getCourierZoneShipp(zone) {
                if(zone){
                    this.newCourier.zones=zone._id?zone._id:zone;
                    const filter = {
                        type: "Courier",
                        zones: zone._id?zone._id:zone,
                        limit:1000
                    };
                    const res = await this.$server.search("users", filter);
                    if (res.content.results) {
                       this.courier = res.content.results;
                    } else this.courier = [];
                }else{
                    this.newCourier.zones=[]; 
                }
            },
            formattedDate(date) {
                let format="yyyy-MM-DD HH:mm";
                if(this.config.name=="shippings" || this.config.name=="products" ) format="yyyy-MM-DD";
                var date=this.$moment(date).format(format);
                if(date=='Invalid date') return null;
                else return  date;
            },  
            async emitFunction(action,id,data){
               if(action==="delete") {
                   if(this.config.name == 'products'){
                     // const resExp = await this.$server.search("expeditions", {"details.product":id});
                      const resOrd = await this.$server.search("orders", {"details.product":id});
                        if(resOrd.content.results && resOrd.content.results.length>0) alert(`This product is already used in the system !`, "warning");
                        else this.remove(id);

                    }else if(this.config.name == 'warehouses'){
                       const resPr = await this.$server.get("products", {"details.warehouse":id});
                       const resOrd = await this.$server.get("orders", {"warehouse":id});
                       if(resPr.content._id || resOrd.content._id) alert(`This warehouse is already used in the system !`, "warning");
                       else this.remove(id);
                    }else{
                       this.remove(id);
                    }
                  
                }
               if(action==="print") {this.generatePdf(id,data);}
               if(action==="double") {
                  this.$vm2.open('ModalDouble');
                  this.filterDouble={'details.product':data.details[0].product._id,warehouse:data.warehouse._id||data.warehouse,phone:data.customer.phone,seller:data.seller._id||data.seller};
                  await this.getOrderDoubled(this.filterDouble);
               }
            },
            async getOrderDoubled(filter){
                this.loadingDouble=true;
               
                if(filter.page) this.filterDouble.page=filter.page;
                const res = await this.$server.search("orders",this.filterDouble);
                this.loadingDouble=false;
                if(res && res.content && res.content.results){
                    this.dataDouble=res.content.results;
                    this.paginateDouble.total = res.content.total;
                    this.paginateDouble.lastpage = res.content.last_page;
                    this.paginateDouble.per_page = res.content.per_page;
                    this.paginateDouble.currentpage = res.content.current_page;
                } else{
                    this.dataDouble=[];
                    this.paginateDouble={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}
                }
            },
            async paginatationDouble(direction) {
                var page = 0;
                if (direction == "next") {
                    page = ++this.paginate.currentpage;
                } else {
                    page = --this.paginate.currentpage;
                }
                this.filterDouble['page']=page;

                this.getOrderDoubled(this.filterDouble);
            },
            async paginatationProductAnalytics(direction) {
                var page = 0;
                if (direction == "next") {
                    page = ++this.ProductNotUsed.paginate.currentpage;
                } else {
                    page = --this.ProductNotUsed.paginate.currentpage;
                }

                this.ProductsNotUsed('confermation',{page:page});
            },
            colorStatus(status) {
                switch (status) {
                    case 'queued':
                        return "color: rgb(233 147 19); border-color: rgb(233 147 19);" 
                        break;
                    case 'prepared':
                        return  "color:rgb(58 217 18); border-color: rgb(58 217 18);" 
                        break;
                    case 'shipped':
                        return  "color:rgb(58 217 18); border-color: rgb(58 217 18);" 
                        break;
                    case 'received':
                        return  "color:rgb(58 217 18); border-color: rgb(58 217 18);" 
                        break;
                    case 'paid':
                        return  "color:rgb(34, 150, 78); border-color: rgb(34, 150, 78);" 
                        break;  
                    case 'refunded':
                        return  "color:rgb(150 15 227); border-color: rgb(150 15 227);" 
                        break;   
                    case 'reprogrammed':
                                return  "color:rgb(10 10 10); border-color: rgb(10 10 10);" 
                        break;     
                    case 'cancelled':
                        return "color: rgb(255, 5, 5); border-color: rgb(255, 5, 5);" 
                        break;
                }
           },
            paginatation: function (val) {
                this.$emit('paginatation',val);
            },
            refresh: function () {
                this.cleanUrl();
                this.$emit('refresh');
            },
            reset: function (val) {
                this.$emit('reset',val);
            },
            filtrer: function (val) {
                this.$emit('filtrer',val);
            },
            search: function (val,dataFilter=null) {
                this.$emit('search',val,dataFilter);
            },
            showSousTable: function (val) {
                this.$emit('showProducts',val);
            },
            CheckQteDefecteuse: function (val) {
                this.$emit('CheckQteDefecteuse',val);
            },
            CheckQteReturned: function (val) {
                this.$emit('CheckQteReturned',val);
            },
            CheckQteDefecteuseOrder: function (val) {
                this.$emit('CheckQteDefecteuseOrder',val);
            },
            
            CheckQteSentExist: function (val) {
               this.$emit('CheckQteSentExist',val);
            }, 
            generateListPdf: function () {
                this.$emit('generateListPdf');
            },
            downloadAnalytics: function () {
                this.$emit('downloadAnalytics');
            },
            Changelimit: function (val) {
                this.openLimit=false;
                this.$emit('Changelimit',val);
            },
            downloadCsv: function () {
                 //this.dataExcel=[];
                if(this.config.name=='orders' || this.config.name=='shippings' || this.config.name=='payments' || this.config.name=='expeditions') {
                    //this.dataExcel=this.data;
                    //this.$emit('downloadOrders')
                        var nameTable="shippings";
                        if(this.config.name=='orders') nameTable="orders";
                        if(this.config.name=='payments') nameTable="payments";
                        if(this.config.name=='expeditions') nameTable="expeditions";
                         console.log('pppp-------',nameTable)
                        var htmls = "";
                        var uri = 'data:application/vnd.ms-excel;base64,';
                        var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'; 
                        var base64 = function(s) {
                            return window.btoa(unescape(encodeURIComponent(s)))
                        };

                        var format = function(s, c) {
                            return s.replace(/{(\w+)}/g, function(m, p) {
                                return c[p];
                            })
                        };
                        const table =document.getElementById("p-table");
                        htmls =table.outerHTML
                        var ctx = {
                            worksheet : nameTable,
                            table : htmls
                        }

                        var link = document.createElement("a");
                        link.download = nameTable+".xls";
                        link.href = uri + base64(format(template, ctx));
                        link.click();
                };
                //if(this.config.name=='shippings') this.$emit('downloadShippings');
                if(this.config.name=='stockHistories') this.$emit('downloadStocks');
            },
            showPrConfirmOperationUpdateoducts: function (data,index) {
                this.$emit('ConfirmOperationUpdate',val);
            },
            selectAllCheckbox: function ($event) {
                this.$emit('selectAllCheckbox',$event);
            },
            getRowDetail: function (data,id) {
                this.$emit('getRowDetail',data,id);
            },
            emtyTabId: function () {
                this.$emit('emtyTabId');
            },
            async EmitMethodAction(action){
              if(action=="addPay") this.$router.push('/payments/new');
              if(action=="printdInvoice") this.generatePdf();
              if(action=="print") this.generateListPdf();
              if(action=="changestatus") this.OpenClosePopupModal('open');
              if(action=="printdDelivry") this.generatePdf();
              if(action=="addPrd") this.$router.push('/products/new');
              if(action=="addqte") {this.OpenClosePopupModal('open');}
              if(action=="deleteOrders") {
                 if (this.tabId.length  > 0 ) {
                        if(this.config.name=="orders"){
                             this.$confirm("Are you sure to delete this orders ?").then(async (res) => {
                                 if(res){
                                    console.log('tab id====',this.tabId)
                                    const data = {ids:this.tabId} 
                                    const ress = await this.$server.deleteMany("orders", data);
                                    if(ress) {await this.refresh(); alert("delete orders", "success"); this.emtyTabId(); }
                              }
                           }); 
                        }
                       
                    }else alert(`No ${this.config.name} selected !`, "warning");
              }
              if(action=="MarkUnreached") {
             
                if(this.config.name=="orders"){

                    Swal.fire({
                        title: "Saisissez le nombre d'appels à passer en statut Unreached",
                        input: "number",
                        inputPlaceholder: "Nombre d'appels",
                        showCancelButton: true,
                        confirmButtonText: "OK",
                        inputValidator: (value) => {
                            const num = Number(value);

                            if (!value || value.trim() === "" || Number.isNaN(num)) {
                                return "Nombre d'appels is required";
                            }

                            if (num <= 2) {
                                return "Le nombre doit être supérieur à 2";
                            }

                            return null;
                        },
                        }).then(async (result) => {
                        if (result.isConfirmed) {
                            console.log("Motif:", result.value);
                            // Do something with result.value
                            this.loadingChange = true;
                            const res = await this.$server.updateMany(this.config.name, { MarkUnreached:true, nbAppel: result.value, warehouse: this.idWharhouse._id });
                            this.loadingChange = false;
                            console.log("res:", res);

                            if(res && res.ok) return alert("Status updated", "success"); 
                            else return alert(res, "warning");  
                        }
                        });
                }
                       
                   
              }
            },
            async UpdateStatus(data){
                    this.loadingChange = true;
                    this.itemsShipp=0;
                    this.showprogress = true;
                    this.Datadone=true;
                    var itemsCounts=50;
                    var count = Math.ceil(data.ids.length/itemsCounts);
                    var close=false;
                    
                    for (var i = 0; i < count; i++) {
                                if(close) return;
                                var s= data.ids.slice(i*itemsCounts,i*itemsCounts + itemsCounts)
                                const datau = {
                                    ids:s,
                                    status:this.statusTochange,
                                    warehouse:this.idWharhouse,
                                    country:this.idWharhouse.country,
                                    comment:data.comment?data.comment:null,
                                    warehouseParent:data.warehouseParent?data.warehouseParent:null
                                } 
                                console.time("update many "+this.config.name); 
                                const res = await this.$server.updateMany(this.config.name, datau);
                                console.timeEnd("update many "+this.config.name); 
                                //console.log(i,Date.now())
                                if(res) this.itemsShipp+=s.length;
                                else {
                                    console.log('problemoooooooo')
                                    this.Datadone=false;
                                    close=true  
                                }
                                if(this.itemsShipp == data.ids.length) {
                                    this.loadingChange = false;
                                    this.itemsShipp=0;
                                    console.log('update many good',this.tabId.length)
                                    this.open = false;
                                    this.showprogress = false;
                                    this.statusTochange="";
                                    this.emtyTabId();
                                    console.log('after update many good',this.tabId.length)
                                    this.OpenClosePopupModal('close');
                                    await this.refresh();
                                   if(res.length==0 || (res && res.ok)) {this.resonCancelled="";alert(this.config.name+" updated", "success"); } 
                                   else alert(res, "warning");  
                                }
                                if(close){
                                    this.open = false;
                                    this.itemsShipp=0;
                                    this.loadingChange = false;
                                    this.showprogress = false;
                                    this.resonCancelled="";
                                     console.log('update many noot good',this.tabId.length)
                                    this.emtyTabId();
                                    console.log('after update many good',this.tabId.length)
                                    await this.refresh();
                                    this.OpenClosePopupModal('close');
                                    alert("An error occurred, please reload the page and try again !!", "error");  
                                }
                               
                    }
            },
            async confirmChange(){
               
                
                if (this.statusTochange == "") {
                    alert(`No status selected`, "warning");
                    return false;
                }else{
                    
                    if(this.statusTochange == 'cancelled' && !this.resonCancelled){
                        alert(`Reason cancelled required`, "warning");
                        return false;
                    }

                    let data = {
                        ids:this.tabId,
                        status:this.statusTochange,
                     } 


                    if(this.sous_idWharhouse && this.sous_warehouses.length>0 && ['cancelled','paid'].indexOf(this.statusTochange) != -1){
                        if(this.sous_idWharhouse=='all'){
                            alert(`Veuillez sélectionner un sous-warehouse pas All`, "warning");
                            return false;
                        }else data.warehouseParent=this.sous_idWharhouse;
                    } 
                   
                    if(this.statusTochange == 'cancelled') data.comment=this.resonCancelled;
                    this.$confirm(`You are sure to do this action, Total ${this.config.name} to ${this.statusTochange} : ${this.tabId.length}`).then(async (res) => {
                        if (res) await this.UpdateStatus(data);
                    });
                   
                }
            },
            async confirmChangeQte(){
               // this.loading = true;
                this.ChangeQte.warehouse=this.idWharhouse;
                const data = {
                    _id:this.tabId[0],
                    actionInstock:this.ChangeQte
                }  
                if(parseInt(this.ChangeQte.quantity)==0){
                    alert('Quantity must be greater than zero !', "warning");  
                    return false;
                } 
                if(this.expeditionData.warhouseParent.exist && !this.expeditionData.warhouseParent.warehouse){
                    alert("Warehouse est obligatoir", "warning");
                    return false;
                }
              //  console.log('data_______________',data) 
                if(this.expeditionData.warhouseParent.exist) this.ChangeQte.warhouseParent=this.expeditionData.warhouseParent.warehouse;
                this.ChangeQte.loading=true;
                const res = await this.$server.update("products", data);
                console.log('res---------',res)
                this.ChangeQte.loading=false;
                if (res && res.newProduct) {
                    //this.loading = false;
                    this.expeditionData.warhouseParent={exist:false,warehouse:null},
                    this.ChangeQte={
                        operation:'Addition',
                        stock:'inStock-total',
                        loading:false,
                        warehouse:null,
                        warhouseParent:null,
                        quantity:0
                    };
                    this.emtyTabId();
                    this.OpenClosePopupModal('close');
                    await this.refresh();
                    alert("Product quantite updated", "success");  
                }else alert(res, "warning");  
                
            },
           async OpenClosePopupModal(action,type=null){
               
                let modal_id = "ModalChangeStatus";
                if(this.config.name=="products") modal_id = "ModalChangeQte";
                if(action === 'open') {
                    if (this.tabId.length  > 0 ) {
                        console.log('this.tabId------lenght---------',this.tabId.length)
                        console.log('this.tabId----------------',this.tabId)
                        console.log('modal_id----------------',modal_id)
                        this.$vm2.open(modal_id);
                        if(this.config.name=="products" && modal_id==="ModalChangeQte"){
                            const resW = await this.$server.search("warehouses", { country: this.idWharhouse.country,all:true,limit:100}); 
                            console.log('resW--------------',resW)
                            if(resW.content && resW.content.results) {
                                this.checkWarehousingParent=resW.content.results.sort((a,b) => (a._id > b._id) ? 1 : ((b._id > a._id) ? -1 : 0));
                                this.checkWarehousingParent.forEach(x => { x.fullOf=false; });
                            }else this.checkWarehousingParent=[];
                            if(this.checkWarehousingParent.length>1) this.expeditionData.warhouseParent.exist=true;
                        }
                    }else {alert(`No ${this.config.name} selected !`, "warning")};
                } else  {
                    if(type=="changestatus") this.emtyTabId();
                    this.$vm2.close(modal_id);
                }
            },

            statusToUpdate(data) {
                let dataCheck=false;
          
                if(this.currentUser.type === 'Seller' && this.currentUser.statusToUpdate.length>0){
                    console.log('data status-----',data.status.name)
                    let CurrentStatus=data.status.name;
                    const getFromSatusCaChange=this.currentUser.statusToUpdate.map(el => el.split('->')[0]);
                    if(getFromSatusCaChange.find(el=> el.toLowerCase() === CurrentStatus.toLowerCase())) dataCheck=true;

                    console.log('data dataCheck-----',dataCheck)
                }else{
                    if(['Admin','Administrateur','TeleConsultant','CallenterManager','Accountant'].includes(this.currentUser.type))  dataCheck=true;
                }

                return dataCheck;
            },
           
            async ShowPopUpInformation(index,status=null,data=null) {
                 if(this.config.name=="statusHistories") return false;
                if(this.config.name=="shippings"){
                     this.CheckQteDefecteuse(data);
                     this.CheckQteReturned(data);
                     if(this.currentUser.type=='Courier' && (status=="received" || status=="cancelled")){
                        return false;
                     }
                    if(this.currentUser.type=='StockManager' && (status=="received" || status=="shipped" || status=="cancelled")){
                       return false;
                     }
                    if(this.currentUser.type=='Accountant' && (status!="prepared" && status!="shipped" && status!="reprogrammed")){
                          return false;
                    }
                     if(this.currentUser.type=='Seller'){
                          return false;
                    }
                }
               if(this.config.name=='expeditions'){
                   this.CheckQteSentExist(data);
                  if(this.currentUser.type!='Admin' && this.currentUser.type !='Administrateur' && this.currentUser.type!='Courier' && this.currentUser.type!='StockManager'){
                    return false;
                  }
               } 
               if(this.config.name=='refunds'){
                    if(this.currentUser.type!='Admin' && this.currentUser.type !='Administrateur'){
                        return false;
                    }
                    if(this.currentUser.type ==='Administrateur' && status!="pending"){
                       return false;
                    }
               }
              if(this.config.name=='sourcings'){
                    if(this.currentUser.type!='Admin' && this.currentUser.type !='Administrateur'){
                        return false;
                     }
               }
                if(this.config.name=='payments'){
                    if(this.currentUser.type!='Admin' && this.currentUser.type !='Administrateur'){
                        return false;
                     }
               }   
               if(this.config.name=='orders'){
                    console.log('order----------',this.currentUser.type)
                    console.log('status to upp----------',this.statusToUpdate(data))
                   // if(!['Admin','Administrateur','TeleConsultant','CallenterManager','Accountant'].includes(this.currentUser.type))  return false;
                    if(!this.statusToUpdate(data)) return false;
                    this.CheckQteDefecteuseOrder(data);
                    await this.CheckDataShip(data);  
               }      
                // await this.assign(index);
                let modal_id = "modal1_" + index;
                console.log(modal_id);
                this.$vm2.open(modal_id);
            },
            async UpdateShipping(dataToEdit, index){
              if(this.config.name=="shippings") {
                dataToEdit.date_1=dataToEdit.date;
              }
                delete dataToEdit.seller;
                this.loadingdatashipp=true;
               // dataToEdit.date=this.$moment(new Date('2023-03-09')).format('YYYY-MM-DD[T00:00:00.000Z]');
                const  data = await this.$server.update(this.config.name, dataToEdit);
                  this.loadingdatashipp=false;   
                if (data && data._id) {
                    this.closePopUpInformation(index);
                    this.cleanUrl();
                    alert(this.config.title+" updated", "success");
                }else alert(data, "warning");  
            },
            async ConfirmOperationUpdate(dataToEdit, index) {
              //  if(this.config.name=="shippings") console.log('dataToEdit date shipp',dataToEdit.date) 
                if(this.config.name=="shippings" || this.config.name=="orders")  dataToEdit.country=this.idWharhouse.country;
                if(this.config.name=="shippings"){  
                     this.$confirm(`Are you sure to update this shipping (status : ${dataToEdit.status})`).then(async (res) => {
                            if (res) {         
                                 if(dataToEdit.status === 'cancelled' && !dataToEdit.comment) {alert("Motif d'annulation requis !!", "warning");return false}        
                                if(this.currentUser.type == 'Accountant'){
                                    console.log('data_________________',dataToEdit);
                                    
                                    if(this.active_el){
                                        if(dataToEdit.status === 'cancelled' && !dataToEdit.comment) {alert("Motif d'annulation requis !!", "warning");return false}
                                        this.$confirm("This order is "+dataToEdit.status).then(async (res) => {
                                            if (res) {
                                                if(dataToEdit.status != 'reprogrammed') delete dataToEdit.date;
                                                else dataToEdit.courier=null;
                                                this.UpdateShipping(dataToEdit, index);
                                            }
                                        });
                                    }else  this.closePopUpInformation(index);
                                }else {
                                    this.UpdateShipping(dataToEdit, index);
                                }
                            }
    
                    }); 
                }else if(this.config.name=="refunds" && dataToEdit.status=="effectue"){
                    if (!dataToEdit.date){
                         alert("Shipping date required !! ", "warning");
                         return false
                    }
                    this.$confirm("Are you sure ?").then(async (res) => {
                        if (res) {
                            const data_refund = await this.$server.update("refunds", dataToEdit);
                            if (data_refund) {
                                if (data_refund.ObjetDetails) alert('Refund updated', "success");    
                                if (data_refund.trackingNumber) alert("Shipping created for this refund !", "success");   
                                this.closePopUpInformation(index); 
                            }
                        }
                    });                  
                
                }else if(this.config.name=="sourcings" && dataToEdit.status=="accepted"){
                    if (!dataToEdit.provider.email){
                         alert("Provider email required !! ", "warning");
                         return false
                    }
                    this.$confirm("Are you sure ?").then(async (res) => {
                        if (res) {
                            const data = await this.$server.update(this.config.name, dataToEdit);
                                if (data && data._id) {
                                    this.closePopUpInformation(index);
                                    alert(this.config.title+" updated", "success");
                                }else alert(data, "warning");
                            }
                    });                  
                
                }else if(this.config.name=="expeditions" && dataToEdit.status=="received"){
                    if (!dataToEdit.arrivalDate || !dataToEdit.fees){
                           let mess="Arrival Date required !!";
                           if(!dataToEdit.fees) mess="Expedition Fees !!";
                           alert(mess, "warning");
                         return false
                    }
                    if(this.config.name=="expeditions"){
                        this.loadingcreateShipp=true;
                        // const resW = await this.$server.search("warehouses", { country: dataToEdit.warehouse.country,all:true,limit:100}); 
                        // if(resW.content && resW.content.results) {
                        //     this.checkWarehousingParent=resW.content.results.sort((a,b) => (a._id > b._id) ? 1 : ((b._id > a._id) ? -1 : 0));
                        //     this.checkWarehousingParent.forEach(x => { x.fullOf=false; });
                        // }else this.checkWarehousingParent=[];
                        // console.log('checkWarehousingParent-----',this.checkWarehousingParent)
                        // if(this.checkWarehousingParent.length>1){
                        //     this.expeditionData.warhouseParent.exist=true;
                        //     this.expeditionData.country=dataToEdit.warehouse.name;
                        //     this.expeditionData.data=dataToEdit;
                        //     this.expeditionData.model=index;
                        //     this.$vm2.open('ModalChangeSetSettingsSeller');
                        //     let exist=false;
                        //     dataToEdit.details.forEach(function (element) {
                        //         if(element.warehouseParentName && element.warehouseParent && !element.warehouseParent._id){
                        //             exist=true;
                        //             element.warehouseParent={_id:element.warehouseParent,name:element.warehouseParentName}
                        //         }
                        //     });
                        //     if(exist){
                        //         const indexPP = this.data.findIndex(expedition => expedition._id.toString() ===  dataToEdit._id.toString());
                        //         if(indexPP != -1) this.data[indexPP].details = dataToEdit.details;
                        //     }
                            
                        //     this.loadingcreateShipp=false;
                        //     return false
                        // }    
                    }     
                    this.$confirm("Are you sure ?").then(async (res) => {
                        if (res) {
                            this.loadingdatashipp=true;
                            const data = await this.$server.update(this.config.name, dataToEdit);
                            this.loadingdatashipp=false;
                                if (data && data._id) {
                                    this.closePopUpInformation(index);
                                    alert(this.config.title+" updated", "success");
                                }else alert(data, "warning");
                            }
                    });                  
                
                }else if(this.config.name=="payments" && dataToEdit.status=="processed"){
                    if (!dataToEdit.date){
                         alert("Date payement required !! ", "warning");
                         return false
                    }
                    const dataP = await this.$server.update("payments", dataToEdit);
                    if (dataP){
                        alert('Payments updated', "success");    
                        this.closePopUpInformation(index);
                    }else alert("An error occurred, please reload the page and try again !!", "error");                     
                
                }else if(this.config.name=="orders" && dataToEdit.status.name && dataToEdit.status.name=="Confirmed"){
                    this.loadingcreateShipp=true;
                    console.log('ok 1')
                     if(this.shipping._id){
                         console.log('ok 2')
                         const data_shi = await this.$server.update("shippings", this.shipping);
                          const data_order = await this.$server.update("orders", dataToEdit);
                          this.loadingcreateShipp=false;
                        if (data_shi && data_shi._id) {
                            this.closePopUpInformation(index);
                            alert("Shipping and Order updated !", "success");                         
                        }else alert(data_shi, "warning");    
                     }else{  
                         console.log('dataToEdit shipping-----',dataToEdit)
                         console.log('shipping shipping-----',this.shipping)
                 
                         if(dataToEdit.checkWarehousingParent && dataToEdit.checkWarehousingParent.length>0 && !this.shipping.warehouseParent){
                            alert("Zone (City) required !", "warning");
                            this.loadingcreateShipp=false;
                            return false;
                         }

                        if(this.shipping.warehouseParent){
                            for (let index = 0; index < dataToEdit.details.length; index++) {
                                const expLineOrder = dataToEdit.details[index];
                                expLineOrder.warehouseParent = this.shipping.warehouseParent;
                                expLineOrder.warehouseParentName = this.shipping.warehouseParent.name;
                            }
                        }
                        if (this.checkDataShipping()) {
                            console.log('ok 4')
                            this.shipping.seller=dataToEdit.seller._id;
                            this.shipping.warehouse=dataToEdit.warehouse._id||dataToEdit.warehouse;
                            const checkDataShipp = await this.$server.get("orders", {id: this.shipping.order});
                            //console.log('checkDataShipp-----',checkDataShipp)
                            if(this.currentUser.type != 'Seller' && checkDataShipp.content.teleConsultant && (checkDataShipp.content.status.name == "Pending" || checkDataShipp.content.status.name == "Waiting")){
                                 alert("Shipping is already being processed in the call center !!", "warning");
                                 this.loadingcreateShipp=false;
                                  return false;
                            }
                            if(checkDataShipp.content.status.name == "Confirmed"){
                                 alert("Shipping already created for this order !!", "warning");
                                 this.loadingcreateShipp=false;
                                 await this.refresh();
                                  return false;
                            }
                            console.log('ok 5')
                           // this.shipping.details=checkDataShipp.content.details;
                            this.shipping.orderObjet=checkDataShipp.content;
                         
                            dataToEdit['shipping']=this.shipping;
                            dataToEdit.creatShipInAdmin=true;
                            dataToEdit.country=this.idWharhouse.country;
                            const data_order = await this.$server.update("orders", dataToEdit);
                            this.loadingcreateShipp=false;
                            console.log('ok 6 create')
                            if (data_order && data_order._id) {
                                console.log('ok 7')
                                 alert("Shipping created !", "success");
                                this.closePopUpInformation(index);
                            } else alert(data_order, "warning");
                        } else {
                            alert("you must fill all the fields !! ", "warning");
                        }
                    }  
                     this.loadingcreateShipp=false;
                }else{
                    if(this.config.name=="expeditions"){
                       // if(dataToEdit.arrivalDate == "Invalid date") dataToEdit.arrivalDate=null;

                    }
            
                    const data = await this.$server.update(this.config.name, dataToEdit);
                    this.loadingcreateShipp=false;
                     if (data && data._id) {
                        this.closePopUpInformation(index);
                        alert(this.config.title+" updated", "success");
                    }else alert(data, "warning");
                }
            },
            async closePopUpInformation(index) {
                let modal_id = "modal1_" + index;
                this.$vm2.close(modal_id);
                this.cleanUrl();
                await this.refresh();
                this.active_el="";
            },
            async OpenPopupNewShipp(name,action,type=null){
               if(!type){
                    await this.getCouriers();
                    await this.getZones();  
                    if(action=='open')  {
                        this.$vm2.open(name);
                        if(name!='newShipp') this.$vm2.close('newShipp');
                    }else {
                        this.newShipp.tabId=[];this.newShipp.shippings=[];this.searchTextShipp="";
                        this.$vm2.close(name);
                        if(name!='newShipp') this.$vm2.open('newShipp');
                    }
               } else{
                    if(action=='open')  {
                        this.$vm2.open(name);
                    }else{
                        this.$vm2.close(name);
                        this.newShipp.echange.data=null;
                    }
               }

            },
            async getZones() {
                const res = await this.$server.search("zones",{ limit: 40,warehouse:this.idWharhouse._id});
                if (res && res.content.results) this.zonesShipp = res.content.results;
                else this.zonesShipp = [];
            },
            serchZones: _.debounce(async function(name,type) {
                console.log('event______________',name)
                    await this.$store.dispatch('wharhouse/searchUser',{type: 'zone',warhouse:this.idWharhouse._id,search:name}).then((res) => {
                        this.zonesShipp = res
                    })
            }, 500), 
            async EmitActionNewShipp(name){
               if(name=='Echange'){
                 if(this.newShipp.echange.data){
                    if(this.newShipp.echange.data.order.details.length==1){
                        if(this.newShipp.echange.data.type=='echange'){
                            alert("Cette order est deja echangé !", "warning");
                            return false;
                        }
                        if(['received','paid', 'processed'].toString().indexOf(this.newShipp.echange.data.status) == -1){
                            alert("Seulement pour les shipping: (received ou paid ou processed') !", "warning");
                            return false;
                        }
                        const DetailsPr=this.newShipp.echange.data.order.details[0];
                        const data = {
                            _id:DetailsPr.product._id||DetailsPr.product,
                            actionInstock:{
                                status:this.newShipp.echange.data.status,
                                warehouse:this.idWharhouse,
                                stock:'inStock-total',
                                quantity:DetailsPr.quantity,
                                shipping:this.newShipp.echange.data._id,
                                operation:'Substraction',
                                reason:`Echange order (id: ${this.$f.getIdbySplit(this.newShipp.echange.data.order.id)})`,
                                echange:true
                            }
                        }  
                       
                    //  console.log('data_______________',data) 
                    this.$confirm(`You are sure to do this action`).then(async (action) => {
                        if (action) {
                            
                            try {
                                this.newShipp.loading=true;
                                const res = await this.$server.update("products", data);
                                console.log('res----------',res)
                                this.newShipp.loading=false;
                                if(res && res.resShipp) {
                                    this.OpenPopupNewShipp('Echange','close','Echange');
                                    alert("Product updated", "success"); 
                                    let routeData = this.$router.resolve({name: 'shippings', query: {name: res.resShipp.trackingNumber,warehouse:this.idWharhouse._id||this.idWharhouse}});
                                    this.newShipp.echange.data=null;
                                    window.open(routeData.href, '_blank');
                                }else alert(res, "warning");  
                            }catch (error) { 
                                console.log('error----------',error)
                                this.newShipp.loading=false;                        
                                alert(error, "warning");  
                            }
                           
                       }
                    });        
                        
                    }else alert("Tu peu pas faire un Echange, car cette order contient plusieur product !!", "warning");

                 }else  alert("Data order not found, please refresh page and try again !", "warning");
               } 
               if(name=='newZone')  {
                  if(this.newZone.name && this.newZone.country){
                       const data = await this.$server.create("zones", this.newZone);
                        if (data._id) {
                            this.newShipp.courier.zones.push(data._id);
                            this.newShipp.courier.updateIntable=true;
                            const datauser = await this.$server.update("users", this.newShipp.courier);
                             alert("zone created", "success");
                             await this.getZonesByCourier(datauser);
                             this.$vm2.close(name);this.$vm2.open('newShipp');
                        }
                  }else{
                       alert("You must fill all required field !", "warning");
                  }
               }if(name=='newCourier'){
                   this.newCourier.role=await this.getRoleByName('Courier');
                   //return false
                  if(this.newCourier.fullName && this.newCourier.email){
                       this.newCourier.email=this.newCourier.email.toLowerCase().trim();
                       //check if user exist
                        const checkUser = await this.$server.find("users",{name:this.newCourier.email});
                        console.log('checkUser',checkUser)
                         if(checkUser.content.length>0){
                            alert('Email already exist !', "warning");
                            return false;
                        }
                       const data = await this.$server.create("users", this.newCourier);
                        if (data.content._id) {
                              alert("Courier created !", "success");
                              await this.getCouriers();
                             this.$vm2.close(name);this.$vm2.open('newShipp');
                        }
                  }else{
                       alert("You must fill all required field !", "warning");
                  }
               }if(name=='newShipp'){
                   console.log('oooooooooooooooooook',this.newShipp)
                   if(this.newShipp.zone && this.newShipp.courier && this.newShipp.date){
                     this.newShipp.tabId=[];
                     //check count orders lié a ce livreur
                       const filtersC={
                            status:"countShipp",
                            date:this.newShipp.date,
                            courier:this.newShipp.courier._id||this.newShipp.courier,
                        };
                       this.newShipp.countShippCourier=0;
                       const resCount = await this.$server.search("shippings", filtersC);
                       console.log('oooooooooooooooooook')
                       if(resCount.content && resCount.content>=26){
                           this.newShipp.countShippCourier=resCount.content;
                           this.$vm2.open('alertCourier');
                       }else{
                            console.log('oooooooooooooooooook 11111')
                           this.$vm2.close(name); this.$vm2.open('newDataShipp');
                            document.getElementById('inputshipping').focus(); 
                       }                
                   }else{
                        alert("You must fill all required field !", "warning");
                   }                  
               }if(name=='alertCourier'){
                     this.$vm2.close(name); this.$vm2.open('newDataShipp');
                     document.getElementById('inputshipping').focus(); 
               }if(name=='newDataShipp'){
                   if(this.newShipp.tabId.length>0){
                        this.loadingdatashipp = true;
                        this.itemsShipp=0;
                        this.showprogress = true;
                        this.Datadone=true;
                        var itemsCounts=20;
                        var count = Math.ceil(this.newShipp.tabId.length/itemsCounts);
                        var close=false;
                        
                        for (var i = 0; i < count; i++) {
                            //await (async (i) => {
                                //setTimeout(async (s) => { 
                                        if(close) return;
                                        var s= this.newShipp.tabId.slice(i*itemsCounts,i*itemsCounts + itemsCounts)
                                        const data = {
                                            ids:s,
                                            status:'shipped',
                                            zone:this.newShipp.zone,
                                            courier:this.newShipp.courier,
                                            warehouse:this.idWharhouse,
                                            counry:this.idWharhouse.country
                                        }  
                                        console.time("update many shippings"); 
                                        const res = await this.$server.updateMany("shippings", data);
                                        console.timeEnd("update many shippings"); 
                                        //console.log(i,Date.now())
                                        if(res) this.itemsShipp+=s.length;
                                        else {
                                            console.log('problemoooooooo')
                                            this.Datadone=false;
                                            close=true  
                                        }
                                        if(this.itemsShipp == this.newShipp.tabId.length) {
                                            this.loadingdatashipp = false;
                                            this.showprogress = false;
                                            this.newShipp.shippings=[];
                                            this.zonesShipp=[];this.courier=[];
                                            this.newShipp.zone=null;
                                            this.newShipp.courier=null;
                                            this.newShipp.date=null;
                                            this.$vm2.close('newDataShipp');
                                            await this.refresh();
                                            if(res.length==0) alert("Shippings updated", "success");  
                                             else alert(res, "warning");  
                                            this.$vm2.close('newShipp');
                                            let columns = document.querySelectorAll('.checkallbboxShipp');
                                            columns.forEach(column => {column.checked = false});
                                        }
                                        if(close){
                                            this.loadingdatashipp = false;
                                        }
                                       // }, i * 1000);
                                //})(i);
                        }
                   }else alert("No shippings selected !", "warning");
               }
            },
           async OrderChange(index,order){
             let modal_id = "modal1_" + index;
             this.$vm2.close(modal_id);
              const DataShipp = await this.$server.get("shippings", {
                  order: order._id,
                  type:'normal'
                });
             if(DataShipp.content._id){     
               //  console.log('this___________________',DataShipp)   
               const nDate = new Date().toLocaleString('en-US', {timeZone: 'Africa/Abidjan'});
               let newdate=new Date(nDate);  
                    this.shippingChange.address= DataShipp.content.address;
                    this.shippingChange.order= order._id;
                    //this.shippingChange.details=order.details;
                    this.shippingChange.orderObjet=order;
                    this.shippingChange.courier= DataShipp.content.courier?DataShipp.content.courier._id:null;
                    this.shippingChange.zone= DataShipp.content.zone?DataShipp.content.zone._id:null;
                    this.shippingChange.seller= DataShipp.content.seller;
                    this.shippingChange.warehouse= DataShipp.content.warehouse;
                    this.shippingChange.date= newdate;
                   
                    this.$confirm("Are you sure to create shipping change for this order?").then(async (res) => {
                            if (res) {
                                const data_ship = await this.$server.create("shippings", this.shippingChange);
                                    if (data_ship._id) {
                                        this.$router.push('/shippings')
                                        alert("Shipping created !", "success");
                                    } 
                            }
                        });
             }else{
                  alert("No Shipping for this order !", "error");
                 }
            },
            async getCategories() {
                const res = await this.$server.search("categories");
                if (res.content) this.categories = res.content.results;
                else this.categories = [];
            },
            async getRoles() {
                const res = await this.$server.search("roles");
                if (res.content) this.roles = res.content.results;
                else this.roles = [];
            },
            async remove(id) {
                this.$confirm("Are you sure ?").then(async (res) => {
                    if (res) {
                        const data = await this.$server.delete(this.config.name, { _id: id });
                        if (data && data._id) {
                            alert(`${this.name} deleted !`, "success");
                            await this.refreshChild();
                        }else alert(data, "warning");
                    }
                });
            },
            async refreshChild() {
                await this.refresh();
            },
            getAccessLinks(action){
                const modelToCheck=this.config.name;
                const user=this.currentUser.type;
                if(modelToCheck=="shippings" && user=="Seller") return false
                if(modelToCheck=="shippings" && user=="Accountant" && (action=="print" || action=="printdDelivry")) return false
                if(modelToCheck=="products" && user=="Seller" && action=="addqte") return false
                if(modelToCheck=="payments" && user=="Seller" && action=="addPay") return false
                if(modelToCheck=="payments" && user=="Seller") return false
                return true;
            },
            getAccess(accessToCheck,status=null,OrderUnreachedata=null,type=null,role=null) {
                if(!this.currentUser.role) return false;
              
                const modelToCheck=this.config.name;
                const permissions = this.currentUser.role.permissions;
               // let productExist=false;
                 if(!role){        
                      return false;
                 }
                  
                 if((modelToCheck == "shippings" || modelToCheck == "payments") && accessToCheck=="print") return true;
                 if(modelToCheck == "orders" && accessToCheck === "double" && status && status.name && status.name==='Double') return true;
             
                for (let i in permissions) {
                    let model = permissions[i]["model"];
                    let access = permissions[i]["access"];
                    if (model == modelToCheck) {
                        
                         if(modelToCheck=="expeditions" && (accessToCheck=="update" || accessToCheck=="delete") && (status=="received" || status=="cancelled")){
                             if(this.currentUser.type=='Admin' || this.currentUser.type =='Administrateur'){
                                return true;
                             }else{ 
                                return false;
                             }
                         }
                        if((modelToCheck=="shippings" && type !== null  &&  this.currentUser.type=='Accountant'  &&  accessToCheck=="update" && type=='normal')){
                            return false;
                          }
                        if((modelToCheck=="shippings" && status !== null && this.currentUser.type=='Accountant') &&  accessToCheck=="update" && (status.name=="Processed" || status.name=="Waiting" || status.name=="Cancelled" || status.name=="Skipped" || status.name=="Pending" || status.name=="Unreached")){
                               return false;
                         }
                         if((modelToCheck=="orders" && status !== null && this.currentUser.type=='Seller') && (accessToCheck=="update" || accessToCheck=="delete")){
                            if(status.name=="Pending" || status.name=="Waiting"){
                                if(OrderUnreachedata && OrderUnreachedata.length>0) return false;
                                else return true;
                            }else return false;
                         } 
                        if((modelToCheck=="sourcings" && status !== null && this.currentUser.type=='Seller') && (accessToCheck=="update" || accessToCheck=="delete") && (status!=="pending")){
                            return false;
                        }

                        if(modelToCheck=="sourcings" && this.currentUser.type=='Sourcing' && (['delete','read'].includes(accessToCheck) || !['pending','priced'].includes(status))) return false;

                        if((modelToCheck=="shippings" && status !== null && this.currentUser.type=='Courier') &&  accessToCheck=="update" && (status=="received" || status=="cancelled")){
                               return false;
                         }
                         if(modelToCheck=="shippings" && status !== null && this.currentUser.type=='StockManager' && accessToCheck=="update"){
                            if(status!="cancelled") return true;
                            else return false;
                            
                         }
                        return access[accessToCheck];
                    }
                }
            },
            ShowConvertUserModal(index, subscriber) {
                let modal_id = "convertToUser_" + index;
                this.$refs[modal_id][0].showModal();
                if (
                    !(
                        !!this.newSeller.subscriber &&
                        this.newSeller.subscriber._id == subscriber._id
                    )
                ) {
                    this.newSeller = {
                        subscriber: subscriber,
                        fullName: subscriber.fullName,
                        phone: subscriber.phone,
                        email: subscriber.email,
                        type: "Seller",
                    };
                }
            },
            checkNewSellerData() {
                if (
                    this.newSeller.role &&
                    this.newSeller.username &&
                    this.newSeller.password &&
                    this.newSeller.email &&
                    this.newSeller.company &&
                    this.newSeller.type &&
                    this.newSeller.category
                )
                    return true;
                else return false;
            },
            checkDataShipping() {
                if (this.shipping.address && this.shipping.order && this.shipping.date)
                    return true;
                 else return false;
            },
            QuantityTotalProductOrder(data){
                var qte=0;
                for (let i in data.order.details) {
                    qte+=data.order.details[i].quantity;
                }
                return qte;
            },
            getTotalAmoutPayemnt(data){
                let total=0;
                for(let i in data){
                  total+=data[i].amount;
                }
                return total;
            },
            async generatePdf(id,content) {
              //  return false
                if(this.config.name!="payments"){
                      if(this.tabId.length==0){
                             alert(`No Shipping selected !`, "warning");
                            return false;
                        }
                  var printContents = "";
                  var style="";
                  if(this.tabId.length>1) style="height: 101%;border: 1px solid white;page-break-after: avoid; page-break-before: avoid;";
                  else style="height: 99%;border: 1px solid white;page-break-after: avoid; page-break-before: avoid;";
                   for(let i in this.tabId){
                     let modalPr_id = "Modalprint_" + this.tabId[i].id;
                     printContents +='<div class="container shipp-print" style="page-break-after: always; page-break-before: auto;">';
                     printContents += document.getElementById(modalPr_id).innerHTML;
                      printContents +="</div>";
                   }
                    
                         var mywindow = window.open('', 'PRINT', 'height=400,width=600');
                        mywindow.document.write('<html lang="en"><head><meta charset="utf-8"><title>DELIVRY NOTE</title>');
                            mywindow.document.write('<style type="text/css">' +
                            '@media print {' +
        '@page {size: auto; margin: 5mm;}' +
        '.container.shipp-print{page-break-after: always; page-break-inside: avoid;}' +
        '.container.shipp-print:last-child{page-break-after: auto;}' +
          '.mr-5{margin-right:4mm}' +
          '.barcode-img img{width: 200px;}' +
          'p{margin:0}' +
          'table{border-collapse: collapse;}' +
          'table th, table td {border:1px solid #000;}' +
          '.text-right{text-align:right}' +
          '.flex-1{flex:1 1 0%}' +
          '.w-40{width:10rem}' +
          '.font-medium{font-weight:500}' +
          '.py-1{padding-top:.25rem;padding-bottom:.25rem}' +
          '.inline-block{display:inline-block}' +
          '.mb-3{margin-bottom:.25rem}' +
          '.py-2{padding-top:.5rem;padding-bottom:.5rem}' +
          '.ml-auto{margin-left:auto}' +
          '.border-black{border: 1px solid black;}' +
          '.border{border-width:1px}' +
          '.whitespace-no-wrap{white-space:nowrap}' +
          '.text-center{text-align:center}' +
          '.w-1/4{width: 25%}' +
          '.text-left{text-align:left}' +
          '.px-2{padding-left:.5rem;padding-right:.5rem}' +
          '.min-w-full{min-width:100%}' +
          '.mb-5{margin-bottom:1.25rem}' +
          '.px-1{padding-left:.25rem;padding-right:.25rem}' +
          '.mx-auto{margin-left:auto;margin-right:auto}' +
          'body{font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;font-size:1em}' +
          '.justify-between{justify-content:space-between}' +
          '.w-full{width:100%}' +
          '.block{display:block}' +
          '.flex{display:flex}' +
          '.uppercase{text-transform: uppercase;}' +
          '.mb-2{margin-bottom: 0.5rem;}' +
          '.mb-3{margin-bottom: 0.75rem;}' +
          '.font-bold{font-weight: 700;}' +
          '.font-semibold{font-weight:600}' +
          '.text-xl{font-size: 1.25rem;line-height: 1.75rem;}' +
          '.size-m{font-size: 12px;font-weight: 500;}' +
          // ✅ Styles مهمين للـ QR Code SVG
          '.flex{display:flex;}' +
          '.justify-center{justify-content:center;}' +
          '.items-center{align-items:center;}' +
          'svg{display:block;max-width:100%;height:auto;}' +
          // ✅ Print-specific styles
          '@media print {' +
          '@page {size: auto; margin: 0mm;}' +
          'body{margin:2mm;}' +
          'svg{page-break-inside:avoid;-webkit-print-color-adjust:exact;print-color-adjust:exact;}' +
          '.barcode-img{display:flex;justify-content:space-between;align-items:center;}' +
        '.barcode-img svg{display:block;max-width:70px;height:auto;}' +
        '.ml-4{margin-left:1rem}' +
        '.mt-1{margin-top:0.25rem}' +
        '.mt-2{margin-top:0.5rem}' +
        '.flex-col{flex-direction:column}' +
        '.inline-flex{display:inline-flex}' +
          '}' +
          '</style>');
                        mywindow.document.write('</head><body style="margin:2mm;">');
                        mywindow.document.write(printContents);
                        mywindow.document.write('</body></html>');
                        mywindow.document.close(); // necessary for IE >= 10
                        mywindow.focus(); // necessary for IE >= 10*/

                        setTimeout(function () {
                            mywindow.print();
                            mywindow.close();
                        }, 500);
                        return false; 
                    }else{
                        if(this.tabId.length==0){
                             alert(`No payement selected !`, "warning");
                            return false;
                        }
                        const doc = new jsPDF('p', 'pt');
                        const fontSizes = {
                            TitleFontSize:14,
                            SubTitleFontSize:12,
                            NormalFontSize:10,
                            SmallFontSize:9
                        };
                        const lineSpacing = 12;
                        let items;
                        let expeditions;
                        for(let k in this.tabId){
                                const filter = {
                                    _id: this.tabId[k]
                                }
                            const  res = await this.$server.search("payments", filter);
                            if (res.content.results) {
                                 items=res.content.results[0].details;
                                 expeditions=res.content.results[0].expeditions;
                             }
                        
                        let expeditionsCount=0;
                        //let expeditions=content.expeditions;
                        for(let i in expeditions){
                            expeditionsCount++;
                        }
                        let data=[]; let dataExp=[];
                        let i = 1;
                        items.forEach(el =>{let obj = [
                            i,
                            this.$f.getIdbySplit(el.order.id),  
                            el.order.customer.fullName,
                            el.order.totalPrice,
                            el.confirmation_vat,
                            el.shipping_vat,
                            el.shipping_refund_vat,
                            el.shipping_change_vat,
                            el.amount,
                        ];
                        i++;
                        data.push(obj);

                        
                        });
                        doc.autoTable({ 
                        headerStyles: {fillColor: [0, 0, 0]},
                        theme: 'grid',
                        head: [['#', 'ID', 'Customer','Total price','Confirmation Fees','Shipping Fees','Refund Fees','Change Fees','Total']],
                        margin: { top: 150 },
                        body: data,
                        })
                        //Expedition fees
                        if(expeditionsCount>0){
                        doc.setFont('normal');
                        doc.setFontSize(fontSizes.SubTitleFontSize);
                        doc.text('Expeditions: ', 40,doc.autoTable.previous.finalY+15);
                        let j = 1;
                        expeditions.forEach(el =>{let obj = [
                            j,
                            el.id.weight,  
                            el.id.transportMode,
                            el.id.details.length+' Products',
                            el.id.carrier.name,
                            el.id.country,
                            el.fees,
                        ];
                        j++;
                        dataExp.push(obj);
                        });
                        doc.autoTable({ 
                    // headerStyles: {fillColor: [0, 0, 0]},
                        theme: 'striped',
                        head: [['#', 'Weight (Kg)', 'Transport mode','Details','Carrier','Country','Expedition fees']],
                        margin: { top: doc.autoTable.previous.finalY+30 },
                        body: dataExp,
                        })
                        }
                        let startX = 40;
                        const pageWidth = doc.internal.pageSize.width;
                        const endX =  pageWidth - startX;
                        doc.setFont("arial")
                        doc.setFontSize(fontSizes.SubTitleFontSize);

                        // set fix value for Y to bring title in alignment with folding marks
                        let startY = 50;
                        doc.text('Payement NO: ', startX, startY);

                        doc.setFont("bold");

                        startX += doc.getStringUnitWidth('Payement NO: ') * fontSizes.SubTitleFontSize;
                        doc.text(res.content.results[0].id, startX, startY);

                        doc.setFont('normal');
                        doc.text(this.$moment(res.content.results[0].date).format('yyyy-MM-DD'), endX, startY, 'right');
                        startY = 33;
                        startY += lineSpacing * 2;
                        startX = 40;
                        doc.text('Seller: '+res.content.results[0].seller.email, startX, startY += lineSpacing + 2);
                        doc.text('Payement methode: '+res.content.results[0].method, startX, startY += lineSpacing * 2);

                        //total amount orders
                        startY += lineSpacing * 2;
                        doc.text('Total: '+this.getTotalAmoutPayemnt(res.content.results[0].details), endX, doc.autoTable.previous.finalY+20, 'right');
                        doc.text('TVA: '+res.content.results[0].vat+" %", endX, doc.autoTable.previous.finalY+40, 'right');
                        doc.text('Transfert fees: '+res.content.results[0].transfert_fees, endX, doc.autoTable.previous.finalY+60, 'right');
                        doc.text('Grand total: '+res.content.results[0].amount, endX, doc.autoTable.previous.finalY+80, 'right');
                        doc.setLineWidth(0.5);
                        startY += 4;
                        doc.line(startX - 1, startY, endX + 1, startY);
                        startY += 2;
                        doc.line(startX -2 , startY, endX + 2, startY);
                        startY += 20;
                        doc.text('Orders: ', startX, startY);
                       // doc.line(450 , doc.autoTable.previous.finalY+30, endX + 2, doc.autoTable.previous.finalY+30);
                        doc.addPage();
                    }
                    //delte black page
                      var pageCount = doc.internal.getNumberOfPages();
                      doc.deletePage(pageCount)
                        doc.save('Payement.pdf')

                    }              
            }
            },
    };
</script>

<!--  ************  -->
<style scoped>

.productsnotused .my-12{
    margin-top: 0rem;
    margin-bottom: 0rem;
}
.max-300{
    max-height: 300px;
}
.animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
    50% {
        opacity: .2;
    }
 }
.parent-warehouse{
    border-left: 1px solid #000;
    padding-left: 20px;
    position: relative;
    margin-left: 18px;
    line-height: 24px;
}
.primary-warehouse::before{
    height: 1px;
    background: #000;
    width: 15px;
    left: 0;
    top: 11px;
    display: inline-block;
    content: "";
    position: absolute;
}
.header-table.th-header{
  background-color: #d4ebff;
}
.header-1 .content.content-2{
  height: inherit !important;
  }
.header-table .first{
  padding-left: 5px;
}

.quant-1{
  margin: 0 !important;
}
.statusP{
    border-radius: 10px;
    padding: 4px 6px;
    font-size: 13px;
}
.statusP.status-inactive{
     color: white;
   background-color: #e52f0e;
}
.statusP.status-active{
     color: #57585a;
    background-color: #0aca6e;
}
.box-flexx{
    display: -webkit-box;
    -webkit-box-pack: center;
    -webkit-box-align: center;
}
table>thead>tr:first-child th:last-child {
    border-top-right-radius: 4px;
}
.ware-name{
    color: #fff;
    background-color: #00b8d9;
    border-color: #00b8d9;
    box-shadow: 0 5px 10px rgb(0 184 217 / 30%);
}
.ant-table-cell-fix-right {
    position: -webkit-sticky!important;
    position: sticky!important;
    z-index: 2;
    background: #fff;
}
.ant-table-thead > tr > th{
 background: rgb(203 213 224);
}
.ant-table-cell-fix-right-first:after, .ant-table-cell-fix-right-last:after {
    position: absolute;
    top: 0;
    bottom: -1px;
    left: 0;
    width: 30px;
    transform: translateX(-100%);
    transition: box-shadow .3s;
    content: "";
    pointer-events: none;
    box-shadow: inset -10px 0 8px -8px rgb(0 0 0 / 15%);
}
.modal-footer-ex {
    overflow: auto;
    position: absolute;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    box-shadow: 0 -4px 1px -4px rgb(0 0 0 / 10%);
    border-top: 1px solid #ededed;
    padding-top: 15px;
    padding-bottom: 15px;
 }
 
 .leading-normal th:last-child{
    text-align: center;
}
/* .k-progress-text {
    margin-left: 10px;
    display: inline-block;
    vertical-align: middle;
    text-align: right;
    word-break: keep-all;
    width: 15%;
}
.k-progress, .k-progress-outer {
    box-sizing: border-box;
}
.k-progress {
    color: #606266;
    font-size: 14px;
    display: flex;
    align-items: center;
}
.k-progress-outer {
    width: 100%;
    display: inline-block;
    vertical-align: middle;
    margin-right: -55px;
    padding-right: 50px;
}
.k-progress-outer-bg-border {
    border-radius: 100px;
}
.k-progress-outer-bg {
    width: 100%;
    position: relative;
}
.k-progress-outer-line {
    position: relative;
    height: 6px;
    margin-top: -6px;
    background: rgba(0, 0, 0, 0) linear-gradient(to right, rgb(245, 175, 25), rgb(241, 39, 17), rgb(146, 84, 222), rgb(64, 169, 255), rgb(92, 219, 211)) repeat scroll 0% 0%;
    border-radius: 100px;
    transition: all .4s cubic-bezier(.08,.82,.17,1) 0s;
}
.k-progress-outer-line-active {
    background: #fff;
    height: inherit;
    border-radius: 10px;
    opacity: 0;
    -webkit-animation: kp-active 2.4s cubic-bezier(0,0,.2,1) infinite;
    animation: kp-active 2.4s cubic-bezier(0,0,.2,1) infinite;
    content: "";
} */
@-webkit-keyframes kp-active {
 0% {
  width:0;
  opacity:.2
 }
 30% {
  width:0;
  opacity:.6
 }
 to {
  width:100%;
  opacity:0
 }
}
@keyframes kp-active {
 0% {
  width:0;
  opacity:.2
 }
 30% {
  width:0;
  opacity:.6
 }
 to {
  width:100%;
  opacity:0
 }
}
.icon-acount{
    vertical-align: middle;
    margin-bottom: 10px;
}
.change-status .vs__dropdown-menu{
   max-height:100px
}
.w-56 {
  width:14rem
 }
 .bg-ww {
    border: 2px solid #77d7c8;
    background-color: #f5f5f5;
    padding: 15px;
    max-height: 270px;
    overflow-y: auto;
}
.check-left {
    position: absolute;
    top: 5px;
    left: 5px;
}
.intro-y.active {
    border: 2px solid rgba(103,240,114,.9);
    background: rgba(103,240,114,.1);
}
.active .check-left {
    display: block;
}
.zoom-in {
    cursor: pointer;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transition-property: background-color,border-color,color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;
    transition-property: background-color,border-color,color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;
    transition-property: background-color,border-color,color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;
    transition-duration: .15s;
    transition-timing-function: cubic-bezier(.4,0,.2,1);
    transition-duration: .3s;
}
.zoom-in:hover {
 --tw-shadow:0 20px 25px -5px rgba(0,0,0,0.1),0 10px 10px -5px rgba(0,0,0,0.04);
 box-shadow:0 3px 20px rgba(0,0,0,.043137254901960784);
 --tw-scale-x:1.05;
 --tw-scale-y:1.05
}
.warehouse .zoom-in:hover {
    margin-left: 8px;
    margin-right: 8px;
}
.intro-y {
    position: relative;
    transform: translateY(50px);
    -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
    animation: intro-y-animation .4s ease-in-out .33333s;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    -webkit-animation-delay: .2s;
    animation-delay: .2s;
}
.box-1 {
    background: #f2f4f7;
    border: 2px solid #77d8c8;
    border-radius: 0.375rem;
}
.feather-icon {
    display: inline-flex;
    align-items: center;
}
.animate-show-tab{
    transform: translateY(50px);
    -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
    animation: intro-y-animation .4s ease-in-out .33333s;
        animation-delay: 0.33333s;
        animation-fill-mode: none;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    -webkit-animation-delay: .1s;
    animation-delay: .1s;
}
@-webkit-keyframes intro-y-animation {
 to {
  opacity:1;
  transform:translateY(0)
 }
}


.barcode-img img{
    width:100px !important
}
.dropdown-limit{
    border: 1px solid rgba(0,0,0,.1);
    position: relative;
}
.vs-dropdown--limit--after {
    top: 0;
    right: 10px;
    position: absolute;
    width: 10px;
    height: 10px;
    display: block;
    background: #fff;
    transform: rotate( 
45deg
 ) translate(-7px);
    border-top: 1px solid rgba(0,0,0,.1);
    border-left: 1px solid rgba(0,0,0,.1);
    z-index: 10;
    box-sizing: border-box;
}
.prova:after {
  content: attr(data-ribbon);
  position: absolute;
  width: 90px;
  height: 40px;
  background: #428bca;
  color: white;
  top: -5px;
  text-align: center ;
  line-height: 50px;
  right: -34px;
  transform: rotate(45deg);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.toggle__dot {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}

.vs__dropdown-toggle {
    border: none !important;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #63b3ed;
}
.empty-row{
   background: repeating-linear-gradient( 53deg , #bfc0c2 4%, #fcfcff 11px 6%, #ffffff 10px 7%, #9d9c9c 15px);
}
.dropdown-action{
    width: 30%  !important;
}
.border-teal {
    border-color: #4dc0b5;
}
.bg-teal-lightest {
    background-color: #e8fffe;
}
    .text-red {
        color: #e3342f;
    }
    .table-shipp,.table-shipp  thead{
        border: 2px solid #2c84c7;
    }
    .vs__dropdown-toggle {
    border: none;
    }    
    .bg-light-blue-200 {
    --tw-bg-opacity: 1;
    background-color: rgba(186,230,253,var(--tw-bg-opacity));
    border-bottom: 1px solid #fff;
    }
    #loading{
        position: relative;
    }
    dialog[open] {
        animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
    }
    dialog::backdrop {
        background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
        backdrop-filter: blur(3px);
    }
    @keyframes appear {
        from {
            opacity: 0;
            transform: translateX(-3rem);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }
</style>
